(function () {
  const root = window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/';
  const routes = window.routes || {
    cart_url: `${root}cart`,
    cart_add_url: `${root}cart/add.js`,
    cart_change_url: `${root}cart/change.js`,
    cart_update_url: `${root}cart/update.js`,
  };
  const cartAddAjaxUrl = `${root}cart/add.js`;
  const cartUpdateAjaxUrl = `${root}cart/update.js`;

  function getCartAddAjaxUrl() {
    const url = routes.cart_add_url || cartAddAjaxUrl;
    return /\.js(?:\?|$)/.test(url) ? url : cartAddAjaxUrl;
  }

  function getCartUpdateAjaxUrl() {
    const url = routes.cart_update_url || cartUpdateAjaxUrl;
    return /\.js(?:\?|$)/.test(url) ? url : cartUpdateAjaxUrl;
  }

  function money(cents) {
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      return window.Shopify.formatMoney(cents);
    }
    return new Intl.NumberFormat('en-AU', { style: 'currency', currency: 'AUD' }).format(cents / 100);
  }

  function parseJsonScript(id) {
    const el = document.getElementById(id);
    if (!el) return {};
    try {
      return JSON.parse(el.textContent);
    } catch (error) {
      console.warn('Cart settings could not be parsed.', error);
      return {};
    }
  }

  const settings = parseJsonScript('CityCartSettings');

  const cartEditStorageKey = 'cityCartEditLine';
  const cartEditTokenStorageKey = 'cityCartEditToken';

  function getCartEditKey() {
    try {
      return new URLSearchParams(window.location.search).get('cart_edit_key') || '';
    } catch (error) {
      return '';
    }
  }

  function storeCartEditPayload(payload) {
    try {
      window.sessionStorage.setItem(cartEditStorageKey, JSON.stringify(payload));
    } catch (error) {
      console.warn('Cart edit state could not be stored.', error);
    }
  }

  function storeLensReplacementCartEditPayload(payload) {
    try {
      window.sessionStorage.setItem('cityLensReplacementCartEditPayload', JSON.stringify(payload || {}));
    } catch (error) {
      console.warn('Lens replacement edit state could not be stored.', error);
    }
  }

  function openLensReplacementDrawerEditor(payload, trigger) {
    if (!payload || !payload.key) return false;
    const nativeEditor = window.CityLensReplacementMultiFrame;
    if (!nativeEditor || typeof nativeEditor.openCartLine !== 'function') return false;
    try {
      return nativeEditor.openCartLine(payload, trigger) !== false;
    } catch (error) {
      console.warn('Native lens replacement cart editor could not be opened.', error);
      return false;
    }
  }

  function openLensReplacementDrawerAdd(payload, trigger) {
    if (!payload || !payload.key) return false;
    const nativeEditor = window.CityLensReplacementMultiFrame;
    if (!nativeEditor || typeof nativeEditor.openCartAdd !== 'function') return false;
    try {
      return nativeEditor.openCartAdd(payload, trigger) !== false;
    } catch (error) {
      console.warn('Native add-frame editor could not be opened.', error);
      return false;
    }
  }

  function getCartEditPayload() {
    const editKey = getCartEditKey();
    if (!editKey) return null;

    try {
      const payload = JSON.parse(window.sessionStorage.getItem(cartEditStorageKey) || 'null');
      if (!payload || payload.key !== editKey) return { key: editKey, properties: {}, quantity: 1 };
      return payload;
    } catch (error) {
      return { key: editKey, properties: {}, quantity: 1 };
    }
  }

  function clearCartEditState() {
    try {
      window.sessionStorage.removeItem(cartEditStorageKey);
      window.sessionStorage.removeItem(cartEditTokenStorageKey);
    } catch (error) {
      console.warn('Cart edit state could not be cleared.', error);
    }

    if (!getCartEditKey() || !window.history || !window.history.replaceState) return;

    const url = new URL(window.location.href);
    url.searchParams.delete('cart_edit');
    url.searchParams.delete('cart_edit_key');
    window.history.replaceState({}, '', `${url.pathname}${url.search}${url.hash}`);
  }

  function getCartSections(cart) {
    if (cart && typeof cart.getSectionsToRender === 'function') {
      return cart.getSectionsToRender().map((section) => section.id);
    }
    return ['cart-drawer', 'cart-icon-bubble'];
  }

  function getCartEditToken() {
    if (!getCartEditKey()) return '';

    try {
      let token = window.sessionStorage.getItem(cartEditTokenStorageKey);
      if (!token) {
        token = `edit-${Date.now()}-${Math.random().toString(36).slice(2)}`;
        window.sessionStorage.setItem(cartEditTokenStorageKey, token);
      }
      return token;
    } catch (error) {
      return `edit-${Date.now()}`;
    }
  }

  function fetchCartState(signal) {
    return fetch(`${root}cart.js?_=${Date.now()}`, {
      cache: 'no-store',
      credentials: 'same-origin',
      headers: { Accept: 'application/json' },
      signal,
    }).then((response) => {
      if (!response.ok) throw new Error('Cart state could not be read.');
      return response.json();
    });
  }

  function getCartItemProperty(item, propertyName) {
    if (!item || !item.properties) return '';
    if (!Array.isArray(item.properties)) return item.properties[propertyName] || '';

    const match = item.properties.find((property) => {
      if (Array.isArray(property)) return property[0] === propertyName;
      return property && property.name === propertyName;
    });
    if (!match) return '';
    return Array.isArray(match) ? match[1] : match.value;
  }

  function isCustomPolarisedAddonItem(item) {
    const handle = String((item && (item.handle || item.product_handle)) || '').toLowerCase();
    const title = String((item && (item.product_title || item.title)) || '').toLowerCase();
    const variantId = Number((item && (item.variant_id || item.id)) || 0);

    return (
      getCartItemProperty(item, '_city_custom_polarised_add_on') === 'true' ||
      handle === 'custom-polarised-upgrade-add-on' ||
      title.includes('custom polarised upgrade add-on') ||
      variantId === 52896594428213 ||
      variantId === 52896594460981
    );
  }

  function isCustomPolarisedParentItem(item) {
    const lensOption = String(getCartItemProperty(item, 'Lens Option') || '').toLowerCase();
    return getCartItemProperty(item, '_city_custom_polarised_parent') === 'true' || lensOption === 'custom polarised upgrade';
  }

  function propertyIsTrue(value) {
    if (value === true) return true;
    return ['true', '1', 'yes'].includes(String(value || '').trim().toLowerCase());
  }

  function isLensReplacementItem(item) {
    const handle = String((item && (item.handle || item.product_handle)) || '').toLowerCase();
    const productType = String((item && (item.product_type || item.type)) || '').toLowerCase();
    const productTitle = String((item && item.product_title) || '').toLowerCase();
    const title = String((item && item.title) || '').toLowerCase();

    return (
      propertyIsTrue(getCartItemProperty(item, '_is_lens_replacement')) ||
      productType === 'lens replacement service' ||
      handle === 'lens-replacement-single-vision' ||
      handle === 'lens-replacement-multifocal' ||
      productTitle === 'lens replacement - single vision' ||
      productTitle === 'lens replacement - multifocal' ||
      title.startsWith('lens replacement - single vision') ||
      title.startsWith('lens replacement - multifocal')
    );
  }

  function isTransitProtectionItem(item) {
    const handle = String((item && (item.handle || item.product_handle)) || '').toLowerCase();
    const productTitle = String((item && item.product_title) || '').toLowerCase();
    const title = String((item && item.title) || '').toLowerCase();
    const variantId = Number((item && (item.variant_id || item.id)) || 0);

    return (
      propertyIsTrue(getCartItemProperty(item, '_applies_to_lens_replacement')) ||
      handle === 'transit-protection' ||
      handle === 'transit-protection-1000-preview' ||
      handle === 'transit-protection-coverage' ||
      productTitle === 'transit protection' ||
      title === 'transit protection' ||
      variantId === 52942403666229 ||
      variantId === 53522739069237 ||
      [53526902702389, 53526902735157, 53526902767925].includes(variantId)
    );
  }

  function getLensReplacementQuantity(cartState) {
    const items = Array.isArray(cartState && cartState.items) ? cartState.items : [];
    return items.reduce((quantity, item) => {
      if (!isLensReplacementItem(item)) return quantity;
      return quantity + Math.max(Number(item.quantity || 0), 0);
    }, 0);
  }

  function getTransitProtectionItems(cartState) {
    const items = Array.isArray(cartState && cartState.items) ? cartState.items : [];
    return items.filter(isTransitProtectionItem);
  }

  function getTransitProtectionCoverageLimit(item) {
    const handle = String((item && (item.handle || item.product_handle)) || '').toLowerCase();
    const variantId = Number((item && (item.variant_id || item.id)) || 0);
    if (variantId === 53526902767925) return '$1,500';
    if (handle === 'transit-protection-1000-preview' || variantId === 53522739069237 || variantId === 53526902735157) return '$1,000';
    return '$500';
  }

  function getTransitProtectionCoverageCopy(item) {
    return `Up to ${getTransitProtectionCoverageLimit(item)} total cover`;
  }

  function getTransitProtectionProperties(item) {
    return {
      Coverage: getTransitProtectionCoverageCopy(item),
    };
  }

  function transitProtectionPropertiesNeedSync(item) {
    const expected = getTransitProtectionProperties(item);
    return Object.keys(expected).some((key) => String(getCartItemProperty(item, key) || '') !== expected[key]);
  }

  function updateTransitProtectionLine(item, quantity) {
    if (!item || !item.key) return Promise.resolve(false);

    return fetch(routes.cart_change_url, {
      method: 'POST',
      cache: 'no-store',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
      },
      body: JSON.stringify({
        id: item.key,
        quantity,
        properties: getTransitProtectionProperties(item),
      }),
    })
      .then((response) => response.json())
      .then((response) => {
        if (response.status) throw new Error(response.description || response.message || 'Unable to update Transit Protection');
        return true;
      });
  }

  function removeTransitProtectionLines(items) {
    const updates = {};
    (items || []).forEach((item) => {
      if (item && item.key) updates[item.key] = 0;
    });

    if (!Object.keys(updates).length) return Promise.resolve(false);

    return fetch(routes.cart_update_url, {
      method: 'POST',
      cache: 'no-store',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
      },
      body: JSON.stringify({ updates }),
    })
      .then((response) => response.json())
      .then((response) => {
        if (response.status) throw new Error(response.description || response.message || 'Unable to remove Transit Protection');
        return true;
      });
  }

  let transitProtectionSyncPromise = null;

  function syncTransitProtectionQuantity(cartState, options = {}) {
    if (transitProtectionSyncPromise) return transitProtectionSyncPromise;

    const lensReplacementQuantity = getLensReplacementQuantity(cartState);
    const transitItems = getTransitProtectionItems(cartState);
    if (!transitItems.length) return Promise.resolve(false);

    const primaryItem = transitItems[0];
    const duplicateItems = transitItems.slice(1);
    const needsRemoval = lensReplacementQuantity <= 0;
    const needsQuantityUpdate = !needsRemoval && Number(primaryItem.quantity || 0) !== 1;
    const needsPropertyUpdate = !needsRemoval && transitProtectionPropertiesNeedSync(primaryItem);
    if (!needsRemoval && !needsQuantityUpdate && !needsPropertyUpdate && !duplicateItems.length) {
      return Promise.resolve(false);
    }

    transitProtectionSyncPromise = Promise.resolve()
      .then(() => {
        if (needsRemoval) return removeTransitProtectionLines(transitItems);
        return updateTransitProtectionLine(primaryItem, 1)
          .then((changed) => {
            if (!duplicateItems.length) return changed;
            return removeTransitProtectionLines(duplicateItems).then(() => true);
          });
      })
      .then((changed) => {
        if (changed && options.refresh !== false) {
          return refreshCartDrawer(options.openAfterRefresh === true, 0).then(() => true);
        }
        return changed;
      })
      .catch((error) => {
        console.warn('Transit Protection sync failed.', error);
        return false;
      })
      .finally(() => {
        transitProtectionSyncPromise = null;
      });

    return transitProtectionSyncPromise;
  }

  function syncTransitProtectionBeforeCartRender(cartState, sections = ['cart-drawer', 'cart-icon-bubble'], sectionsUrl = window.location.pathname) {
    const lensReplacementQuantity = getLensReplacementQuantity(cartState);
    const transitItems = getTransitProtectionItems(cartState);
    if (!transitItems.length) return Promise.resolve(cartState);

    const primaryItem = transitItems[0];
    const needsRemoval = lensReplacementQuantity <= 0;
    const needsQuantityUpdate = !needsRemoval && Number(primaryItem.quantity || 0) !== 1;
    const needsPropertyUpdate = !needsRemoval && transitProtectionPropertiesNeedSync(primaryItem);
    if (!needsRemoval && !needsQuantityUpdate && !needsPropertyUpdate) return Promise.resolve(cartState);

    const requestBody = needsRemoval
      ? {
          updates: transitItems.reduce((updates, item) => {
            if (item && item.key) updates[item.key] = 0;
            return updates;
          }, {}),
          sections,
          sections_url: sectionsUrl,
        }
      : {
          id: primaryItem.key,
          quantity: 1,
          properties: getTransitProtectionProperties(primaryItem),
          sections,
          sections_url: sectionsUrl,
        };

    return fetch(needsRemoval ? routes.cart_update_url : routes.cart_change_url, {
      method: 'POST',
      cache: 'no-store',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
      },
      body: JSON.stringify(requestBody),
    })
      .then((response) => response.json())
      .then((response) => {
        if (response.status) throw new Error(response.description || response.message || 'Unable to sync Transit Protection');
        return response;
      });
  }

  function scheduleTransitProtectionSync(delay = 450, options = {}) {
    window.setTimeout(() => {
      fetchCartState()
        .then((cartState) => syncTransitProtectionQuantity(cartState, options))
        .catch(() => null);
    }, delay);
  }

  function getVisibleCartItemCount(cartState) {
    const items = Array.isArray(cartState && cartState.items) ? cartState.items : [];
    if (!items.length) return Number((cartState && cartState.item_count) || 0);

    return items.reduce((count, item) => {
      const rxGroup = getCartItemProperty(item, '_city_rx_sunglasses_group');
      if (rxGroup) {
        const groupItems = items.filter((candidate) => getCartItemProperty(candidate, '_city_rx_sunglasses_group') === rxGroup);
        const parentCount = groupItems.filter((candidate) => propertyIsTrue(getCartItemProperty(candidate, '_city_rx_sunglasses_parent'))).length;
        const serviceCount = groupItems.filter((candidate) => propertyIsTrue(getCartItemProperty(candidate, '_city_rx_sunglasses_service'))).length;
        if (parentCount === 1 && serviceCount === 1) {
          return propertyIsTrue(getCartItemProperty(item, '_city_rx_sunglasses_parent')) ? count + 1 : count;
        }
        return count + Number(item.quantity || 0);
      }
      let isPairedCustomPolarisedAddon = false;

      if (isCustomPolarisedAddonItem(item)) {
        const group = getCartItemProperty(item, '_city_custom_polarised_group');
        const tint = getCartItemProperty(item, 'Custom polarised lens colour');

        isPairedCustomPolarisedAddon = items.some((parentItem) => {
          if (!isCustomPolarisedParentItem(parentItem)) return false;

          const parentGroup = getCartItemProperty(parentItem, '_city_custom_polarised_group');
          const parentTint = getCartItemProperty(parentItem, 'Custom polarised lens colour');
          if (group && parentGroup === group) return true;
          return tint && parentTint === tint && Number(parentItem.quantity || 0) === Number(item.quantity || 0);
        });
      }

      return isPairedCustomPolarisedAddon ? count : count + Number(item.quantity || 0);
    }, 0);
  }

  function syncCartEmptyState(cartState) {
    if (!cartState) return;

    const hasItems = getVisibleCartItemCount(cartState) > 0;
    const drawer = document.querySelector('cart-drawer');
    const drawerItems = document.querySelector('cart-drawer-items');
    const drawerInner = document.querySelector('cart-drawer .drawer__inner');

    if (drawer) drawer.classList.toggle('is-empty', !hasItems);
    if (drawerItems) drawerItems.classList.toggle('is-empty', !hasItems);
    if (drawerInner) drawerInner.classList.remove('is-empty');
  }

  function setRevitalensPromptAdded(prompt) {
    if (!prompt) return;
    const button = prompt.querySelector('[data-city-upsell-button]');
    if (!button) return;
    button.textContent = 'Added';
    button.disabled = true;
  }

  function setRevitalensPromptAvailable(prompt) {
    if (!prompt) return;
    const button = prompt.querySelector('[data-city-upsell-button]');
    const upsellForm = prompt.querySelector('[data-city-upsell-form]');
    if (!button || (upsellForm && upsellForm.dataset.cityUpsellAdding === 'true')) return;
    button.textContent = 'Add +';
    button.disabled = false;
  }

  function syncRevitalensPrompts(cartState) {
    const prompts = document.querySelectorAll('[data-city-revitalens-prompt][data-city-upsell-variant-id]');
    if (!prompts.length || !cartState || !Array.isArray(cartState.items)) return;

    prompts.forEach((prompt) => {
      const variantId = Number(prompt.dataset.cityUpsellVariantId || 0);
      if (!variantId) return;
      const isInCart = cartState.items.some((item) => Number(item.variant_id || 0) === variantId);
      if (isInCart) {
        setRevitalensPromptAdded(prompt);
      } else {
        setRevitalensPromptAvailable(prompt);
      }
    });
  }

  function waitForCartItems(minItemCount = 1, attempt = 0) {
    return fetchCartState().then((cartState) => {
      syncCartEmptyState(cartState);
      if (getVisibleCartItemCount(cartState) >= minItemCount || attempt >= 8) return cartState;

      return new Promise((resolve) => {
        setTimeout(resolve, 180);
      }).then(() => waitForCartItems(minItemCount, attempt + 1));
    });
  }

  function drawerHasRenderedItems() {
    return Boolean(document.querySelector('#CartDrawer .cart-item'));
  }

  function openDrawerIfNeeded(openAfterRefresh = false) {
    if (!openAfterRefresh) return;

    const drawer = document.querySelector('cart-drawer');
    if (!drawer || typeof drawer.open !== 'function' || drawer.classList.contains('active')) return;

    setTimeout(() => drawer.open());
  }

  function applyMainCartDocument(html) {
    if (!document.querySelector('#main-cart-items')) return;
    const incomingItems = html.querySelector('#main-cart-items .js-contents');
    const currentItems = document.querySelector('#main-cart-items .js-contents');
    const incomingFooter = html.querySelector('#main-cart-footer');
    const currentFooter = document.querySelector('#main-cart-footer');
    if (incomingItems && currentItems) currentItems.innerHTML = incomingItems.innerHTML;
    if (incomingFooter && currentFooter) {
      const incomingTotals = incomingFooter.querySelector('.js-contents');
      const currentTotals = currentFooter.querySelector('.js-contents');
      if (incomingTotals && currentTotals) currentTotals.innerHTML = incomingTotals.innerHTML;
      currentFooter.classList.toggle('is-empty', incomingFooter.classList.contains('is-empty'));
    }
    const incomingCart = html.querySelector('cart-items');
    const currentCart = document.querySelector('cart-items');
    if (incomingCart && currentCart) currentCart.classList.toggle('is-empty', incomingCart.classList.contains('is-empty'));
  }

  function refreshMainCart() {
    if (!document.querySelector('#main-cart-items')) return Promise.resolve();
    const url = new URL(window.location.href);
    url.searchParams.set('_city_cart_refresh', String(Date.now()));
    return fetch(url.toString(), { cache: 'no-store', credentials: 'same-origin' })
      .then(response => {
        if (!response.ok) throw new Error('Unable to refresh the cart page.');
        return response.text();
      })
      .then(text => applyMainCartDocument(new DOMParser().parseFromString(text, 'text/html')));
  }

  function applyCartDrawerDocument(htmlText, openAfterRefresh = false, cartState = null, options = {}) {
    const html = new DOMParser().parseFromString(htmlText, 'text/html');
    if (!options.displayOnly) applyMainCartDocument(html);
    const incomingDrawer = html.querySelector('cart-drawer');
    const currentDrawer = document.querySelector('cart-drawer');
    if (options.displayOnly && (!incomingDrawer || !currentDrawer || !html.querySelector('#CartDrawer'))) return false;

    if (incomingDrawer && currentDrawer) {
      currentDrawer.classList.toggle('is-empty', incomingDrawer.classList.contains('is-empty'));
    }

    const incoming = html.querySelector('#CartDrawer');
    const current = document.querySelector('#CartDrawer');
    if (incoming && current) {
      current.innerHTML = incoming.innerHTML;
    }

    const incomingCartIcon = html.querySelector('#cart-icon-bubble');
    const currentCartIcon = document.querySelector('#cart-icon-bubble');
    if (incomingCartIcon && currentCartIcon) {
      currentCartIcon.innerHTML = incomingCartIcon.innerHTML;
    }

    syncCartEmptyState(cartState);
    initCartEnhancements(null, options.displayOnly ? { deferCartState: true } : {});
    if (options.displayOnly) initExpiryTimer(true);
    openDrawerIfNeeded(openAfterRefresh);

    document.dispatchEvent(new CustomEvent('city:cart-state-changed', {
      detail: { source: options.displayOnly ? 'city-cart-drawer-shared' : 'city-cart-drawer-page' },
    }));
    return drawerHasRenderedItems();
  }

  let sharedCartDisplayTimer = null, sharedCartDisplayPending = false, sharedCartDisplayRunning = false, sharedCartDisplayVersion = 0;

  function sharedCartDisplayBusy() {
    return Array.from(document.querySelectorAll('dialog.lr-multi[open], #CartDrawer [data-city-inline-editor-form], #CartDrawer [data-city-inline-variant-form], #CartDrawer [aria-busy="true"], #CartDrawer .is-updating, #CartDrawer .cart__items--disabled'))
      .some((node) => node.getClientRects().length > 0)
      || !!document.querySelector('#CartDrawer input:focus, #CartDrawer select:focus, #CartDrawer textarea:focus');
  }

  function queueSharedCartDisplayRefresh() {
    sharedCartDisplayVersion++;
    sharedCartDisplayPending = true;
    clearTimeout(sharedCartDisplayTimer);
    sharedCartDisplayTimer = setTimeout(refreshSharedCartDisplay, 150);
  }

  function refreshSharedCartDisplay() {
    if (sharedCartDisplayRunning || !sharedCartDisplayPending) return;
    if (sharedCartDisplayBusy()) {
      sharedCartDisplayTimer = setTimeout(refreshSharedCartDisplay, 250);
      return;
    }
    if (!document.querySelector('cart-drawer')) { sharedCartDisplayPending = false; return; }
    sharedCartDisplayPending = false;
    sharedCartDisplayRunning = true;
    const version = sharedCartDisplayVersion;
    return fetch(sharedCartDisplayUrl(), { cache: 'no-store', credentials: 'same-origin' })
      .then((response) => { if (!response.ok) throw new Error('Cart display could not be read'); return response.text(); })
      .then((htmlText) => {
        if (version !== sharedCartDisplayVersion || sharedCartDisplayBusy()) { sharedCartDisplayPending = true; return; }
        applyCartDrawerDocument(htmlText, false, null, { displayOnly: true });
      })
      .catch(() => null)
      .finally(() => {
        sharedCartDisplayRunning = false;
        if (sharedCartDisplayPending) sharedCartDisplayTimer = setTimeout(refreshSharedCartDisplay, 150);
      });
  }

  function sharedCartDisplayUrl() {
    const url = new URL(window.location.href);
    const previewTheme = url.searchParams.get('preview_theme_id');
    // A passive read must not replay a tab's earlier country/currency selection.
    url.search = '';
    if (previewTheme) url.searchParams.set('preview_theme_id', previewTheme);
    url.searchParams.set('_city_cart_refresh', String(Date.now()));
    return url.toString();
  }

  function initSharedCartDisplaySync() {
    window.addEventListener('storage', (event) => {
      if (event.storageArea && event.storageArea !== window.localStorage) return;
      if (event.key === null || /^(?:cityCart|cart(?:$|[._:-])|Shopify::cart)/.test(event.key || '')) queueSharedCartDisplayRefresh();
    });
    document.addEventListener('visibilitychange', () => {
      if (document.visibilityState === 'visible') queueSharedCartDisplayRefresh();
    });
    document.addEventListener('city:cart-state-changed', (event) => {
      if (event.detail?.source === 'city-cart-drawer-shared') return;
      sharedCartDisplayVersion++;
      if (sharedCartDisplayRunning) sharedCartDisplayPending = true;
    });
  }

  function refreshCartDrawerFromPage(openAfterRefresh = false, cartState = null) {
    const url = new URL(window.location.href);
    const previewTheme = document.querySelector('[data-city-contact-purchase-options]')?.dataset.cityPreviewTheme;
    if (previewTheme) url.searchParams.set('preview_theme_id', previewTheme);
    url.searchParams.set('_city_cart_refresh', String(Date.now()));

    return fetch(url.toString(), {
      cache: 'no-store',
      credentials: 'same-origin',
    })
      .then((response) => response.text())
      .then((htmlText) => applyCartDrawerDocument(htmlText, openAfterRefresh, cartState));
  }

  function applyCartSections(sections, openAfterRefresh = false) {
    if (!sections) return Promise.resolve();

    const drawerSection = sections['cart-drawer'];
    if (drawerSection) {
      const html = new DOMParser().parseFromString(drawerSection, 'text/html');
      const incomingDrawer = html.querySelector('cart-drawer');
      const currentDrawer = document.querySelector('cart-drawer');

      if (incomingDrawer && currentDrawer) {
        currentDrawer.classList.toggle('is-empty', incomingDrawer.classList.contains('is-empty'));
      }

      const incoming = html.querySelector('#CartDrawer');
      const current = document.querySelector('#CartDrawer');
      if (incoming && current) {
        current.innerHTML = incoming.innerHTML;
      }

    }

    const cartIconSection = sections['cart-icon-bubble'];
    if (cartIconSection) {
      const html = new DOMParser().parseFromString(cartIconSection, 'text/html');
      const incoming = html.querySelector('#cart-icon-bubble') || html.querySelector('.shopify-section');
      const current = document.querySelector('#cart-icon-bubble');
      if (incoming && current) {
        current.innerHTML = incoming.id === 'cart-icon-bubble' ? incoming.innerHTML : incoming.innerHTML;
      }
    }

    initCartEnhancements();

    return fetchCartState()
      .then((cartState) => {
        syncCartEmptyState(cartState);
        return cartState;
      })
      .catch(() => null)
      .then(() => refreshMainCart())
      .then(() => {
        openDrawerIfNeeded(openAfterRefresh);
        document.dispatchEvent(new CustomEvent('city:cart-state-changed', {
          detail: { source: 'city-cart-drawer' },
        }));
      });
  }

  function refreshCartDrawer(openAfterRefresh = false, minItemCount = 0, attempt = 0) {
    // These callers have completed an add; a new cart can reserve again after expiry.
    if (openAfterRefresh && minItemCount > 0 && attempt === 0) cartExpirySharedRemoved = false;
    const params = new URLSearchParams({
      sections: 'cart-drawer,cart-icon-bubble',
      sections_url: window.location.pathname,
      _: String(Date.now()),
    });

    return waitForCartItems(minItemCount || 0)
      .then((cartState) =>
        refreshCartDrawerFromPage(openAfterRefresh, cartState)
          .then((renderedFromPage) => ({ cartState, renderedFromPage }))
          .catch(() =>
            fetch(`${routes.cart_url}?${params.toString()}`, {
              cache: 'no-store',
              credentials: 'same-origin',
              headers: { Accept: 'application/json' },
            })
              .then((response) => response.json())
              .then((sections) =>
                applyCartSections(sections, openAfterRefresh).then(() => ({
                  cartState,
                  renderedFromPage: drawerHasRenderedItems(),
                }))
              )
          )
      )
      .then(({ cartState }) => cartState)
      .then((cartState) => {
        if (getVisibleCartItemCount(cartState) > 0 && !drawerHasRenderedItems() && attempt < 6) {
          return new Promise((resolve) => {
            setTimeout(resolve, 220);
          }).then(() => refreshCartDrawer(openAfterRefresh, minItemCount, attempt + 1));
        }
        return cartState;
      })
      .catch(() => refreshCartDrawerFallback(openAfterRefresh));
  }

  function refreshCartDrawerFallback(openAfterRefresh = false) {
    return fetch(`${routes.cart_url}?section_id=cart-drawer&_=${Date.now()}`, {
      cache: 'no-store',
      credentials: 'same-origin',
    })
      .then((response) => response.text())
      .then((htmlText) => {
        const html = new DOMParser().parseFromString(htmlText, 'text/html');
        const incomingDrawer = html.querySelector('cart-drawer');
        const currentDrawer = document.querySelector('cart-drawer');

        if (incomingDrawer && currentDrawer) {
          currentDrawer.classList.toggle('is-empty', incomingDrawer.classList.contains('is-empty'));
        }

        const incoming = html.querySelector('#CartDrawer');
        const current = document.querySelector('#CartDrawer');
        if (incoming && current) {
          current.innerHTML = incoming.innerHTML;
        }

        initCartEnhancements();
      })
      .then(() =>
        fetch(`${routes.cart_url}?section_id=cart-icon-bubble&_=${Date.now()}`, {
          cache: 'no-store',
          credentials: 'same-origin',
        })
      )
      .then((response) => response.text())
      .then((htmlText) => {
        const html = new DOMParser().parseFromString(htmlText, 'text/html');
        const incoming = html.querySelector('.shopify-section') || html.querySelector('#cart-icon-bubble');
        const current = document.querySelector('#cart-icon-bubble');
        if (incoming && current) current.innerHTML = incoming.innerHTML;
        const drawer = document.querySelector('cart-drawer');
        if (openAfterRefresh && drawer && typeof drawer.open === 'function') {
          setTimeout(() => drawer.open());
        }
      })
      .catch((error) => console.warn('Cart refresh failed.', error));
  }

  function cleanCartEditToken(sections) {
    const token = getCartEditToken();
    if (!token) return Promise.resolve(null);

    return fetch(`${root}cart.js?_=${Date.now()}`, {
      cache: 'no-store',
      credentials: 'same-origin',
      headers: { Accept: 'application/json' },
    })
      .then((response) => response.json())
      .then((cartState) => {
        const editedItem = (cartState.items || []).find(
          (item) => item.properties && item.properties._cart_edit_token === token
        );
        if (!editedItem) return null;

        const properties = { ...editedItem.properties };
        delete properties._cart_edit_token;

        return fetch(routes.cart_change_url, {
          method: 'POST',
          cache: 'no-store',
          credentials: 'same-origin',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
            'X-Requested-With': 'XMLHttpRequest',
          },
          body: JSON.stringify({
            id: editedItem.key,
            quantity: editedItem.quantity,
            properties,
            sections,
            sections_url: window.location.pathname,
          }),
        }).then((response) => response.json());
      })
      .catch((error) => {
        console.warn('Cart edit token cleanup failed.', error);
        return null;
      });
  }

  function removeEditedCartLine(options = {}) {
    const editKey = getCartEditKey();
    if (!editKey) return Promise.resolve(options.response || null);

    const sections = getCartSections(options.cart);

    return fetch(routes.cart_change_url, {
      method: 'POST',
      cache: 'no-store',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
      },
      body: JSON.stringify({
        id: editKey,
        quantity: 0,
        sections,
        sections_url: window.location.pathname,
      }),
    })
      .then((response) => response.json())
      .then((response) => {
        if (response.status) throw new Error(response.description || response.message || 'Unable to update cart');

        return cleanCartEditToken(sections).then((cleanResponse) =>
          cleanResponse && !cleanResponse.status ? cleanResponse : response
        );
      })
      .then((response) => {
        clearCartEditState();
        resetExpiryTimer();

        if (options.render) {
          if (options.cart && typeof options.cart.renderContents === 'function') {
            options.cart.renderContents(response);
          } else if (response.sections) {
            applyCartSections(response.sections, options.openAfterRefresh !== false);
          }
        }

        return response;
      });
  }

  function removeTransitProtectionAddon(removeButton) {
    if (!removeButton || removeButton.dataset.cityRemoving === 'true') return Promise.resolve(null);

    const itemKey = removeButton.dataset.cartItemKey;
    if (!itemKey) return Promise.resolve(null);

    removeButton.dataset.cityRemoving = 'true';
    removeButton.disabled = true;
    removeButton.setAttribute('aria-busy', 'true');

    const sections = ['cart-drawer', 'cart-icon-bubble'];

    return fetch(routes.cart_change_url, {
      method: 'POST',
      cache: 'no-store',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
      },
      body: JSON.stringify({
        id: itemKey,
        quantity: 0,
        sections,
        sections_url: window.location.pathname,
      }),
    })
      .then((response) => response.json())
      .then((response) => {
        if (response.status) throw new Error(response.description || response.message || 'Unable to remove Transit Protection');

        resetExpiryTimer();
        if (response.sections) {
          return applyCartSections(response.sections, true).then(() => response);
        }

        return refreshCartDrawer(true, 0).then(() => response);
      })
      .catch((error) => {
        console.warn('Transit Protection remove failed.', error);
        delete removeButton.dataset.cityRemoving;
        removeButton.disabled = false;
        removeButton.removeAttribute('aria-busy');
        throw error;
      });
  }

  function handleTransitProtectionRemoveClick(event) {
    const removeButton = event.target.closest('[data-city-transit-protection-remove]');
    if (!removeButton) return false;

    event.preventDefault();
    event.stopPropagation();
    if (typeof event.stopImmediatePropagation === 'function') event.stopImmediatePropagation();
    removeTransitProtectionAddon(removeButton).catch(() => null);
    return true;
  }

  function resetExpiryTimer() {
    if (!settings.expiryMinutes) return;
    cartExpirySharedRemoved = false;
    const duration = Number(settings.expiryMinutes) * 60 * 1000;
    const expiresAt = Date.now() + duration;
    window.localStorage.setItem('cityCartExpiresAt', String(expiresAt));
    return expiresAt;
  }

  function renewExpiryTimerForCart(cartState) {
    if (!settings.expiryMinutes) return;
    if (getVisibleCartItemCount(cartState) > 0) {
      resetExpiryTimer();
      initExpiryTimer();
    } else {
      window.localStorage.removeItem('cityCartExpiresAt');
      cartExpirySharedRemoved = true;
      stopExpiryTimer();
    }
  }

  function applyDiscount(code, messageEl) {
    const discount = (code || '').trim();
    if (!discount) {
      if (messageEl) messageEl.textContent = 'Enter a discount code first.';
      return Promise.resolve();
    }

    if (messageEl) messageEl.textContent = 'Applying discount...';

    return fetch(routes.cart_update_url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ discount }),
    })
      .then((response) => response.json())
      .then(() => {
        if (messageEl) messageEl.textContent = 'Discount applied. It will be validated by Shopify at checkout.';
        return refreshCartDrawer();
      })
      .catch(() => {
        if (messageEl) messageEl.textContent = 'Discount could not be applied. Please try again.';
      });
  }

  function estimateShipping(form, messageEl) {
    const formData = new FormData(form);
    const params = new URLSearchParams();
    params.set('shipping_address[country]', formData.get('country') || 'Australia');
    params.set('shipping_address[province]', formData.get('province') || '');
    params.set('shipping_address[zip]', formData.get('zip') || '');

    if (messageEl) messageEl.textContent = 'Checking available rates...';

    return fetch(`${root}cart/prepare_shipping_rates.json?${params.toString()}`, { method: 'POST' })
      .then(() => fetch(`${root}cart/async_shipping_rates.json?${params.toString()}`))
      .then((response) => response.json())
      .then((data) => {
        const rates = data.shipping_rates || [];
        if (!rates.length) {
          if (messageEl) messageEl.textContent = 'No shipping rates returned for that postcode yet.';
          return;
        }
        if (messageEl) {
          messageEl.innerHTML = [
            `We found ${rates.length} shipping rate(s) for your address`,
            ...rates.map((rate) => `${rate.name}: ${money(Math.round(Number(rate.price) * 100))}`),
          ].join('<br>');
        }
      })
      .catch(() => {
        if (messageEl) messageEl.textContent = 'Shipping rates are unavailable right now.';
      });
  }

  function goToCheckout(button = null) {
    if (button && button.disabled) return;

    const previousText = button ? button.textContent : '';
    if (button) {
      button.disabled = true;
      button.textContent = 'Checking out...';
    }

    fetchCartState()
      .then((cartState) => {
        if (getVisibleCartItemCount(cartState) > 0) {
          return syncTransitProtectionQuantity(cartState, { refresh: false })
            .catch(() => false)
            .then(() => {
              window.location.assign(`${root}checkout`);
            });
        }

        if (button) {
          button.disabled = false;
          button.textContent = previousText;
        }
        refreshCartDrawer(true, 0);
      })
      .catch(() => {
        window.location.assign(`${root}checkout`);
      });
  }

  function clearCartDrawerErrors() {
    const cartErrors = document.getElementById('cart-errors') || document.getElementById('CartDrawer-CartErrors');
    if (cartErrors) cartErrors.textContent = '';
    return cartErrors;
  }

  function setTransitProtectionAddingState(isAdding) {
    document.documentElement.classList.toggle('city-transit-protection-adding', Boolean(isAdding));
    const drawer = document.querySelector('cart-drawer');
    if (drawer) drawer.classList.toggle('city-transit-protection-adding', Boolean(isAdding));
    if (isAdding) clearCartDrawerErrors();
  }

  function getUpsellSourceButton(upsellSource) {
    if (!upsellSource) return null;
    if (upsellSource.matches && upsellSource.matches('[data-city-upsell-button]')) return upsellSource;
    return upsellSource.querySelector ? upsellSource.querySelector('[data-city-upsell-button], button') : null;
  }

  function getUpsellSourceValue(upsellSource, button, fieldName, dataName, fallback = '') {
    const dataValue = (upsellSource && upsellSource.dataset && upsellSource.dataset[dataName])
      || (button && button.dataset && button.dataset[dataName]);
    if (dataValue) return dataValue;

    const field = upsellSource && upsellSource.querySelector ? upsellSource.querySelector(`[name="${fieldName}"]`) : null;
    return field && field.value ? field.value : fallback;
  }

  function getUpsellSourceQuantity(upsellSource, button) {
    return Math.max(parseInt(getUpsellSourceValue(upsellSource, button, 'quantity', 'cityUpsellQuantity', '1'), 10) || 1, 1);
  }

  function parseCartAddResponse(response) {
    if (!response) throw new Error('Unable to add item');

    const parsePayload = () => {
      if (typeof response.json === 'function') {
        return response.json().catch(() => {
          if (typeof response.text === 'function') {
            return response.text().then((text) => {
              throw new Error(text || 'Unable to add item');
            });
          }
          throw new Error('Unable to add item');
        });
      }

      if (typeof response.text === 'function') {
        return response.text().then((text) => {
          if (!text) return {};
          try {
            return JSON.parse(text);
          } catch (error) {
            return { message: text };
          }
        });
      }

      if (typeof response === 'object') return Promise.resolve(response);

      throw new Error('Unable to add item');
    };

    return parsePayload().then((payload) => {
      const rejected = response.ok === false || (payload && Number(payload.status || 0) >= 400);
      if (rejected) {
        console.warn('Upsell add rejected.', {
          status: response.status,
          statusText: response.statusText,
          ok: response.ok,
          payload,
        });
        throw new Error((payload && (payload.description || payload.message)) || (response.status ? `Unable to add item (${response.status})` : 'Unable to add item'));
      }
      return payload || {};
    });
  }

  function requestCartAjax(url, body, options = {}) {
    return new Promise((resolve, reject) => {
      const xhr = new XMLHttpRequest();
      xhr.open('POST', url, true);
      xhr.withCredentials = true;
      xhr.setRequestHeader('Accept', 'application/json');
      xhr.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
      if (!options.isFormData) xhr.setRequestHeader('Content-Type', 'application/json');

      xhr.onload = () => {
        let payload = {};
        try {
          payload = xhr.responseText ? JSON.parse(xhr.responseText) : {};
        } catch (error) {
          payload = { message: xhr.responseText || '' };
        }

        if (xhr.status < 200 || xhr.status >= 300 || (payload && Number(payload.status || 0) >= 400)) {
          console.warn('Upsell add rejected.', {
            status: xhr.status,
            statusText: xhr.statusText,
            payload,
          });
          reject(new Error((payload && (payload.description || payload.message)) || (xhr.status ? `Unable to add item (${xhr.status})` : 'Unable to add item')));
          return;
        }

        resolve(payload || {});
      };

      xhr.onerror = () => reject(new Error('Unable to add item'));
      xhr.send(body);
    });
  }

  function requestCartAddAjax(body, options = {}) {
    return requestCartAjax(getCartAddAjaxUrl(), body, options);
  }

  function requestCartUpdateAjax(body) {
    return requestCartAjax(getCartUpdateAjaxUrl(), body);
  }

  function submitUpsellForm(upsellForm) {
    const upsellSource = upsellForm;
    if (!upsellSource || upsellSource.dataset.cityUpsellAdding === 'true') return;

    upsellSource.dataset.cityUpsellAdding = 'true';
    const button = getUpsellSourceButton(upsellSource);
    const previousButtonText = button ? button.textContent : '';
    const prompt = upsellSource.closest ? upsellSource.closest('[data-city-revitalens-prompt]') : null;
    const variantId = Number(getUpsellSourceValue(upsellSource, button, 'id', 'cityUpsellVariantId', '0') || 0);
    const uniqueVariantId = Number(upsellSource.dataset.cityUpsellUnique === 'true' ? variantId : 0);
    const openAfterRefresh = upsellSource.dataset.cityUpsellOpenDrawer !== 'false';
    const isTransitProtectionForm = upsellSource.hasAttribute && upsellSource.hasAttribute('data-city-transit-protection-form');
    clearCartDrawerErrors();
    if (isTransitProtectionForm) setTransitProtectionAddingState(true);
    if (button) {
      button.disabled = true;
      button.textContent = 'Adding';
    }

    const prepareUpsellForm = isTransitProtectionForm
      ? fetchCartState().then((cartState) => {
          const lensReplacementQuantity = getLensReplacementQuantity(cartState);
          if (lensReplacementQuantity <= 0) throw new Error('no-lens-replacement');

          const existingTransitItems = getTransitProtectionItems(cartState);
          if (existingTransitItems.length) {
            return syncTransitProtectionQuantity(cartState, { refresh: true, openAfterRefresh }).then(() => {
              throw new Error('already-in-cart');
            });
          }

          setNamedFieldValue(upsellSource, 'quantity', String(lensReplacementQuantity));
          const coverageCopy = getTransitProtectionCoverageCopy(lensReplacementQuantity, { variant_id: variantId });
          setNamedFieldValue(upsellSource, 'properties[Coverage]', coverageCopy);
        })
      : Promise.resolve();

    let body;
    let expectedMinItemCount = 1;
    let useCartUpdate = false;

    prepareUpsellForm
      .then(() => {
        if (!variantId) throw new Error('missing-variant');

        return fetchCartState().catch(() => null);
      })
      .then((cartState) => {
        const addQuantity = getUpsellSourceQuantity(upsellSource, button);
        expectedMinItemCount = cartState ? getVisibleCartItemCount(cartState) + addQuantity : addQuantity;

        if (uniqueVariantId && cartState && cartState.items) {
          if (cartState.items && cartState.items.some((item) => Number(item.variant_id || 0) === uniqueVariantId)) {
            setRevitalensPromptAdded(prompt);
            throw new Error('already-in-cart');
          }
        }

        useCartUpdate = false;
        if (isTransitProtectionForm) {
          body = new FormData(upsellSource);
          body.append('sections', 'cart-drawer,cart-icon-bubble');
          body.append('sections_url', window.location.pathname);
          return null;
        }

        const existingUpsellQuantity = cartState && Array.isArray(cartState.items)
          ? cartState.items.reduce((total, item) => {
              const isSameVariant = Number(item.variant_id || 0) === variantId;
              const hasSellingPlan = Boolean(item.selling_plan_allocation || item.selling_plan);
              return isSameVariant && !hasSellingPlan ? total + (Number(item.quantity || 0) || 0) : total;
            }, 0)
          : 0;
        useCartUpdate = true;
        // Updating by variant ID avoids product-page selling_plan context being applied to simple add-ons.
        body = JSON.stringify({
          updates: {
            [variantId]: existingUpsellQuantity + addQuantity,
          },
          sections: 'cart-drawer,cart-icon-bubble',
          sections_url: window.location.pathname,
        });
        return null;
      })
      .then(() => (useCartUpdate ? requestCartUpdateAjax(body) : requestCartAddAjax(body, { isFormData: isTransitProtectionForm })))
      .then((response) => {
        resetExpiryTimer();
        clearCartDrawerErrors();
        if (response.sections) {
          return applyCartSections(response.sections, openAfterRefresh).then(() => {
            if (prompt) setRevitalensPromptAdded(prompt);
            return new Promise((resolve) => {
              setTimeout(resolve, 160);
            }).then(() => refreshCartDrawer(false, expectedMinItemCount));
          });
        }
        if (prompt) setRevitalensPromptAdded(prompt);
        return refreshCartDrawer(openAfterRefresh, expectedMinItemCount);
      })
      .catch((error) => {
        if (error && error.message === 'already-in-cart') return;
        if (error && error.message === 'no-lens-replacement') {
          clearCartDrawerErrors();
          return refreshCartDrawer(openAfterRefresh, 0);
        }
        const cartErrors = clearCartDrawerErrors();
        if (cartErrors) {
          const message = error && error.message && error.message !== 'missing-variant' && !/response\.json/i.test(error.message)
            ? error.message
            : 'This item could not be added. Please refresh and try again.';
          cartErrors.textContent = message;
        }
        console.warn('Upsell add failed.', error);
      })
      .finally(() => {
        if (isTransitProtectionForm) {
          clearCartDrawerErrors();
          setTransitProtectionAddingState(false);
        }
        delete upsellSource.dataset.cityUpsellAdding;
        if (button) {
          if (prompt && button.textContent === 'Added') return;
          button.disabled = false;
          button.textContent = previousButtonText || 'Add';
        }
      });
  }

  const cartExpiryKey = 'cityCartExpiresAt';
  let cartExpiryCheck = null;
  let cartExpiryStorageBound = false;
  let cartExpirySharedRemoved = false;
  let cartExpiryLockDb = null;

  function readCartExpiry() {
    const value = Number(window.localStorage.getItem(cartExpiryKey) || 0);
    return Number.isFinite(value) && value > 0 ? value : 0;
  }

  function stopExpiryTimer() {
    if (window.cityCartTimer) clearInterval(window.cityCartTimer);
    window.cityCartTimer = null;
  }

  function openCartExpiryLockDb() {
    if (!cartExpiryLockDb) {
      cartExpiryLockDb = new Promise((resolve, reject) => {
        const request = window.indexedDB.open('city-cart-expiry', 1);
        request.onupgradeneeded = () => request.result.createObjectStore('locks');
        request.onsuccess = () => resolve(request.result);
        request.onerror = () => reject(request.error);
        request.onblocked = () => reject(new Error('Cart expiry coordination is unavailable.'));
      }).catch((error) => {
        cartExpiryLockDb = null;
        throw error;
      });
    }
    return cartExpiryLockDb;
  }

  // Atomic IndexedDB transactions coordinate older browsers without Web Locks.
  function updateCartExpiryLease(db, owner, release = false) {
    return new Promise((resolve, reject) => {
      const transaction = db.transaction('locks', 'readwrite');
      const store = transaction.objectStore('locks');
      const request = store.get('cart');
      let acquired = false;
      request.onsuccess = () => {
        const lease = request.result;
        const now = new Date().getTime();
        if (release) {
          if (lease && lease.owner === owner) store.delete('cart');
        } else if (!lease || lease.until <= now) {
          store.put({ owner, until: now + 30000 }, 'cart');
          acquired = true;
        }
      };
      transaction.oncomplete = () => resolve(acquired);
      transaction.onerror = transaction.onabort = () => reject(transaction.error || new Error('Cart expiry coordination failed.'));
    });
  }

  async function withCartExpiryLock(callback) {
    if (window.navigator.locks && typeof window.navigator.locks.request === 'function') {
      return window.navigator.locks.request('city-cart-expiry', { ifAvailable: true }, (lock) => lock ? callback() : false);
    }
    const db = await openCartExpiryLockDb();
    const owner = `${Date.now()}:${Math.random()}`;
    if (!await updateCartExpiryLease(db, owner)) return false;
    try {
      return await callback();
    } finally {
      await updateCartExpiryLease(db, owner, true);
    }
  }

  function clearCart(expectedExpiry, signal) {
    return fetch(`${root}cart/clear.js`, {
      method: 'POST',
      headers: { Accept: 'application/json' },
      signal,
    }).then((response) => {
      if (!response.ok) throw new Error('Cart expiry could not clear the cart.');
      return response.json();
    }).then((cartState) => {
      if (cartState.status) throw new Error(cartState.description || 'Cart expiry could not clear the cart.');
      if (readCartExpiry() === expectedExpiry) {
        cartExpirySharedRemoved = true;
        window.localStorage.removeItem(cartExpiryKey);
      }
      return refreshCartDrawer();
    });
  }

  function checkExpiredCart() {
    if (cartExpiryCheck) return cartExpiryCheck;
    cartExpiryCheck = withCartExpiryLock(async () => {
      const expectedExpiry = readCartExpiry();
      if (!expectedExpiry || expectedExpiry > Date.now()) return false;
      const controller = new AbortController();
      const deadline = setTimeout(() => controller.abort(), 10000);
      try {
        const cartState = await fetchCartState(controller.signal);
        if (!cartState || !Array.isArray(cartState.items)) throw new Error('Cart expiry received an invalid cart.');
        // A cart read can span another tab's add/edit and renewal.
        if (readCartExpiry() !== expectedExpiry || expectedExpiry > Date.now()) return false;
        if (!getVisibleCartItemCount(cartState)) {
          cartExpirySharedRemoved = true;
          window.localStorage.removeItem(cartExpiryKey);
          syncCartEmptyState(cartState);
          return refreshCartDrawer();
        }
        return await clearCart(expectedExpiry, controller.signal);
      } finally {
        clearTimeout(deadline);
      }
    }).catch((error) => {
      console.warn('Cart expiry could not be checked.', error);
    }).finally(() => {
      cartExpiryCheck = null;
      if (!readCartExpiry()) stopExpiryTimer();
    });
    return cartExpiryCheck;
  }

  function initExpiryTimer(syncOnly = false) {
    stopExpiryTimer();
    if (!cartExpiryStorageBound) {
      cartExpiryStorageBound = true;
      window.addEventListener('storage', (event) => {
        if (event.key !== cartExpiryKey && event.key !== null) return;
        stopExpiryTimer();
        cartExpirySharedRemoved = !readCartExpiry();
        // Do not recreate a removed expiry while another tab is clearing.
        if (readCartExpiry()) {
          initExpiryTimer();
        } else {
          queueSharedCartDisplayRefresh();
        }
      });
    }
    const timers = Array.from(document.querySelectorAll('[data-city-cart-timer]'));
    if (!timers.length || !settings.expiryMinutes) return;

    if (!readCartExpiry() && !cartExpirySharedRemoved && !syncOnly) resetExpiryTimer();
    if (!readCartExpiry()) return;

    function tick() {
      const expiresAt = readCartExpiry();
      if (!expiresAt) {
        stopExpiryTimer();
        return;
      }
      const remaining = expiresAt - Date.now();
      if (remaining <= 0) {
        timers.forEach((timer) => {
          timer.textContent = '00:00';
        });
        checkExpiredCart();
        return;
      }

      const minutes = Math.floor(remaining / 60000);
      const seconds = Math.floor((remaining % 60000) / 1000);
      const timeText = `${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;
      timers.forEach((timer) => {
        timer.textContent = timeText;
      });
    }

    window.cityCartTimer = setInterval(tick, 1000);
    tick();
    timers.forEach((timer) => {
      if (!timer.textContent || timer.textContent.trim() === '--:--') {
        timer.textContent = `${String(settings.expiryMinutes).padStart(2, '0')}:00`;
      }
    });
  }

  let cartStateRefreshTimer = null;

  function scheduleCartStateRefresh(renewExpiry = false) {
    clearTimeout(cartStateRefreshTimer);
    cartStateRefreshTimer = setTimeout(() => {
      cartStateRefreshTimer = null;
      fetchCartState()
        .then((cartState) => {
          if (renewExpiry && !cartExpirySharedRemoved) {
            renewExpiryTimerForCart(cartState);
          } else {
            initExpiryTimer();
          }
          syncCartEmptyState(cartState);
        })
        .catch((error) => {
          console.warn('Cart state could not be refreshed.', error);
        });
    }, 60);
  }

  function initCartUpdateSync() {
    if (window.cityCartUpdateSyncReady) return;
    if (
      typeof subscribe !== 'function' ||
      typeof PUB_SUB_EVENTS !== 'object' ||
      !PUB_SUB_EVENTS.cartUpdate
    ) {
      return;
    }

    window.cityCartUpdateSyncReady = true;
    subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
      const cartState = event && event.cartData;

      if (cartState && typeof cartState.item_count !== 'undefined') {
        renewExpiryTimerForCart(cartState);
        syncCartEmptyState(cartState);
        document.dispatchEvent(new CustomEvent('city:cart-state-changed', {
          detail: { source: 'shopify-cart-update' },
        }));
        scheduleTransitProtectionSync(700, { openAfterRefresh: false });
        return;
      }

      scheduleCartStateRefresh();
    });
  }

  const contactLensGroupingMedia = window.matchMedia ? window.matchMedia('(max-width: 749px)') : null;
  let contactLensGroupingEventsBound = false;

  function normalizeContactLensText(value) {
    return String(value || '').replace(/\s+/g, ' ').trim();
  }

  function normalizeContactLensKey(value) {
    return normalizeContactLensText(value).toLowerCase().replace(/[^a-z0-9]+/g, '');
  }

  function escapeContactLensHtml(value) {
    const span = document.createElement('span');
    span.textContent = normalizeContactLensText(value);
    return span.innerHTML;
  }

  function escapeContactLensAttribute(value) {
    return String(value || '')
      .replace(/&/g, '&amp;')
      .replace(/"/g, '&quot;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;');
  }

  function getContactLensProperty(item, names) {
    const props = (item && item.properties) || {};
    const wanted = names.map(normalizeContactLensKey);
    const match = Object.keys(props).find((key) => wanted.includes(normalizeContactLensKey(key)));
    return match ? normalizeContactLensText(props[match]) : '';
  }

  function getContactLensSideProperty(item, names, side) {
    const suffix = side === 'right' ? 'Right' : 'Left';
    const sideNames = names.map((name) => `${name} ${suffix}`);
    return getContactLensProperty(item, sideNames) || getContactLensProperty(item, names);
  }

  function getContactLensSide(item) {
    const side = getContactLensProperty(item, ['Side', 'Eye']).toLowerCase();
    if (side.includes('right') || side === 'r' || side === 'od') return 'right';
    if (side.includes('left') || side === 'l' || side === 'os') return 'left';

    const rightQuantity = parseInt(getContactLensProperty(item, ['Quantity Right']) || '', 10);
    const leftQuantity = parseInt(getContactLensProperty(item, ['Quantity Left']) || '', 10);
    if (!Number.isNaN(rightQuantity) || !Number.isNaN(leftQuantity)) {
      const safeRight = Math.max(rightQuantity || 0, 0);
      const safeLeft = Math.max(leftQuantity || 0, 0);
      if (safeRight > 0 && safeLeft <= 0) return 'right';
      if (safeLeft > 0 && safeRight <= 0) return 'left';
      if (safeLeft > 0 && safeRight > 0) return 'both';
    }

    const labels = Object.keys((item && item.properties) || {}).map(normalizeContactLensKey);
    const hasRight = labels.some((label) => label.endsWith('right'));
    const hasLeft = labels.some((label) => label.endsWith('left'));
    if (hasRight && !hasLeft) return 'right';
    if (hasLeft && !hasRight) return 'left';
    return '';
  }

  function getContactLensEyeQuantity(item, side) {
    const quantity = parseInt(getContactLensProperty(item, [side === 'right' ? 'Quantity Right' : 'Quantity Left']) || '', 10);
    if (!Number.isNaN(quantity)) return Math.max(quantity, 0);
    return getContactLensSide(item) === side ? Math.max(Number(item.quantity || 0), 0) : 0;
  }

  function getContactLensType(item) {
    const haystack = `${Object.keys((item && item.properties) || {}).join(' ')} ${item.productTitle || ''}`.toLowerCase();
    const parts = [];
    if (haystack.includes('cylinder') || haystack.includes('axis') || haystack.includes('toric')) parts.push('toric');
    if (haystack.includes(' add') || haystack.includes('addition') || haystack.includes('multifocal')) parts.push('multifocal');
    if (haystack.includes('colour') || haystack.includes('color')) parts.push('colour');
    return parts.length ? parts.join('-') : 'spherical';
  }

  function getContactLensPackKey(item) {
    const propertyPack = getContactLensProperty(item, ['Size', 'Pack Size', 'Pack', 'Box Size']);
    if (propertyPack) return propertyPack;

    const variantTitle = normalizeContactLensText(item && item.variantTitle);
    if (!variantTitle || variantTitle.toLowerCase() === 'default title') return '';

    const packMatch = variantTitle.match(/\b\d+\s*(?:pack|pk|box|boxes|lens|lenses)\b/i);
    if (packMatch) return packMatch[0];

    return variantTitle;
  }

  function getContactLensSessionId(item) {
    return normalizeContactLensText(
      (item && (item.prescriptionGroupId || item.prescriptionSessionId || item.groupId || item.sessionId))
      || getContactLensProperty(item, [
        'Prescription Group ID',
        'Prescription Group',
        'Prescription Session ID',
        'Prescription Session',
        'Prescription Set ID',
        'Rx Group ID',
        'Rx Session ID',
        'Cart Group ID',
        'Contact Lens Group ID',
      ])
    );
  }

  function getContactLensGroupingKey(item) {
    return [
      item.productId || item.productHandle || '',
      item.productTitle || '',
      item.productType || '',
      item.vendor || '',
      getContactLensPackKey(item),
      item.sellingPlanId || item.sellingPlan || '',
      item.hasPrescriptionUpload ? 'upload' : 'manual',
      getContactLensSessionId(item) || 'no-session',
    ].map(normalizeContactLensKey).join('|');
  }

  function getContactLensPackTitle(item) {
    return getContactLensPackKey(item);
  }

  function getContactLensPrescriptionSummary(item, side) {
    if (item.hasPrescriptionUpload) return 'Prescription: Uploaded';

    const sphere = getContactLensSideProperty(item, ['Sphere Power', 'Sphere', 'SPH', 'Power'], side);
    const baseCurve = getContactLensSideProperty(item, ['Base Curve', 'BC'], side);
    const cylinder = getContactLensSideProperty(item, ['Cylinder Power', 'Cylinder', 'CYL'], side);
    const axis = getContactLensSideProperty(item, ['Axis'], side);
    const add = getContactLensSideProperty(item, ['Add', 'ADD', 'Addition', 'Add Power'], side);
    const dominance = getContactLensSideProperty(item, ['Dominance', 'Dominant Eye', 'Distance/Near', 'Distance Near'], side);
    const colour = getContactLensSideProperty(item, ['Colour', 'Color'], side);
    const parts = [];

    if (sphere) parts.push(sphere);
    if (cylinder) parts.push(axis ? `CYL ${cylinder} x ${axis}` : `CYL ${cylinder}`);
    if (!cylinder && axis) parts.push(`AXIS ${axis}`);
    if (add) parts.push(`ADD ${add}`);
    if (item.baseCurveChangeable && baseCurve) parts.push(`BC ${baseCurve}`);
    if (dominance) parts.push(dominance);
    if (colour) parts.push(`Colour ${colour}`);

    return parts.length ? parts.join(' / ') : 'Prescription details incomplete';
  }

  function readContactLensCartRows() {
    const structuredRows = Array.from(document.querySelectorAll('#CartDrawer [data-city-contact-lens-row]')).map((row) => {
      try {
        const item = JSON.parse(row.dataset.cityContactLensItem || '{}');
        item.row = row;
        item.side = getContactLensSide(item);
        item.groupKey = getContactLensGroupingKey(item);
        return item;
      } catch (error) {
        return null;
      }
    }).filter(Boolean);
    return structuredRows.length ? structuredRows : readContactLensCartDomRows();
  }

  function parseContactLensMoneyToCents(text) {
    const amount = String(text || '').replace(/,/g, '').match(/-?\d+(?:\.\d{1,2})?/);
    if (!amount) return 0;
    return Math.round(Number(amount[0]) * 100);
  }

  function getContactLensRowLine(row) {
    const input = row.querySelector('.quantity__input[data-index]');
    if (input && input.dataset.index) return Number(input.dataset.index) || 0;
    const remove = row.querySelector('cart-remove-button[data-index]');
    if (remove && remove.dataset.index) return Number(remove.dataset.index) || 0;
    const idMatch = String(row.id || '').match(/CartDrawer-Item-(\d+)/);
    return idMatch ? Number(idMatch[1]) || 0 : 0;
  }

  function readContactLensCartDomRows() {
    return Array.from(document.querySelectorAll('#CartDrawer tr.cart-item'))
      .filter((row) => !row.matches('.city-cart-add-on-row, .city-rx-component-row, [data-city-contact-lens-card]'))
      .map((row) => {
        const properties = {};
        row.querySelectorAll('.cart-item__details .product-option').forEach((option) => {
          const label = option.querySelector('dt');
          const value = option.querySelector('dd');
          if (!label || !value) return;
          const key = label.textContent.replace(/:\s*$/, '').trim();
          const text = value.textContent.trim().replace(/\s+/g, ' ');
          if (key && text) properties[key] = text;
        });

        const propertyKeys = Object.keys(properties).map((key) => key.toLowerCase());
        const looksLikeContactLens = propertyKeys.some((key) => (
          key === 'side'
          || key === 'eye'
          || key === 'base curve'
          || key === 'diameter'
          || key === 'bc'
          || key === 'dia'
          || key.includes('sphere')
          || key.includes('cylinder')
          || key === 'axis'
          || key === 'sph'
          || key === 'cyl'
        ));
        if (!looksLikeContactLens) return null;

        const titleLink = row.querySelector('.cart-item__name');
        const quantityInput = row.querySelector('.quantity__input');
        const removeButton = row.querySelector('cart-remove-button[data-cart-item-key]');
        const image = row.querySelector('.cart-item__image');
        const priceElement = row.querySelector('.cart-item__price-wrapper .city-rrp-price__now, .cart-item__final-price, .price--end, .cart-item__price-wrapper .price');
        const item = {
          key: (quantityInput && quantityInput.dataset.cartItemKey) || (removeButton && removeButton.dataset.cartItemKey) || '',
          line: getContactLensRowLine(row),
          productId: '',
          productHandle: '',
          productTitle: titleLink ? titleLink.textContent.trim().replace(/\s+/g, ' ') : '',
          productType: '',
          vendor: '',
          variantId: quantityInput ? quantityInput.dataset.quantityVariantId || '' : '',
          variantTitle: properties.Size || properties['Pack Size'] || '',
          variantSku: '',
          quantity: quantityInput ? Number(quantityInput.value || 1) : 1,
          finalLinePrice: parseContactLensMoneyToCents(priceElement ? priceElement.textContent : ''),
          variantPrice: Number(row.querySelector('.city-rrp-price')?.dataset.cityRrpVariantPrice || 0),
          compareAtPrice: Number(row.querySelector('.city-rrp-price')?.dataset.cityRrpComparePrice || 0),
          url: titleLink && titleLink.getAttribute('href') ? titleLink.getAttribute('href') : '#',
          image: image && image.getAttribute('src') ? image.getAttribute('src') : null,
          sellingPlan: '',
          hasPrescriptionUpload:
            propertyKeys.includes('prescription upload') ||
            normalizeContactLensKey(properties.Prescription) === 'uploaded' ||
            normalizeContactLensKey(properties.Prescription) === 'received',
          properties,
          row,
        };
        item.side = getContactLensSide(item);
        item.groupKey = getContactLensGroupingKey(item);
        return item;
      })
      .filter(Boolean);
  }

  function contactLensItemsCanGroup(items) {
    if (items.length === 1) return items[0].side === 'both';
    if (items.length !== 2) return false;
    return items.map((item) => item.side).sort().join('|') === 'left|right';
  }

  function buildContactLensLineDetails(item, side, options = {}) {
    const quantity = side === 'both' ? Number(item.quantity || 0) : getContactLensEyeQuantity(item, side);
    const label = side === 'right' ? 'R' : side === 'left' ? 'L' : 'Rx';
    const bothEyes = getContactLensProperty(item, ['Side', 'Eye']).toLowerCase().includes('both');
    const sideLabel = bothEyes ? 'Both Eyes' : side === 'right' ? 'Right Eye' : side === 'left' ? 'Left Eye' : 'Prescription';
    const safeKey = escapeContactLensAttribute(item.key || '');
    const removeTooltip = `Remove ${sideLabel}`;
    const hideRemove = Boolean(options.hideRemove);
    return `
      <div class="city-contact-lens-card__rx-row" data-city-contact-lens-eye="${escapeContactLensAttribute(side)}" data-city-contact-lens-key="${safeKey}">
        <span class="city-contact-lens-card__rx-label">${label}</span>
        <span class="city-contact-lens-card__rx-copy">
          <strong>${sideLabel}</strong>
          <span class="city-contact-lens-card__rx-text">${escapeContactLensHtml(getContactLensPrescriptionSummary(item, side === 'both' ? 'right' : side))}</span>
        </span>
        <span class="city-contact-lens-card__qty" aria-label="${sideLabel} quantity">
          <button type="button" data-city-contact-lens-eye-qty-change="-1" data-city-contact-lens-key="${safeKey}" aria-label="Decrease ${sideLabel} quantity">-</button>
          <span>${quantity}</span>
          <button type="button" data-city-contact-lens-eye-qty-change="1" data-city-contact-lens-key="${safeKey}" aria-label="Increase ${sideLabel} quantity">+</button>
        </span>
        ${hideRemove ? '' : `<button class="city-contact-lens-card__eye-remove" type="button" data-city-contact-lens-remove-key="${safeKey}" aria-label="${removeTooltip}" data-city-tooltip="${removeTooltip}">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" aria-hidden="true" focusable="false" class="icon icon-remove"><path d="M14 3h-3.53a3.07 3.07 0 00-.6-1.65C9.44.82 8.8.5 8 .5s-1.44.32-1.87.85A3.06 3.06 0 005.53 3H2a.5.5 0 000 1h1.25v10c0 .28.22.5.5.5h8.5a.5.5 0 00.5-.5V4H14a.5.5 0 000-1zM6.91 1.98c.23-.29.58-.48 1.09-.48s.85.19 1.09.48c.2.24.3.6.36 1.02h-2.9c.05-.42.17-.78.36-1.02zm4.84 11.52h-7.5V4h7.5v9.5z" fill="currentColor"/><path d="M6.55 5.25a.5.5 0 00-.5.5v6a.5.5 0 001 0v-6a.5.5 0 00-.5-.5zM9.45 5.25a.5.5 0 00-.5.5v6a.5.5 0 001 0v-6a.5.5 0 00-.5-.5z" fill="currentColor"/></svg>
        </button>`}
      </div>
    `;
  }

  function getContactLensGroupSummary(items) {
    if (items.length === 1 && getContactLensProperty(items[0], ['Side', 'Eye']).toLowerCase().includes('both')) {
      const quantity = Math.max(Number(items[0].quantity || 0), 0);
      return `${quantity} ${quantity === 1 ? 'box' : 'boxes'} \u00b7 Both Eyes`;
    }
    const totalBoxes = items.reduce((sum, item) => {
      if (item.side === 'both') {
        return sum + getContactLensEyeQuantity(item, 'right') + getContactLensEyeQuantity(item, 'left');
      }
      return sum + Math.max(Number(item.quantity || 0), 0);
    }, 0);
    const rightItem = items.find((item) => item.side === 'right' || item.side === 'both');
    const leftItem = items.find((item) => item.side === 'left' || item.side === 'both');
    const rightQty = rightItem ? getContactLensEyeQuantity(rightItem, 'right') : 0;
    const leftQty = leftItem ? getContactLensEyeQuantity(leftItem, 'left') : 0;
    const boxLabel = totalBoxes === 1 ? 'box' : 'boxes';
    if (rightQty > 0 && leftQty > 0) return `${totalBoxes} ${boxLabel} \u00b7 Right + Left Eye`;
    if (rightQty > 0) return `${totalBoxes} ${boxLabel} \u00b7 Right Eye only`;
    if (leftQty > 0) return `${totalBoxes} ${boxLabel} \u00b7 Left Eye only`;
    return 'Contact lenses';
  }

  function updateContactLensGroupQuantities(items, nextQuantity) {
    const updates = {};
    items.forEach((item) => {
      if (item && item.key) updates[item.key] = nextQuantity;
    });

    return fetch(routes.cart_update_url, {
      method: 'POST',
      cache: 'no-store',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
      },
      body: JSON.stringify({
        updates,
        sections: 'cart-drawer,cart-icon-bubble',
        sections_url: window.location.pathname,
      }),
    })
      .then((response) => response.json())
      .then((response) => {
        if (response.status) throw new Error(response.description || response.message || 'Unable to update cart');
        applyCartSections(response.sections, true);
      });
  }

  function setContactLensRemoveLoading(trigger) {
    if (!trigger) return;
    const card = trigger.closest('.city-contact-lens-card');
    const choice = trigger.closest('.city-contact-lens-card__choice');
    const removeButton = card ? card.querySelector('[data-city-contact-lens-remove-choice]') : null;

    trigger.classList.add('is-loading');
    trigger.setAttribute('aria-busy', 'true');
    trigger.disabled = true;

    if (removeButton) {
      removeButton.classList.add('is-loading');
      removeButton.setAttribute('aria-busy', 'true');
      removeButton.disabled = true;
    }

    if (choice) {
      choice.querySelectorAll('button').forEach((button) => {
        if (button !== trigger) button.disabled = true;
      });
    }
  }

  function clearContactLensRemoveLoading(trigger) {
    if (!trigger) return;
    const card = trigger.closest('.city-contact-lens-card');
    const choice = trigger.closest('.city-contact-lens-card__choice');
    const removeButton = card ? card.querySelector('[data-city-contact-lens-remove-choice]') : null;

    trigger.classList.remove('is-loading');
    trigger.removeAttribute('aria-busy');
    trigger.disabled = false;

    if (removeButton) {
      removeButton.classList.remove('is-loading');
      removeButton.removeAttribute('aria-busy');
      removeButton.disabled = false;
    }

    if (choice) {
      choice.querySelectorAll('button').forEach((button) => {
        button.disabled = false;
      });
    }
  }

  function removeContactLensGroupWithLoading(trigger, items) {
    setContactLensRemoveLoading(trigger);
    return updateContactLensGroupQuantities(items, 0).catch(() => {
      clearContactLensRemoveLoading(trigger);
    });
  }

  function updateContactLensItemQuantity(trigger, item, nextQuantity) {
    if (!item || !item.key) return Promise.resolve();
    const card = trigger ? trigger.closest('.city-contact-lens-card') : null;
    if (card) card.classList.add('is-updating');

    return fetch(routes.cart_change_url, {
      method: 'POST',
      cache: 'no-store',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
      },
      body: JSON.stringify({
        id: item.key,
        quantity: Math.max(Number(nextQuantity || 0), 0),
        sections: 'cart-drawer,cart-icon-bubble',
        sections_url: window.location.pathname,
      }),
    })
      .then((response) => response.json())
      .then((response) => {
        if (response.status) throw new Error(response.description || response.message || 'Unable to update cart');
        resetExpiryTimer();
        return applyCartSections(response.sections, true);
      })
      .catch((error) => {
        if (card) card.classList.remove('is-updating');
        throw error;
      });
  }

  function renderContactLensGroupedCard(items, index) {
    const first = items[0];
    const grouped = contactLensItemsCanGroup(items);
    const title = first.productTitle || '';
    const safeTitle = escapeContactLensHtml(title);
    const safeTitleAttribute = escapeContactLensAttribute(title);
    const pack = getContactLensPackTitle(first);
    const recurringTotal = items.every((item) => item.recurringLinePrice != null)
      ? items.reduce((sum, item) => sum + Number(item.recurringLinePrice), 0) : null;
    const recurringStart = Number(first.initialOrderCount || 0) + 1;
    const recurringLabel = recurringStart === 2 ? 'from second order'
      : recurringStart > 1 ? `from order ${recurringStart}` : 'per delivery';
    const subscriptionHtml = first.sellingPlan
      ? `<p class="city-contact-lens-card__summary" data-city-cart-subscription>${escapeContactLensHtml(first.sellingPlan)}${recurringTotal == null ? '' : `<br>${money(recurringTotal)} ${recurringLabel}`}</p>` : '';
    const totalPrice = items.reduce((sum, item) => sum + Number(item.finalLinePrice || 0), 0);
    const priceHtml = '<div class="city-contact-lens-card__prices" data-city-contact-rrp-total></div>';
    const rightItem = items.find((item) => item.side === 'right' || item.side === 'both');
    const leftItem = items.find((item) => item.side === 'left' || item.side === 'both');
    const rightQty = rightItem ? getContactLensEyeQuantity(rightItem, 'right') : 0;
    const leftQty = leftItem ? getContactLensEyeQuantity(leftItem, 'left') : 0;
    const visibleEyeCount = (rightQty > 0 ? 1 : 0) + (leftQty > 0 ? 1 : 0);
    const hidePerEyeRemove = visibleEyeCount <= 1;
    const hasPrescriptionUpload = items.some((item) => item.hasPrescriptionUpload);
    const mainRemoveTitle = visibleEyeCount > 1 ? 'Remove both eyes' : 'Remove item';
    const mainRemoveLabel = visibleEyeCount > 1 ? 'Remove entire contact lens item' : 'Remove contact lens item';
    const row = document.createElement('tr');
    row.className = `city-contact-lens-card-row city-contact-lens-card-row--inline${grouped ? ' city-contact-lens-card-row--grouped' : ''}`;
    row.dataset.cityContactLensCard = 'true';
    row.dataset.cityContactLensJsCard = 'true';
    row.innerHTML = `
      <td colspan="4">
        <article class="city-contact-lens-card" data-city-contact-lens-ui-card>
          <div class="city-contact-lens-card__media">
            ${first.image ? `<img src="${escapeContactLensAttribute(first.image)}" alt="" loading="lazy">` : ''}
          </div>
          <div class="city-contact-lens-card__main">
            <a class="city-contact-lens-card__title" href="${escapeContactLensAttribute(first.url || '#')}">${safeTitle}</a>
            ${pack ? `<span class="city-contact-lens-card__pack">${escapeContactLensHtml(pack)}</span>` : ''}
            <p class="city-contact-lens-card__summary">${escapeContactLensHtml(getContactLensGroupSummary(items))}</p>
            ${subscriptionHtml}
            <div data-city-contact-rrp-unit></div>
          </div>
          <div class="city-contact-lens-card__meta-actions">
            ${priceHtml}
            <button class="city-contact-lens-card__remove" type="button" data-city-contact-lens-remove-group="${index}" aria-label="${mainRemoveLabel}" data-city-tooltip="${mainRemoveTitle}">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" aria-hidden="true" focusable="false" class="icon icon-remove"><path d="M14 3h-3.53a3.07 3.07 0 00-.6-1.65C9.44.82 8.8.5 8 .5s-1.44.32-1.87.85A3.06 3.06 0 005.53 3H2a.5.5 0 000 1h1.25v10c0 .28.22.5.5.5h8.5a.5.5 0 00.5-.5V4H14a.5.5 0 000-1zM6.91 1.98c.23-.29.58-.48 1.09-.48s.85.19 1.09.48c.2.24.3.6.36 1.02h-2.9c.05-.42.17-.78.36-1.02zm4.84 11.52h-7.5V4h7.5v9.5z" fill="currentColor"/><path d="M6.55 5.25a.5.5 0 00-.5.5v6a.5.5 0 001 0v-6a.5.5 0 00-.5-.5zM9.45 5.25a.5.5 0 00-.5.5v6a.5.5 0 001 0v-6a.5.5 0 00-.5-.5z" fill="currentColor"/></svg>
            </button>
          </div>
          <div class="city-contact-lens-card__rx">
            ${rightItem ? buildContactLensLineDetails(rightItem, 'right', { hideRemove: hidePerEyeRemove }) : ''}
            ${leftItem ? buildContactLensLineDetails(leftItem, 'left', { hideRemove: hidePerEyeRemove }) : ''}
            ${!rightItem && !leftItem ? buildContactLensLineDetails(first, first.side || 'both', { hideRemove: true }) : ''}
          </div>
          <div class="city-contact-lens-card__editor" data-city-contact-lens-editor="${index}" hidden></div>
          ${hasPrescriptionUpload ? '' : `<div class="city-contact-lens-card__actions">
            <button class="city-contact-lens-card__link" type="button" data-city-contact-lens-edit="${rightItem ? rightItem.line : first.line}" aria-expanded="false">Edit prescription</button>
          </div>`}
        </article>
      </td>
    `;
    const priceTemplate = document.querySelector('[data-city-cart-rrp-template]');
    if (priceTemplate) {
      const quantity = items.reduce((sum, item) => sum + Number(item.quantity || 0), 0);
      const unitPrice = Number(first.finalPrice ?? totalPrice / Math.max(quantity, 1));
      const unitAddsInfo = quantity > 1 || totalPrice !== unitPrice;
      const eligible = Number(first.compareAtPrice) > Number(first.variantPrice);
      const renderPrice = (slot, price, compareAtPrice, total) => {
        const block = priceTemplate.content.firstElementChild.cloneNode(true);
        block.querySelector('.unit-price')?.remove();
        updateCityRrpPrice(block, { price, compareAtPrice, variantPrice: Number(first.variantPrice), total });
        row.querySelector(slot).appendChild(block);
      };
      renderPrice('[data-city-contact-rrp-total]', totalPrice, eligible && !unitAddsInfo ? Number(first.compareAtPrice) : 0, true);
      if (eligible && unitAddsInfo) renderPrice('[data-city-contact-rrp-unit]', unitPrice, Number(first.compareAtPrice), false);
    } else {
      row.querySelector('[data-city-contact-rrp-total]').innerHTML = money(totalPrice);
    }
    return row;
  }

  function initContactLensCartGrouping() {
    document.querySelectorAll('#CartDrawer [data-city-contact-lens-card]').forEach((card) => card.remove());

    const items = readContactLensCartRows();
    if (!items.length) return;

    const groupsByKey = new Map();
    items.forEach((item) => {
      if (!groupsByKey.has(item.groupKey)) groupsByKey.set(item.groupKey, []);
      groupsByKey.get(item.groupKey).push(item);
    });

    const renderedGroups = [];
    groupsByKey.forEach((groupItems) => {
      if (contactLensItemsCanGroup(groupItems)) {
        renderedGroups.push(groupItems);
      } else {
        groupItems.forEach((item) => renderedGroups.push([item]));
      }
    });

    window.CityContactLensCartGroups = renderedGroups;

    document.querySelectorAll('#CartDrawer [data-city-contact-lens-row]').forEach((row) => {
      row.classList.add('city-contact-lens-row-hidden');
      row.style.display = 'none';
      delete row.dataset.cityContactLensExpanded;
    });

    renderedGroups.forEach((groupItems, index) => {
      const firstRow = groupItems[0] && groupItems[0].row;
      if (!firstRow || !firstRow.parentNode) return;
      firstRow.parentNode.insertBefore(renderContactLensGroupedCard(groupItems, index), firstRow);
      groupItems.forEach((item) => {
        if (item.row) item.row.classList.add('city-contact-lens-row-hidden');
      });
    });

    if (!contactLensGroupingEventsBound) {
      contactLensGroupingEventsBound = true;
      if (contactLensGroupingMedia && contactLensGroupingMedia.addEventListener) {
        contactLensGroupingMedia.addEventListener('change', initContactLensCartGrouping);
      }
    }
  }

  function initCartEnhancements(cartState = null, options = {}) {
    if (options.deferCartState) {
      bindTransitProtectionRemoveButtons();
      initContactLensCartGrouping();
      enhanceLensReplacementCartCards();
      return;
    }

    if (cartState) {
      if (cartExpirySharedRemoved) initExpiryTimer();
      else renewExpiryTimerForCart(cartState);
      syncCartEmptyState(cartState);
      syncRevitalensPrompts(cartState);
      syncTransitProtectionQuantity(cartState, { openAfterRefresh: false }).catch(() => null);
      scheduleTransitProtectionSync(700, { openAfterRefresh: false });
    } else {
      scheduleCartStateRefresh(!cartExpirySharedRemoved);
      fetchCartState()
        .then((freshCartState) => {
          syncRevitalensPrompts(freshCartState);
          return syncTransitProtectionQuantity(freshCartState, { openAfterRefresh: false });
        })
        .catch(() => null);
    }
    bindTransitProtectionRemoveButtons();
    initContactLensCartGrouping();
    enhanceLensReplacementCartCards();

  }

  function labelCopiedSingleFrames(rows) {
    const groups = new Map();
    rows.forEach((row) => {
      const edit = row.querySelector('[data-city-cart-edit-link]');
      let payload;
      try { payload = JSON.parse(edit?.dataset.cityCartEditPayload || '{}'); } catch (_) { return; }
      const group = payload.properties?.['_Lens Replacement Group ID'];
      const pair = payload.properties?.['_Lens Replacement Pair ID'];
      if (!group || !pair) return;
      const entries = groups.get(group) || [];
      entries.push({ row, edit, payload, pair, frame: String(payload.properties.Frame || '').trim() });
      groups.set(group, entries);
    });
    groups.forEach((entries) => {
      // A submitted single has no Frame property; its copies start at stored Frame 1.
      if (entries.length < 2 || entries.filter((entry) => !entry.frame).length !== 1
        || new Set(entries.map((entry) => entry.pair)).size !== entries.length
        || entries.some((entry) => entry.frame && !/^Frame [1-9]\d*$/.test(entry.frame))) return;
      entries.forEach(({ row, edit, payload, frame }) => {
        const label = `Frame ${frame ? Number(frame.slice(6)) + 1 : 1}`;
        row.dataset.cityLensDisplayFrame = label;
        const title = row.querySelector('.city-lens-replacement-card__title');
        if (title) title.textContent = title.textContent.replace(/^[^·]*·/, `${label} ·`);
        row.querySelectorAll('.city-lens-replacement-summary__line').forEach((line) => {
          if (String(line.querySelector('dt')?.textContent || '').trim() === 'Pair reference:') {
            const value = line.querySelector('dd');
            if (value) value.textContent = label;
          }
        });
        // Display context only: the original identity and every order property stay intact.
        payload.displayFrameLabel = label;
        edit.dataset.cityCartEditPayload = JSON.stringify(payload);
        edit.setAttribute('aria-label', `Edit ${label}`);
      });
    });
  }

  function labelDistinctCartSubmissions(rows) {
    const entries = rows.map((row) => {
      const edit = row.querySelector('[data-city-cart-edit-link]');
      let payload;
      try { payload = JSON.parse(edit?.dataset.cityCartEditPayload || '{}'); } catch (_) { return null; }
      return { row, edit, payload, group: payload.properties?.['_Lens Replacement Group ID'], pair: payload.properties?.['_Lens Replacement Pair ID'],
        original: Number(row.dataset.cityLensOriginalPrice), final: Number(row.dataset.cityLensFinalPrice) };
    });
    if (entries.some((entry) => !entry?.group || !entry?.pair)
      || new Set(entries.map((entry) => entry.group)).size < 2
      || new Set(entries.map((entry) => `${entry.group}|${entry.pair}`)).size !== entries.length) return;
    // Display the returned full-price pair first, including equal-price ties.
    // This names existing allocations; it never changes stored pair positions.
    if (entries.every((entry) => Number.isFinite(entry.original) && Number.isFinite(entry.final))) {
      entries.sort((a, b) => b.original - a.original || b.final - a.final);
    }
    entries.forEach(({ row, edit, payload }, index) => {
      const label = `Frame ${index + 1}`;
      row.dataset.cityLensDisplayFrame = label;
      const title = row.querySelector('.city-lens-replacement-card__title');
      if (title) title.textContent = title.textContent.replace(/^[^·]*·/, `${label} ·`);
      row.querySelectorAll('.city-lens-replacement-summary__line').forEach((line) => {
        if (String(line.querySelector('dt')?.textContent || '').trim() === 'Pair reference:') {
          const value = line.querySelector('dd');
          if (value) value.textContent = label;
        }
      });
      payload.displayFrameLabel = label;
      edit.dataset.cityCartEditPayload = JSON.stringify(payload);
      edit.setAttribute('aria-label', `Edit ${label}`);
    });
  }

  function enhanceLensReplacementCartCards() {
    let rows = Array.from(document.querySelectorAll('#CartDrawer [data-city-lens-replacement-row]'));
    document.querySelectorAll('[data-city-lens-add-row], [data-city-lens-estimate-summary]').forEach((node) => node.remove());
    if (!rows.length) return;
    const checkoutButton = document.querySelector('#CartDrawer-Checkout');
    if (checkoutButton) checkoutButton.textContent = 'Checkout';
    const firstRow = rows[0];
    rows = rows.sort((a, b) => {
      const aNumber = Number(String(a.dataset.cityLensFrame || '').match(/\d+/)?.[0] || 9999);
      const bNumber = Number(String(b.dataset.cityLensFrame || '').match(/\d+/)?.[0] || 9999);
      return aNumber - bNumber;
    });
    if (firstRow && firstRow.parentNode) {
      const parent = firstRow.parentNode;
      const anchor = document.createComment('city-lens-frame-order');
      parent.insertBefore(anchor, firstRow);
      rows.forEach((row) => parent.insertBefore(row, anchor));
      anchor.remove();
    }

    const ranked = rows.map((row, index) => ({
      row,
      index,
      cents: Number(row.dataset.cityLensOriginalPrice || row.dataset.cityLensFinalPrice || 0),
    })).sort((a, b) => b.cents - a.cents || a.index - b.index);
    const estimateByRow = new Map();
    let estimatedSaving = 0;
    ranked.forEach((entry, rank) => {
      const finalCents = Number(entry.row.dataset.cityLensFinalPrice);
      const saving = Number.isFinite(finalCents) ? Math.max(0, entry.cents - finalCents) : 0;
      const allocationTitle = entry.row.querySelector('.discounts')?.textContent || '';
      const allocationPercent = Number(allocationTitle.match(/\b(15|20)% off (?:second|additional) Lens Replacement pair/i)?.[1] || 0);
      const percent = allocationPercent && saving === Math.floor(entry.cents * allocationPercent / 100) ? allocationPercent : 0;
      estimatedSaving += saving;
      estimateByRow.set(entry.row, { percent, saving });
    });

    // Returned cart allocations are independent of the displayed physical-frame labels.
    labelCopiedSingleFrames(rows);
    labelDistinctCartSubmissions(rows);
    const displayedRows = rows.slice().sort((a, b) => {
      const labelNumber = (row) => Number(String(row.dataset.cityLensDisplayFrame || row.dataset.cityLensFrame || '').match(/\d+/)?.[0] || 9999);
      return labelNumber(a) - labelNumber(b);
    });
    if (firstRow && firstRow.parentNode) {
      const parent = firstRow.parentNode;
      const anchor = document.createComment('city-lens-display-order');
      parent.insertBefore(anchor, firstRow);
      displayedRows.forEach((row) => parent.insertBefore(row, anchor));
      anchor.remove();
    }

    rows.forEach((row) => {
      const detailsList = row.querySelector('.city-lens-replacement-card__details');
      if (detailsList && !detailsList.closest('.city-lens-replacement-card__disclosure')) {
        const compactValues = Array.from(detailsList.querySelectorAll('.city-lens-replacement-summary__line')).map((line) => {
          const label = String(line.querySelector('dt')?.textContent || '').trim().replace(/:$/, '');
          const value = String(line.querySelector('dd')?.textContent || '').replace(/\s*\(Included\)\s*/gi, ' ').trim();
          return { label, value };
        }).filter((item) => item.value);
        const preferred = ['Single Vision Use', 'Multifocal Design', 'Lens Option', 'Lens Purpose', 'Package', 'Light-adaptive brand', 'Light-adaptive lens colour', 'Tint colour', 'Lens option', 'Lens thickness', 'Light-adaptive technology', 'Lens coating', 'Sunglass lens type', 'Sunglass colour', 'Multifocal design', 'Use', 'Frame'];
        const summaryValues = compactValues.filter((item) => preferred.includes(item.label))
          .slice(0, 5).map((item) => item.value);
        const compact = document.createElement('p');
        compact.className = 'city-lens-replacement-card__summary';
        compact.setAttribute('data-clarity-mask', 'true');
        compact.textContent = summaryValues.join(' · ');
        detailsList.before(compact);
        const disclosure = document.createElement('details');
        disclosure.className = 'city-lens-replacement-card__disclosure';
        const summary = document.createElement('summary');
        summary.textContent = 'View details';
        detailsList.before(disclosure);
        disclosure.append(summary, detailsList);
      }
      const estimate = estimateByRow.get(row);
      const previousBadge = row.querySelector('.city-lens-replacement-card__estimate');
      if (previousBadge) previousBadge.remove();
      if (estimate && estimate.saving) {
        const summary = row.querySelector('.city-lens-replacement-card__summary');
        const details = row.querySelector('.cart-item__details');
        const target = summary || details;
        if (target && !row.querySelector('.city-lens-replacement-card__estimate')) {
          const label = document.createElement('span');
          label.className = 'city-lens-replacement-card__estimate';
          label.textContent = `${estimate.percent ? estimate.percent + '% saving' : 'Saving'} · ${money(estimate.saving)}`;
          target.after(label);
        }
      }
      if (!row.querySelector('.city-lens-replacement-card__actions')) {
        const disclosure = row.querySelector('.city-lens-replacement-card__disclosure');
        const editLink = row.querySelector('[data-city-cart-edit-link]');
        const removeControl = row.querySelector('cart-remove-button');
        const actionRow = document.createElement('div');
        actionRow.className = 'city-lens-replacement-card__actions';
        if (editLink) {
          editLink.textContent = 'Edit';
          editLink.setAttribute('aria-label', `Edit ${row.dataset.cityLensDisplayFrame || row.dataset.cityLensFrame || 'lens replacement frame'}`);
        }
        const removeButton = removeControl && removeControl.querySelector('button');
        if (removeButton && !removeButton.querySelector('.city-lens-replacement-card__remove-label')) {
          const removeLabel = document.createElement('span');
          removeLabel.className = 'city-lens-replacement-card__remove-label';
          removeLabel.textContent = 'Remove';
          removeButton.append(removeLabel);
        }
        if (disclosure) actionRow.append(disclosure);
        if (editLink) actionRow.append(editLink);
        if (removeControl) actionRow.append(removeControl);
        const actionAnchor = row.querySelector('.city-lens-replacement-card__estimate, .city-lens-replacement-card__summary');
        const detailsCell = row.querySelector('.cart-item__details');
        if (actionRow.childElementCount && actionAnchor) actionAnchor.after(actionRow);
        else if (actionRow.childElementCount && detailsCell) detailsCell.append(actionRow);
      }
    });

    const eligibleRows = rows.filter((row) => {
      const editLink = row.querySelector('[data-city-cart-edit-link]');
      try {
        const payload = JSON.parse(editLink?.dataset.cityCartEditPayload || '{}');
        const prescriptionType = String(payload.properties?.['Prescription type'] || payload.productTitle || '');
        return /single vision|multifocal/i.test(prescriptionType);
      } catch (error) {
        return false;
      }
    });
    const firstEdit = eligibleRows[0]?.querySelector('[data-city-cart-edit-link]');
    const lastRow = displayedRows[displayedRows.length - 1];
    if (firstEdit && lastRow && lastRow.parentNode) {
      const addRow = document.createElement('tr');
      addRow.dataset.cityLensAddRow = 'true';
      addRow.className = 'city-lens-replacement-add-row';
      const cell = document.createElement('td');
      cell.colSpan = 4;
      const button = document.createElement('button');
      button.type = 'button';
      button.dataset.cityLensAddFrame = 'true';
      button.dataset.cityLensSourcePayload = firstEdit.dataset.cityCartEditPayload || '';
      const nextFrameLabel = rows.length === 1 ? 'Add a second frame' : rows.length === 2 ? 'Add a third frame' : 'Add another frame';
      button.innerHTML = `<span aria-hidden="true">+</span><span><strong>${nextFrameLabel}</strong><small>Multi-frame savings available</small></span><span aria-hidden="true">›</span>`;
      cell.append(button);
      addRow.append(cell);
      lastRow.after(addRow);
    }

    if (estimatedSaving > 0) {
      const totals = document.querySelector('#CartDrawer .cart-drawer__footer .totals');
      if (totals) {
        const summary = document.createElement('p');
        summary.dataset.cityLensEstimateSummary = 'true';
        summary.className = 'city-lens-replacement-estimate-summary';
        summary.innerHTML = `<span>Lens Replacement saving</span><strong>−${money(estimatedSaving)}</strong>`;
        totals.before(summary);
      }
    }
  }

  function bindTransitProtectionRemoveButtons() {
    document.querySelectorAll('[data-city-transit-protection-remove]').forEach((button) => {
      if (button.dataset.cityRemoveBound === 'true') return;
      button.dataset.cityRemoveBound = 'true';
      button.addEventListener('click', handleTransitProtectionRemoveClick);
    });
    document.querySelectorAll('[data-city-transit-tier]').forEach((radio) => {
      if (radio.dataset.cityTierBound === 'true') return;
      radio.dataset.cityTierBound = 'true';
      radio.addEventListener('change', () => {
        if (!radio.checked) return;
        const form = radio.closest('[data-city-transit-protection-form]');
        const coverage = form && form.querySelector('[data-city-transit-coverage]');
        if (coverage) coverage.value = radio.dataset.coverage || '';
      });
    });
  }

  function getAlpineState(element) {
    if (!element) return null;
    if (window.Alpine && typeof window.Alpine.$data === 'function') return window.Alpine.$data(element);
    if (element._x_dataStack && element._x_dataStack[0]) return element._x_dataStack[0];
    return null;
  }

  function setNamedFieldValue(form, fieldName, value) {
    if (!form || value === undefined || value === null) return;
    const field = Array.from(form.elements || []).find((element) => element.name === fieldName);
    if (!field) return;

    field.value = value;
    field.dispatchEvent(new Event('input', { bubbles: true }));
    field.dispatchEvent(new Event('change', { bubbles: true }));
  }

  function getLineSide(properties) {
    return properties.Side || properties.side || '';
  }

  function isSideProperty(key) {
    return String(key || '').toLowerCase() === 'side';
  }

  function prefillContactPrescription(form, propsEl, payload) {
    const properties = payload.properties || {};
    const side = String(getLineSide(properties)).toLowerCase().includes('right') ? 'right' : 'left';
    const otherSide = side === 'left' ? 'right' : 'left';
    const sideLabel = side === 'left' ? 'Left' : 'Right';
    const otherSideLabel = otherSide === 'left' ? 'Left' : 'Right';
    const quantity = Math.max(parseInt(payload.quantity || '1', 10) || 1, 1);

    const applyValues = () => {
      const state = getAlpineState(propsEl);
      if (state && state.props && state.quantity) {
        state.same = false;
        state.quantity[side] = quantity;
        state.quantity[otherSide] = 0;

        Object.entries(properties).forEach(([key, value]) => {
          if (isSideProperty(key)) return;
          if (!state.props[side]) state.props[side] = {};
          state.props[side][key] = value;
        });
      }

      setNamedFieldValue(form, `properties[Quantity ${sideLabel}]`, String(quantity));
      setNamedFieldValue(form, `properties[Quantity ${otherSideLabel}]`, '0');

      Array.from(form.elements || []).forEach((field) => {
        if (!field.name || !field.name.endsWith(` ${otherSideLabel}]`)) return;
        field.required = false;
      });

      Object.entries(properties).forEach(([key, value]) => {
        if (isSideProperty(key)) return;
        setNamedFieldValue(form, `properties[${key} ${sideLabel}]`, value);
      });
    };

    [0, 80, 220, 500].forEach((delay) => setTimeout(applyValues, delay));
  }

  function prefillSimpleProperties(form, payload) {
    Object.entries(payload.properties || {}).forEach(([key, value]) => {
      if (isSideProperty(key)) return;
      setNamedFieldValue(form, `properties[${key}]`, value);
    });
  }

  function insertCartEditNotice(form) {
    return;
  }

  function ensureCartEditTokenField(form) {
    const token = getCartEditToken();
    if (!form || !token) return;

    let field = Array.from(form.elements || []).find((element) => element.name === 'properties[_cart_edit_token]');
    if (!field) {
      field = document.createElement('input');
      field.type = 'hidden';
      field.name = 'properties[_cart_edit_token]';
      form.appendChild(field);
    }
    field.value = token;
  }

  function updateProductEditButtons() {
    document.querySelectorAll('button[name="add"]').forEach((button) => {
      const label = button.querySelector('span');
      if (label) {
        label.textContent = 'Update cart';
      } else {
        button.textContent = 'Update cart';
      }
    });

    document.querySelectorAll('[data-city-sticky-submit]').forEach((button) => {
      button.textContent = 'Update cart';
    });
  }

  function initProductCartEdit() {
    if (getCartEditKey()) clearCartEditState();
  }

  function parseInlineCustomProps(customProps) {
    if (!Array.isArray(customProps)) return [];

    return customProps
      .map((item) => {
        const parts = String(item || '').split(':');
        const key = (parts.shift() || '').trim();
        const values = parts
          .join(':')
          .split(',')
          .map((value) => value.trim())
          .filter(Boolean);

        if (!key || !values.length) return null;
        return { key, values };
      })
      .filter(Boolean);
  }

  function barePrescriptionValue(value) {
    return String(value || '').replace(String.fromCharCode(176), '').trim();
  }

  function getInlineFieldValues(fields, key) {
    return (fields.find((field) => field.key === key) || {}).values || [];
  }

  function getInlineSphereRules(state) {
    if (Array.isArray(state.rules)) return state.rules.filter((rule) => rule && rule.cylinders);
    if (state.rules && Array.isArray(state.rules.sphere_rules)) return state.rules.sphere_rules;
    return null;
  }

  function getInlineColourSphereRules(state) {
    if (Array.isArray(state.rules)) {
      return state.rules.filter((rule) => (
        rule
        && Array.isArray(rule.colours)
        && typeof rule.sphere_min === 'number'
        && typeof rule.sphere_max === 'number'
      ));
    }
    if (state.rules && Array.isArray(state.rules.colour_sphere_rules)) return state.rules.colour_sphere_rules;
    return [];
  }

  function getInlineOptionRules(state) {
    return state.rules && Array.isArray(state.rules.option_rules) ? state.rules.option_rules : [];
  }

  function getInlinePayloadVariantOptions(payload) {
    const values = {};
    (Array.isArray(payload && payload.options) ? payload.options : []).forEach((option) => {
      const name = String((option && option.name) || '').trim();
      if (name) values[name] = String(option.selected || '').trim();
    });
    return values;
  }

  function attachInlineVariantOptions(properties, payload) {
    Object.defineProperty(properties, '__cityVariantOptions', {
      value: getInlinePayloadVariantOptions(payload),
      enumerable: false,
      configurable: true,
    });
    return properties;
  }

  function getInlineRuleForSphere(state, properties = state.properties, side = '') {
    const sphereValue = readInlinePropertyValue(properties, 'Sphere Power', side) || properties['Sphere Power'];
    const sphere = parseFloat(barePrescriptionValue(sphereValue));
    const sphereRules = getInlineSphereRules(state);
    if (Number.isNaN(sphere) || !Array.isArray(sphereRules)) return null;

    return sphereRules.find((rule) => sphere >= rule.sphere_min && sphere <= rule.sphere_max) || null;
  }

  function getInlineValidCylinders(state, properties = state.properties, side = '') {
    const rule = getInlineRuleForSphere(state, properties, side);
    if (!rule || !rule.cylinders) return getInlineFieldValues(state.fields, 'Cylinder Power');
    return Object.keys(rule.cylinders);
  }

  function getInlineValidAxes(state, properties = state.properties, side = '') {
    const rule = getInlineRuleForSphere(state, properties, side);
    const allAxes = getInlineFieldValues(state.fields, 'Axis');
    if (!rule || !rule.cylinders) return allAxes;

    const cylinderValue = readInlinePropertyValue(properties, 'Cylinder Power', side) || properties['Cylinder Power'];
    const axes = rule.cylinders[cylinderValue];
    if (axes === undefined) return [];
    if (axes === 'all') return allAxes;

    const validAxes = axes.map(barePrescriptionValue);
    return allAxes.filter((axis) => validAxes.includes(barePrescriptionValue(axis)));
  }

  function matchesInlineRuleDependency(properties, dependencyKey, allowedValues, side = '') {
    const currentValue = readInlinePropertyValue(properties, dependencyKey, side) || properties[dependencyKey] || '';
    if (!currentValue || !Array.isArray(allowedValues)) return false;
    const bareCurrentValue = barePrescriptionValue(currentValue);
    return allowedValues.map(barePrescriptionValue).includes(bareCurrentValue);
  }

  function applyInlineOptionRules(state, key, values, properties = state.properties, side = '') {
    if (!Array.isArray(values) || !values.length) return values;
    const optionRules = getInlineOptionRules(state);
    if (!optionRules.length) return values;

    let nextValues = values.slice();
    optionRules.forEach((rule) => {
      if (!rule || rule.field !== key || !Array.isArray(rule.allowed_values)) return;
      const dependencies = rule.depends_on || {};
      const matches = Object.keys(dependencies).every((dependencyKey) => (
        matchesInlineRuleDependency(properties, dependencyKey, dependencies[dependencyKey], side)
      ));
      if (!matches) return;

      const bareAllowed = rule.allowed_values.map(barePrescriptionValue);
      nextValues = nextValues.filter((value) => bareAllowed.includes(barePrescriptionValue(value)));
    });

    return nextValues;
  }

  function applyInlineColourSphereRules(state, values, properties = state.properties, side = '') {
    if (!Array.isArray(values) || !values.length) return values;
    const colourRules = getInlineColourSphereRules(state);
    if (!colourRules.length) return values;

    const selectedColour = readInlinePropertyValue(properties, 'Colour', side) || properties.Colour || '';
    if (!selectedColour) return values;

    const bareSelectedColour = barePrescriptionValue(selectedColour);
    const matchingRule = colourRules.find((rule) => (
      Array.isArray(rule.colours) && rule.colours.map(barePrescriptionValue).includes(bareSelectedColour)
    ));
    if (!matchingRule) return values;

    return values.filter((value) => {
      const numericValue = parseFloat(barePrescriptionValue(value));
      return !Number.isNaN(numericValue)
        && numericValue >= matchingRule.sphere_min
        && numericValue <= matchingRule.sphere_max;
    });
  }

  function getInlineValuesForField(state, key, properties = state.properties, side = '') {
    if (key === 'Cylinder Power') {
      return applyInlineOptionRules(state, key, getInlineValidCylinders(state, properties, side), properties, side);
    }
    if (key === 'Axis') {
      return applyInlineOptionRules(state, key, getInlineValidAxes(state, properties, side), properties, side);
    }
    let values = getInlineFieldValues(state.fields, key);
    if (key === 'Sphere Power' && properties.__cityVariantOptions?.['Lens Type'] === 'Plano') {
      values = values.filter((value) => /^[+-]?0(?:\.0+)?$/.test(String(value).trim()));
    }
    if (key === 'Sphere Power') values = applyInlineColourSphereRules(state, values, properties, side);
    return applyInlineOptionRules(state, key, values, properties, side);
  }

  function updateInlineSelectOptions(select, values, selectedValue) {
    const previousValue = selectedValue || select.value || '';
    select.innerHTML = '';

    if (values.length !== 1) {
      const placeholder = document.createElement('option');
      placeholder.value = '';
      placeholder.textContent = '-';
      select.appendChild(placeholder);
    }

    values.forEach((value) => {
      const option = document.createElement('option');
      option.value = value;
      option.textContent = value;
      select.appendChild(option);
    });

    select.value = values.includes(previousValue) ? previousValue : values.length === 1 ? values[0] : '';
  }

  function findInlinePropertySelect(form, key) {
    return Array.from(form.querySelectorAll('[data-city-inline-property]')).find(
      (select) => select.dataset.cityInlineProperty === key
    );
  }

  function refreshInlineDependentFields(form, state) {
    const cylinderSelect = findInlinePropertySelect(form, 'Cylinder Power');
    if (cylinderSelect) {
      updateInlineSelectOptions(cylinderSelect, getInlineValuesForField(state, 'Cylinder Power'), state.properties['Cylinder Power']);
      state.properties['Cylinder Power'] = cylinderSelect.value;
    }

    const axisSelect = findInlinePropertySelect(form, 'Axis');
    if (axisSelect) {
      updateInlineSelectOptions(axisSelect, getInlineValuesForField(state, 'Axis'), state.properties.Axis);
      state.properties.Axis = axisSelect.value;
    }
  }

  function findInlineEyePropertySelect(form, lineIndex, key) {
    return Array.from(form.querySelectorAll('[data-city-inline-property]')).find((select) => (
      select.dataset.cityInlineLineIndex === String(lineIndex)
      && select.dataset.cityInlineProperty === key
    ));
  }

  function refreshInlineEyeDependentFields(form, state, lineIndex, changedKey = '') {
    const line = state.lines[lineIndex];
    if (!line) return;

    const sphereSelect = findInlineEyePropertySelect(form, lineIndex, 'Sphere Power');
    if ((!changedKey || changedKey === 'Colour') && sphereSelect) {
      updateInlineSelectOptions(sphereSelect, getInlineValuesForField(state, 'Sphere Power', line.properties, line.side), readInlinePropertyValue(line.properties, 'Sphere Power', line.side));
      writeInlinePropertyValue(line.properties, 'Sphere Power', sphereSelect.value, line.side);
    }

    const cylinderSelect = findInlineEyePropertySelect(form, lineIndex, 'Cylinder Power');
    if ((!changedKey || changedKey === 'Colour' || changedKey === 'Sphere Power') && cylinderSelect) {
      updateInlineSelectOptions(cylinderSelect, getInlineValuesForField(state, 'Cylinder Power', line.properties, line.side), readInlinePropertyValue(line.properties, 'Cylinder Power', line.side));
      writeInlinePropertyValue(line.properties, 'Cylinder Power', cylinderSelect.value, line.side);
    }

    const axisSelect = findInlineEyePropertySelect(form, lineIndex, 'Axis');
    if (axisSelect) {
      updateInlineSelectOptions(axisSelect, getInlineValuesForField(state, 'Axis', line.properties, line.side), readInlinePropertyValue(line.properties, 'Axis', line.side));
      writeInlinePropertyValue(line.properties, 'Axis', axisSelect.value, line.side);
    }
  }

  function createInlineSelectField(labelText, selectName, values, selectedValue) {
    const label = document.createElement('label');
    label.className = 'city-cart-inline-editor__field';

    const labelSpan = document.createElement('span');
    labelSpan.textContent = labelText;

    const select = document.createElement('select');
    select.name = selectName;
    select.required = true;
    updateInlineSelectOptions(select, values, selectedValue);

    label.append(labelSpan, select);
    return { label, select };
  }

  function normalizeInlineSide(value) {
    const text = String(value || '').toLowerCase();
    if (text.includes('both')) return 'both';
    if (text.includes('right') || text === 'r' || text === 'od') return 'right';
    if (text.includes('left') || text === 'l' || text === 'os') return 'left';
    return '';
  }

  function getInlineSideLabel(side) {
    return side === 'both' ? 'Both Eyes' : side === 'right' ? 'Right Eye' : side === 'left' ? 'Left Eye' : 'Eye';
  }

  function getInlinePropertyAlias(key) {
    const normalized = normalizeContactLensKey(key);
    if (normalized === 'spherepower' || normalized === 'sphere' || normalized === 'sph' || normalized === 'power') {
      return ['Sphere Power', 'Sphere', 'SPH', 'Power'];
    }
    if (normalized === 'cylinderpower' || normalized === 'cylinder' || normalized === 'cyl') {
      return ['Cylinder Power', 'Cylinder', 'CYL'];
    }
    if (normalized === 'axis') return ['Axis'];
    if (normalized === 'add' || normalized === 'addpower' || normalized === 'addition') {
      return ['Add', 'ADD', 'Addition', 'Add Power'];
    }
    if (normalized === 'basecurve' || normalized === 'bc') return ['Base Curve', 'BC'];
    if (normalized === 'diameter' || normalized === 'dia') return ['Diameter', 'DIA'];
    if (normalized.includes('dominance') || normalized.includes('dominant') || normalized.includes('distancenear')) {
      return ['Dominance', 'Dominant Eye', 'Distance/Near', 'Distance Near', 'Distance', 'Near'];
    }
    return [key];
  }

  function getInlineSidePropertyAliases(key, side = '') {
    const aliases = getInlinePropertyAlias(key);
    const sideLabels = side === 'right'
      ? ['Right', 'Right Eye', 'R', 'OD']
      : side === 'left'
        ? ['Left', 'Left Eye', 'L', 'OS']
        : [];
    if (!sideLabels.length) return aliases;

    const sideAliases = [];
    sideLabels.forEach((sideLabel) => {
      aliases.forEach((alias) => {
        sideAliases.push(`${alias} ${sideLabel}`);
        sideAliases.push(`${sideLabel} ${alias}`);
      });
    });
    return sideAliases.concat(aliases);
  }

  function findInlinePropertyKey(properties, aliases) {
    const keys = Object.keys(properties || {});
    for (const alias of aliases) {
      const normalizedAlias = normalizeContactLensKey(alias);
      const match = keys.find((propertyKey) => normalizeContactLensKey(propertyKey) === normalizedAlias);
      if (match) return match;
    }
    return '';
  }

  function readInlinePropertyValue(properties, key, side = '') {
    const aliases = getInlineSidePropertyAliases(key, side);
    const match = findInlinePropertyKey(properties, aliases);
    return match ? normalizeContactLensText(properties[match]) : '';
  }

  function writeInlinePropertyValue(properties, key, value, side = '') {
    const aliases = getInlineSidePropertyAliases(key, side);
    const existingKey = findInlinePropertyKey(properties, aliases);
    properties[existingKey || key] = value;
  }

  function isInlineFittingField(field) {
    const normalized = normalizeContactLensKey(field && field.key);
    return normalized === 'basecurve' || normalized === 'bc' || normalized === 'diameter' || normalized === 'dia';
  }

  function isInlineFixedFittingField(field) {
    return isInlineFittingField(field) && Array.isArray(field.values) && field.values.length === 1;
  }

  function getInlineFixedFittingMetaText(line, fields) {
    const parts = [];
    fields.filter(isInlineFixedFittingField).forEach((field) => {
      const normalized = normalizeContactLensKey(field.key);
      const value = readInlinePropertyValue(line.properties, field.key, line.side) || field.values[0] || '';
      if (!value) return;
      if (normalized === 'basecurve' || normalized === 'bc') parts.push(`BC ${value}`);
      if (normalized === 'diameter' || normalized === 'dia') parts.push(`DIA ${value}`);
    });
    return parts.length ? `${parts.join(' \u00b7 ')} fixed` : '';
  }

  function sortInlinePrescriptionFields(fields) {
    const order = ['spherepower', 'sphere', 'sph', 'power', 'cylinderpower', 'cylinder', 'cyl', 'axis', 'add', 'addpower', 'addition', 'dominance', 'dominanteye', 'distancenear', 'design', 'basecurve', 'bc', 'diameter', 'dia'];
    return fields
      .filter((field) => field && field.key && !isSideProperty(field.key))
      .slice()
      .sort((a, b) => {
        const aIndex = order.indexOf(normalizeContactLensKey(a.key));
        const bIndex = order.indexOf(normalizeContactLensKey(b.key));
        return (aIndex === -1 ? 99 : aIndex) - (bIndex === -1 ? 99 : bIndex);
      });
  }

  function getCartEditPayloadForLine(line) {
    const editLink = document.querySelector(`#CartDrawer-Item-${line} [data-city-cart-edit-link]`);
    if (!editLink) return null;
    try {
      return JSON.parse(editLink.dataset.cityCartEditPayload || '{}');
    } catch (error) {
      console.warn('Cart edit payload could not be parsed.', error);
      return null;
    }
  }

  function buildInlinePrescriptionLines(payloads) {
    return payloads
      .filter(Boolean)
      .map((payload) => {
        const properties = attachInlineVariantOptions({ ...(payload.properties || {}) }, payload);
        const side = normalizeInlineSide(getLineSide(properties));
        return {
          payload,
          side,
          properties,
          originalQuantity: Math.max(parseInt(payload.quantity || '1', 10) || 1, 1),
          quantity: Math.max(parseInt(payload.quantity || '1', 10) || 1, 1),
        };
      })
      .filter((line) => line.payload && line.payload.key);
  }

  function getInlineEditorQuantity(payload) {
    const quantityInput = payload.line ? document.getElementById(`Drawer-quantity-${payload.line}`) : null;
    const quantity = parseInt((quantityInput && quantityInput.value) || payload.quantity || '1', 10);
    return Math.max(quantity || 1, 1);
  }

  function closeInlinePrescriptionEditor(trigger = null) {
    const host = trigger
      ? trigger.closest('[data-city-contact-lens-editor], [data-city-inline-editor]')
      : document.querySelector('[data-city-inline-editor]');
    if (!host) return;
    const card = host.closest('.city-contact-lens-card');
    if (card) card.classList.remove('is-editing');
    host.hidden = true;
    host.innerHTML = '';
    document.querySelectorAll('[data-city-contact-lens-edit][aria-expanded="true"]').forEach((button) => {
      button.setAttribute('aria-expanded', 'false');
    });
  }

  function showInlineCartEditError(messageText) {
    const host = document.querySelector('[data-city-inline-editor]');
    if (!host) return;

    host.innerHTML = '';
    host.hidden = false;

    const message = document.createElement('p');
    message.className = 'city-cart-inline-editor__message';
    message.textContent = messageText || 'This item could not be edited in the cart. Please try again.';
    host.appendChild(message);
    host.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
  }

  function getInlineVariantEditorLabels(payload) {
    const options = Array.isArray(payload.options) ? payload.options : [];
    const firstOptionName = String((options[0] && options[0].name) || '').toLowerCase();
    const isColourOnly = options.length === 1 && (firstOptionName.includes('colour') || firstOptionName.includes('color'));

    return {
      title: isColourOnly ? 'Change colour' : 'Change options',
      save: isColourOnly ? 'Save colour' : 'Save options',
      error: isColourOnly ? 'Please choose a colour first.' : 'Please choose all options first.',
    };
  }

  function getInlineOptionLabel(optionName) {
    const normalized = String(optionName || '').trim().toLowerCase();
    if (normalized === 'color' || normalized === 'colour') return 'Colour';
    return optionName || '';
  }

  function normalizeInlineVariantPayload(payload) {
    if (!payload || !payload.isSunglasses) return payload;

    const options = Array.isArray(payload.options) ? payload.options : [];
    const variants = Array.isArray(payload.variants) ? payload.variants : [];
    const colourIndex = options.findIndex((option) => {
      const name = String((option && option.name) || '').toLowerCase();
      return name.includes('colour') || name.includes('color');
    });
    const lensIndex = getInlineLensOptionIndex(payload);
    const lensOptionValue = String((payload.properties && payload.properties['Lens Option']) || '');

    if (lensIndex >= 0 && normalizeInlineLensOption(lensOptionValue) === 'custom-polarised') {
      const lensOption = options[lensIndex];
      if (lensOption) {
        lensOption.selected = lensOptionValue;
        lensOption.values = Array.isArray(lensOption.values) ? lensOption.values.slice() : [];
        if (!lensOption.values.includes(lensOptionValue)) {
          lensOption.values.push(lensOptionValue);
        }
      }
    }

    if (colourIndex >= 0) {
      const colourOption = options[colourIndex];
      const selectedLensValue = lensIndex >= 0 ? (options[lensIndex] && options[lensIndex].selected) || '' : '';
      const selectedColourValue = (colourOption && colourOption.selected) || '';
      const colourVariants = variants
        .filter((variant) => {
          const variantOptions = Array.isArray(variant.options) ? variant.options : [];
          if (lensIndex < 0) return true;
          return variantOptions[lensIndex] === selectedLensValue;
        })
        .map((variant) => {
          const variantOptions = Array.isArray(variant.options) ? variant.options : [];
          return {
            ...variant,
            options: [variantOptions[colourIndex]].filter(Boolean),
          };
        })
        .filter((variant) => variant.options.length);
      const colourValues = colourVariants
        .map((variant) => variant.options[0])
        .filter((value, index, values) => value && values.indexOf(value) === index);

      payload.options = [
        {
          ...colourOption,
          values: colourValues.length ? colourValues : colourOption.values,
          selected: selectedColourValue,
        },
      ];
      payload.variants = colourVariants.length ? colourVariants : variants;
    }

    return payload;
  }

  function findInlineVariant(payload, selectedOptions) {
    const variants = Array.isArray(payload.variants) ? payload.variants : [];
    const lensIndex = getInlineLensOptionIndex(payload);

    if (lensIndex >= 0 && normalizeInlineLensOption(selectedOptions[lensIndex]) === 'custom-polarised') {
      const standardOptions = selectedOptions.slice();
      standardOptions[lensIndex] = 'Standard';
      const standardVariant = variants.find((variant) => {
        const variantOptions = Array.isArray(variant.options) ? variant.options : [];
        return variantOptions.length === standardOptions.length && variantOptions.every((option, index) => option === standardOptions[index]);
      });
      if (standardVariant) {
        return {
          ...standardVariant,
          options: selectedOptions.slice(),
          cityCustomPolarisedBaseVariantId: standardVariant.id,
        };
      }
    }

    return variants.find((variant) => {
      const variantOptions = Array.isArray(variant.options) ? variant.options : [];
      return variantOptions.length === selectedOptions.length && variantOptions.every((option, index) => option === selectedOptions[index]);
    });
  }

  function getInlineValidOptionValues(payload, optionIndex, selectedOptions) {
    const option = payload.options && payload.options[optionIndex];
    const optionValues = Array.isArray(option && option.values) ? option.values : [];
    const variants = Array.isArray(payload.variants) ? payload.variants : [];
    const lensIndex = getInlineLensOptionIndex(payload);

    return optionValues.filter((value) =>
      variants.some((variant) => {
        const variantOptions = Array.isArray(variant.options) ? variant.options : [];
        if (optionIndex === lensIndex && normalizeInlineLensOption(value) === 'custom-polarised') {
          if (variantOptions[optionIndex] !== 'Standard') return false;
        } else if (variantOptions[optionIndex] !== value) {
          return false;
        }

        return selectedOptions.every((selectedValue, index) => {
          if (index === optionIndex || !selectedValue) return true;
          if (index === lensIndex && normalizeInlineLensOption(selectedValue) === 'custom-polarised') {
            return variantOptions[index] === 'Standard';
          }
          return variantOptions[index] === selectedValue;
        });
      })
    );
  }

  function syncInlineVariantOptionChoices(form) {
    const state = form._cityInlineVariantState;
    if (!state) return;

    const selects = Array.from(form.querySelectorAll('[data-city-inline-option]'));
    selects.forEach((select, index) => {
      const selectedOptions = getInlineSelectedOptions(form);
      const values = getInlineValidOptionValues(state.payload, index, selectedOptions);
      const payloadOption = state.payload.options && state.payload.options[index];
      updateInlineSelectOptions(select, values, select.value || (payloadOption && payloadOption.selected) || '');
    });
  }

  function normalizeInlineLensOption(value) {
    if (/custom.*polar/i.test(value || '')) return 'custom-polarised';
    if (/polar/i.test(value || '')) return 'original-polarised';
    return 'standard';
  }

  function getInlineLensOptionIndex(payload) {
    const options = Array.isArray(payload.options) ? payload.options : [];
    return options.findIndex((option) => String((option && option.name) || '').toLowerCase().includes('lens'));
  }

  function getInlineCustomTintPropertyName(payload) {
    return (payload && payload.customTintPropertyName) || 'Custom polarised lens colour';
  }

  function getInlineCustomTintOptions(payload) {
    const options = Array.isArray(payload && payload.customTintOptions) ? payload.customTintOptions.filter(Boolean) : [];
    return options.length ? options : ['Grey solid tint', 'Brown solid tint'];
  }

  function getInlineCurrentCustomTint(payload) {
    const properties = (payload && payload.properties) || {};
    return properties[getInlineCustomTintPropertyName(payload)] || '';
  }

  function getInlineSelectedOptions(form) {
    return Array.from(form.querySelectorAll('[data-city-inline-option]')).map((select) => select.value);
  }

  function inlineSelectionRequiresCustomTint(payload, selectedOptions) {
    if (!payload || !payload.isSunglasses) return false;
    const lensIndex = getInlineLensOptionIndex(payload);
    if (lensIndex < 0) return false;
    return normalizeInlineLensOption(selectedOptions[lensIndex]) === 'custom-polarised';
  }

  function updateInlineCustomTintField(form, selectedOptions) {
    const state = form._cityInlineVariantState;
    const tintSelect = form.querySelector('[data-city-inline-custom-tint]');
    if (!state || !tintSelect) {
      return { required: false, value: '', changed: false };
    }

    const required = inlineSelectionRequiresCustomTint(state.payload, selectedOptions);
    const field = tintSelect.closest('.city-cart-inline-editor__field');
    const currentValue = getInlineCurrentCustomTint(state.payload);

    if (field) field.hidden = !required;
    tintSelect.disabled = !required;
    tintSelect.required = required;

    if (required && !tintSelect.value && currentValue) tintSelect.value = currentValue;
    if (!required) tintSelect.value = '';

    return {
      required,
      value: tintSelect.value,
      changed: required && tintSelect.value !== currentValue,
    };
  }

  function buildInlineVariantProperties(state, form) {
    const properties = { ...(state.payload.properties || {}) };
    const selectedOptions = getInlineSelectedOptions(form);
    const selectedVariant = findInlineVariant(state.payload, selectedOptions);
    const tintSelect = form.querySelector('[data-city-inline-custom-tint]');
    const tintPropertyName = getInlineCustomTintPropertyName(state.payload);

    if (inlineSelectionRequiresCustomTint(state.payload, selectedOptions)) {
      properties['Lens Option'] = 'Custom Polarised Upgrade';
      if (tintSelect && tintSelect.value) properties[tintPropertyName] = tintSelect.value;
    } else {
      delete properties['Lens Option'];
      delete properties[tintPropertyName];
    }

    if (state.payload.isSunglasses) {
      if (selectedVariant && selectedVariant.frameCode) {
        properties['Frame code'] = selectedVariant.frameCode;
      } else {
        delete properties['Frame code'];
      }
    }

    return properties;
  }

  function updateInlineVariantState(form) {
    const state = form._cityInlineVariantState;
    if (!state) return;

    syncInlineVariantOptionChoices(form);
    const selectedOptions = getInlineSelectedOptions(form);
    const selectedVariant = findInlineVariant(state.payload, selectedOptions);
    const tintState = updateInlineCustomTintField(form, selectedOptions);
    const saveButton = form.querySelector('[type="submit"]');
    const message = form.querySelector('[data-city-inline-editor-message]');
    const sameVariant = selectedVariant && String(selectedVariant.id) === String(state.payload.variantId);
    const missingTint = tintState.required && !tintState.value;
    const customPolarisedDifferentVariant =
      tintState.required && selectedVariant && String(selectedVariant.id) !== String(state.payload.variantId);

    state.selectedVariant = selectedVariant || null;

    if (saveButton) {
      saveButton.disabled = !selectedVariant || !selectedVariant.available || missingTint || customPolarisedDifferentVariant || (sameVariant && !tintState.changed);
    }
    if (message) {
      if (!selectedVariant) {
        message.textContent = state.labels.error;
      } else if (!selectedVariant.available) {
        message.textContent = 'That colour is currently out of stock.';
      } else if (missingTint) {
        message.textContent = 'Please choose a custom polarised lens colour.';
      } else if (customPolarisedDifferentVariant) {
        message.textContent = 'To change colour with Custom Polarised Upgrade, remove this item and choose the new colour from the product page.';
      } else if (sameVariant && !tintState.changed) {
        message.textContent = 'This option is already in your cart.';
      } else {
        message.textContent = '';
      }
    }
  }

  function openInlineVariantEditor(payload, trigger) {
    payload = normalizeInlineVariantPayload(payload);

    const host = document.querySelector('[data-city-inline-editor]');
    const options = Array.isArray(payload.options) ? payload.options.filter((option) => Array.isArray(option.values) && option.values.length) : [];
    const variants = Array.isArray(payload.variants) ? payload.variants : [];
    if (!host || !options.length || !variants.length) return false;

    const labels = getInlineVariantEditorLabels(payload);
    const state = { payload, labels, selectedVariant: null };

    host.innerHTML = '';
    host.hidden = false;

    const form = document.createElement('form');
    form.className = 'city-cart-inline-editor__form';
    form.dataset.cityInlineVariantForm = 'true';
    form._cityInlineVariantState = state;
    form.addEventListener('change', (event) => {
      event.stopPropagation();
    });

    const header = document.createElement('div');
    header.className = 'city-cart-inline-editor__header';

    const title = document.createElement('strong');
    title.textContent = labels.title;

    const closeButton = document.createElement('button');
    closeButton.type = 'button';
    closeButton.className = 'city-cart-inline-editor__close';
    closeButton.dataset.cityInlineEditorClose = 'true';
    closeButton.setAttribute('aria-label', `Close ${labels.title.toLowerCase()} editor`);
    closeButton.textContent = 'x';

    header.append(title, closeButton);
    form.appendChild(header);

    const grid = document.createElement('div');
    grid.className = 'city-cart-inline-editor__grid';

    options.forEach((option, index) => {
      const fieldControl = createInlineSelectField(getInlineOptionLabel(option.name), option.name, option.values, option.selected);
      fieldControl.select.dataset.cityInlineOption = String(index);
      fieldControl.select.addEventListener('change', () => updateInlineVariantState(form));
      grid.appendChild(fieldControl.label);
    });

    if (payload.isSunglasses && getInlineLensOptionIndex(payload) >= 0) {
      const tintField = createInlineSelectField(
        'Lens Colour',
        getInlineCustomTintPropertyName(payload),
        getInlineCustomTintOptions(payload),
        getInlineCurrentCustomTint(payload)
      );
      tintField.select.dataset.cityInlineCustomTint = 'true';
      tintField.select.addEventListener('change', () => updateInlineVariantState(form));
      tintField.label.hidden = true;
      grid.appendChild(tintField.label);
    }

    form.appendChild(grid);

    const message = document.createElement('p');
    message.className = 'city-cart-inline-editor__message';
    message.dataset.cityInlineEditorMessage = 'true';
    form.appendChild(message);

    const actions = document.createElement('div');
    actions.className = 'city-cart-inline-editor__actions';

    const cancelButton = document.createElement('button');
    cancelButton.type = 'button';
    cancelButton.className = 'city-cart-inline-editor__cancel';
    cancelButton.dataset.cityInlineEditorClose = 'true';
    cancelButton.textContent = 'Cancel';

    const saveButton = document.createElement('button');
    saveButton.type = 'submit';
    saveButton.className = 'city-cart-inline-editor__save';
    saveButton.textContent = labels.save;

    actions.append(cancelButton, saveButton);
    form.appendChild(actions);
    host.appendChild(form);

    updateInlineVariantState(form);
    host.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    saveButton.focus({ preventScroll: true });

    if (trigger) trigger.setAttribute('aria-expanded', 'true');
    return true;
  }

  function createInlinePrescriptionControl(form, state, line, lineIndex, field) {
    const fieldValues = getInlineValuesForField(state, field.key, line.properties, line.side);
    const selectedValue = readInlinePropertyValue(line.properties, field.key, line.side);

    if (isInlineFixedFittingField(field)) return null;

    const fieldControl = createInlineSelectField(field.key, field.key, fieldValues, selectedValue);
    fieldControl.select.dataset.cityInlineProperty = field.key;
    fieldControl.select.dataset.cityInlineLineIndex = String(lineIndex);
    fieldControl.select.addEventListener('change', () => {
      writeInlinePropertyValue(line.properties, field.key, fieldControl.select.value, line.side);
      if (field.key === 'Colour') {
        writeInlinePropertyValue(line.properties, 'Sphere Power', '', line.side);
        writeInlinePropertyValue(line.properties, 'Cylinder Power', '', line.side);
        writeInlinePropertyValue(line.properties, 'Axis', '', line.side);
        refreshInlineEyeDependentFields(form, state, lineIndex, field.key);
      }
      if (field.key === 'Sphere Power') {
        writeInlinePropertyValue(line.properties, 'Cylinder Power', '', line.side);
        writeInlinePropertyValue(line.properties, 'Axis', '', line.side);
        refreshInlineEyeDependentFields(form, state, lineIndex, field.key);
      }
      if (field.key === 'Cylinder Power') {
        writeInlinePropertyValue(line.properties, 'Axis', '', line.side);
        refreshInlineEyeDependentFields(form, state, lineIndex, field.key);
      }
    });
    return fieldControl.label;
  }

  function createInlinePrescriptionQuantityControl(line, section) {
    const sideLabel = getInlineSideLabel(line.side);
    const wrap = document.createElement('div');
    wrap.className = 'city-cart-inline-editor__quantity-row';

    const label = document.createElement('span');
    label.textContent = 'Quantity';

    const control = document.createElement('span');
    control.className = 'city-contact-lens-card__qty';

    const minus = document.createElement('button');
    minus.type = 'button';
    minus.textContent = '-';
    minus.setAttribute('aria-label', `Decrease ${sideLabel} quantity`);

    const value = document.createElement('span');
    value.textContent = String(line.quantity);

    const plus = document.createElement('button');
    plus.type = 'button';
    plus.textContent = '+';
    plus.setAttribute('aria-label', `Increase ${sideLabel} quantity`);

    const remove = document.createElement('button');
    remove.type = 'button';
    remove.className = 'city-cart-inline-editor__remove-eye';
    remove.dataset.cityRemoveMode = 'remove';

    const helper = document.createElement('p');
    helper.className = 'city-cart-inline-editor__remove-note';
    helper.textContent = 'This eye will be removed when you save changes.';
    helper.hidden = true;

    const setRemoveButtonState = (isRemoved) => {
      remove.dataset.cityRemoveMode = isRemoved ? 'undo' : 'remove';
      remove.removeAttribute('title');
      remove.dataset.cityTooltip = isRemoved ? 'Keep this eye' : `Remove ${sideLabel} when saved`;
      remove.setAttribute('aria-label', isRemoved ? `Keep ${sideLabel}` : `Remove ${sideLabel} when changes are saved`);
      remove.innerHTML = isRemoved
        ? '<span>Undo remove</span>'
        : '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" aria-hidden="true" focusable="false" class="icon icon-remove"><path d="M14 3h-3.53a3.07 3.07 0 00-.6-1.65C9.44.82 8.8.5 8 .5s-1.44.32-1.87.85A3.06 3.06 0 005.53 3H2a.5.5 0 000 1h1.25v10c0 .28.22.5.5.5h8.5a.5.5 0 00.5-.5V4H14a.5.5 0 000-1zM6.91 1.98c.23-.29.58-.48 1.09-.48s.85.19 1.09.48c.2.24.3.6.36 1.02h-2.9c.05-.42.17-.78.36-1.02zm4.84 11.52h-7.5V4h7.5v9.5z" fill="currentColor"/><path d="M6.55 5.25a.5.5 0 00-.5.5v6a.5.5 0 001 0v-6a.5.5 0 00-.5-.5zM9.45 5.25a.5.5 0 00-.5.5v6a.5.5 0 001 0v-6a.5.5 0 00-.5-.5z" fill="currentColor"/></svg><span>Remove</span>';
    };

    const setQuantity = (nextQuantity) => {
      line.quantity = Math.max(parseInt(nextQuantity, 10) || 0, 0);
      value.textContent = String(line.quantity);
      const isRemoved = line.quantity === 0;
      section.classList.toggle('is-removed', isRemoved);
      helper.hidden = !isRemoved;
      setRemoveButtonState(isRemoved);
      section.querySelectorAll('select').forEach((select) => {
        select.disabled = isRemoved;
      });
    };

    minus.addEventListener('click', () => setQuantity(line.quantity - 1));
    plus.addEventListener('click', () => setQuantity(line.quantity + 1));
    remove.addEventListener('click', () => {
      if (line.quantity === 0) {
        setQuantity(line.originalQuantity || 1);
        return;
      }
      setQuantity(0);
    });

    setRemoveButtonState(line.quantity === 0);
    control.append(minus, value, plus);
    wrap.append(label, control, remove, helper);
    return wrap;
  }

  function createInlinePrescriptionEyeSection(form, state, line, lineIndex) {
    const section = document.createElement('section');
    section.className = 'city-cart-inline-editor__eye';

    const headingWrap = document.createElement('div');
    headingWrap.className = 'city-cart-inline-editor__eye-heading';

    const badge = document.createElement('span');
    badge.className = 'city-contact-lens-card__rx-label';
    badge.textContent = line.side === 'right' ? 'R' : line.side === 'left' ? 'L' : 'Rx';

    const headingText = document.createElement('div');
    headingText.className = 'city-cart-inline-editor__eye-title';

    const heading = document.createElement('h4');
    heading.textContent = getInlineSideLabel(line.side);
    headingText.appendChild(heading);

    const fittingMetaText = getInlineFixedFittingMetaText(line, state.fields);
    if (fittingMetaText) {
      const fittingMeta = document.createElement('span');
      fittingMeta.className = 'city-cart-inline-editor__eye-meta';
      fittingMeta.textContent = fittingMetaText;
      headingText.appendChild(fittingMeta);
    }

    headingWrap.append(badge, headingText);
    section.appendChild(headingWrap);

    if (line.payload.hasPrescriptionUpload) {
      const uploadNote = document.createElement('div');
      uploadNote.className = 'city-cart-inline-editor__upload-note';
      uploadNote.innerHTML = '<strong>Prescription: Uploaded</strong><span>To change your prescription, upload a new file or contact our team before ordering.</span>';
      section.appendChild(uploadNote);
      return section;
    }

    state.fields.forEach((field) => {
      const control = createInlinePrescriptionControl(form, state, line, lineIndex, field);
      if (control) section.appendChild(control);
    });

    section.appendChild(createInlinePrescriptionQuantityControl(line, section));

    return section;
  }

  function openInlinePrescriptionEditor(payload, trigger, groupedPayloads = null, hostOverride = null) {
    const host = hostOverride || document.querySelector('[data-city-inline-editor]');
    const lines = buildInlinePrescriptionLines(groupedPayloads || [payload]).sort((a, b) => {
      if (a.side === b.side) return 0;
      if (a.side === 'right') return -1;
      if (b.side === 'right') return 1;
      return 0;
    });
    const fields = sortInlinePrescriptionFields(parseInlineCustomProps(payload.customProps));
    if (!host || (!fields.length && !lines.some((line) => line.payload.hasPrescriptionUpload)) || !lines.length) return false;

    const state = {
      payload,
      lines,
      fields,
      properties: attachInlineVariantOptions({ ...(payload.properties || {}) }, payload),
      rules: payload.prescriptionRules || null,
    };

    document.querySelectorAll('[data-city-contact-lens-editor]').forEach((editor) => {
      if (editor !== host) {
        const editorCard = editor.closest('.city-contact-lens-card');
        if (editorCard) editorCard.classList.remove('is-editing');
        editor.hidden = true;
        editor.innerHTML = '';
      }
    });
    if (hostOverride) closeInlinePrescriptionEditor();

    host.innerHTML = '';
    host.hidden = false;
    const card = host.closest('.city-contact-lens-card');
    if (card) card.classList.add('is-editing');

    const form = document.createElement('form');
    form.className = `city-cart-inline-editor__form${hostOverride ? ' city-cart-inline-editor__form--card' : ''}`;
    form.dataset.cityInlineEditorForm = 'true';
    form._cityInlineState = state;
    form.addEventListener('change', (event) => {
      event.stopPropagation();
    });

    const header = document.createElement('div');
    header.className = 'city-cart-inline-editor__header';

    const headingWrap = document.createElement('div');
    headingWrap.className = 'city-cart-inline-editor__heading';

    const title = document.createElement('strong');
    if (lines.length === 1) {
      title.textContent = `Edit ${getInlineSideLabel(lines[0].side)} Prescription`;
    } else {
      title.textContent = 'Edit prescription';
    }

    const subtitle = document.createElement('p');
    subtitle.textContent = lines.length === 1
      ? 'Update the prescription details for this eye.'
      : 'Update the prescription details for each eye.';
    headingWrap.append(title, subtitle);

    const closeButton = document.createElement('button');
    closeButton.type = 'button';
    closeButton.className = 'city-cart-inline-editor__close';
    closeButton.dataset.cityInlineEditorClose = 'true';
    closeButton.setAttribute('aria-label', 'Close prescription editor');
    closeButton.textContent = 'X';

    header.append(headingWrap, closeButton);
    form.appendChild(header);

    const grid = document.createElement('div');
    grid.className = `city-cart-inline-editor__eye-grid${lines.length === 1 ? ' city-cart-inline-editor__eye-grid--single' : ''}`;

    lines.forEach((line, lineIndex) => {
      grid.appendChild(createInlinePrescriptionEyeSection(form, state, line, lineIndex));
    });

    form.appendChild(grid);

    const message = document.createElement('p');
    message.className = 'city-cart-inline-editor__message';
    message.dataset.cityInlineEditorMessage = 'true';
    form.appendChild(message);

    const actions = document.createElement('div');
    actions.className = 'city-cart-inline-editor__actions';

    const cancelButton = document.createElement('button');
    cancelButton.type = 'button';
    cancelButton.className = 'city-cart-inline-editor__cancel';
    cancelButton.dataset.cityInlineEditorClose = 'true';
    cancelButton.textContent = 'Cancel';

    const saveButton = document.createElement('button');
    saveButton.type = 'submit';
    saveButton.className = 'city-cart-inline-editor__save';
    saveButton.textContent = 'Save changes';

    actions.append(cancelButton, saveButton);
    form.appendChild(actions);
    host.appendChild(form);

    lines.forEach((line, lineIndex) => refreshInlineEyeDependentFields(form, state, lineIndex));
    host.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    saveButton.focus({ preventScroll: true });

    if (trigger) trigger.setAttribute('aria-expanded', 'true');
    return true;
  }

  function submitInlinePrescriptionEditor(form) {
    const state = form._cityInlineState;
    if (!state) return Promise.resolve();
    if (form.dataset.cityInlineSaving === 'true') return Promise.resolve();

    const invalidSelect = Array.from(form.querySelectorAll('select[required]:not(:disabled)')).find((select) => !select.value);
    const message = form.querySelector('[data-city-inline-editor-message]');
    if (invalidSelect) {
      if (message) message.textContent = 'Please complete all prescription fields first.';
      invalidSelect.focus();
      return Promise.resolve();
    }

    const invalidSupplierShade = (state.lines || []).some((line) => {
      if (line.quantity === 0) return false;
      const colour = barePrescriptionValue(readInlinePropertyValue(line.properties, 'Colour', line.side));
      const rule = getInlineColourSphereRules(state).find((item) => (
        (item.colours || []).map(barePrescriptionValue).includes(colour)
      ));
      if (!rule) return false;
      const rawPower = barePrescriptionValue(readInlinePropertyValue(line.properties, 'Sphere Power', line.side));
      const power = Number(rawPower);
      return !rawPower || !Number.isFinite(power) || power < rule.sphere_min || power > rule.sphere_max
        || (rule.sphere_min === 0 && rule.sphere_max === 0 && line.payload.hasPrescriptionUpload);
    });
    if (invalidSupplierShade) {
      if (message) message.textContent = 'This shade is available in Plano (0.00) only. Choose 0.00 or change the shade on the product page.';
      return Promise.resolve();
    }
    const submitButton = form.querySelector('[type="submit"]');
    const cancelButton = form.querySelector('[data-city-inline-editor-close]');
    const invalidPlano = (state.lines || []).some((line) => {
      if (line.quantity === 0 || getInlinePayloadVariantOptions(line.payload)['Lens Type'] !== 'Plano') return false;
      const sphere = readInlinePropertyValue(line.properties, 'Sphere Power', line.side);
      return !/^[+-]?0(?:\.0+)?$/.test(String(sphere || '').trim());
    });
    if (invalidPlano) {
      if (message) message.textContent = 'Colour-only lenses must use 0.00 power. Choose vision correction on the product page for powered lenses.';
      return Promise.resolve();
    }
    form.dataset.cityInlineSaving = 'true';
    form.classList.add('is-saving');
    if (submitButton) {
      submitButton.disabled = true;
      submitButton.textContent = 'Saving...';
    }
    if (cancelButton) cancelButton.disabled = true;
    if (message) message.textContent = '';

    const updates = (state.lines || [{ payload: state.payload, properties: state.properties }]).map((line) => {
      const nextProperties = { ...(line.payload.properties || {}) };
      const sideLabel = getInlineSideLabel(line.side);
      if (line.side) nextProperties.Side = sideLabel;

      Object.keys(line.properties || {}).forEach((key) => {
        if (!isSideProperty(key)) nextProperties[key] = line.properties[key];
      });

      return {
        payload: line.payload,
        quantity: Number.isFinite(Number(line.quantity)) ? Math.max(parseInt(line.quantity, 10) || 0, 0) : (line.originalQuantity || getInlineEditorQuantity(line.payload)),
        properties: nextProperties,
      };
    });

    const submitUpdate = (update) => fetch(routes.cart_change_url, {
      method: 'POST',
      cache: 'no-store',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
      },
      body: JSON.stringify({
        id: update.payload.key,
        quantity: update.quantity,
        properties: update.properties,
        sections: 'cart-drawer,cart-icon-bubble',
        sections_url: window.location.pathname,
      }),
    })
      .then((response) => response.json())
      .then((response) => {
        if (response.status) throw new Error(response.description || response.message || 'Unable to update prescription');
        return response;
      });

    return updates
      .reduce((promise, update) => promise.then(() => submitUpdate(update)), Promise.resolve())
      .then(() => {
        resetExpiryTimer();
        return new Promise((resolve) => {
          setTimeout(resolve, 120);
        }).then(() => refreshCartDrawer(false, 0));
      })
      .catch((error) => {
        console.warn('Prescription update failed.', error);
        if (message) message.textContent = "We couldn't update your prescription. Please try again.";
      })
      .finally(() => {
        delete form.dataset.cityInlineSaving;
        form.classList.remove('is-saving');
        if (submitButton) {
          submitButton.disabled = false;
          submitButton.textContent = 'Save changes';
        }
        if (cancelButton) cancelButton.disabled = false;
      });
  }

  function submitInlineVariantEditor(form) {
    const state = form._cityInlineVariantState;
    if (!state) return Promise.resolve();
    if (form.dataset.cityInlineSaving === 'true') return Promise.resolve();

    updateInlineVariantState(form);
    const selectedVariant = state.selectedVariant;
    const message = form.querySelector('[data-city-inline-editor-message]');
    const nextProperties = buildInlineVariantProperties(state, form);
    const selectedOptions = getInlineSelectedOptions(form);
    const sameVariant = selectedVariant && String(selectedVariant.id) === String(state.payload.variantId);
    const tintRequired = inlineSelectionRequiresCustomTint(state.payload, selectedOptions);
    const tintPropertyName = getInlineCustomTintPropertyName(state.payload);
    const tintChanged = tintRequired && nextProperties[tintPropertyName] !== getInlineCurrentCustomTint(state.payload);

    if (!selectedVariant || !selectedVariant.available || (tintRequired && !nextProperties[tintPropertyName]) || (sameVariant && !tintChanged)) {
      if (message && !message.textContent) message.textContent = state.labels.error;
      return Promise.resolve();
    }

    const quantity = getInlineEditorQuantity(state.payload);
    const submitButton = form.querySelector('[type="submit"]');
    form.dataset.cityInlineSaving = 'true';
    if (submitButton) {
      submitButton.disabled = true;
      submitButton.textContent = 'Saving...';
    }
    if (message) message.textContent = '';

    if (sameVariant) {
      return fetch(routes.cart_change_url, {
        method: 'POST',
        cache: 'no-store',
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
          'X-Requested-With': 'XMLHttpRequest',
        },
        body: JSON.stringify({
          id: state.payload.key,
          quantity,
          properties: nextProperties,
          sections: 'cart-drawer,cart-icon-bubble',
          sections_url: window.location.pathname,
        }),
      })
        .then((response) => response.json())
        .then((response) => {
          if (response.status) throw new Error(response.description || response.message || 'Unable to update colour');
          resetExpiryTimer();
          if (response.sections) return applyCartSections(response.sections, true);
          return refreshCartDrawer(true, 0);
        })
        .catch((error) => {
          if (message) message.textContent = error.message || 'Colour could not be updated. Please try again.';
        })
        .finally(() => {
          delete form.dataset.cityInlineSaving;
          if (submitButton) {
            submitButton.disabled = false;
            submitButton.textContent = state.labels.save;
          }
        });
    }

    return fetch(getCartAddAjaxUrl(), {
      method: 'POST',
      cache: 'no-store',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
      },
      body: JSON.stringify({
        id: selectedVariant.id,
        quantity,
        properties: nextProperties,
      }),
    })
      .then((response) => response.json())
      .then((response) => {
        if (response.status) throw new Error(response.description || response.message || 'Unable to update colour');

        return fetch(routes.cart_change_url, {
          method: 'POST',
          cache: 'no-store',
          credentials: 'same-origin',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
            'X-Requested-With': 'XMLHttpRequest',
          },
          body: JSON.stringify({
            id: state.payload.key,
            quantity: 0,
            sections: 'cart-drawer,cart-icon-bubble',
            sections_url: window.location.pathname,
          }),
        });
      })
      .then((response) => response.json())
      .then((response) => {
        if (response.status) throw new Error(response.description || response.message || 'Unable to update colour');
        resetExpiryTimer();
        if (response.sections) return applyCartSections(response.sections, true);
        return refreshCartDrawer(true, 0);
      })
      .catch((error) => {
        if (message) message.textContent = error.message || 'Colour could not be updated. Please try again.';
      })
      .finally(() => {
        delete form.dataset.cityInlineSaving;
        if (submitButton) {
          submitButton.disabled = false;
          submitButton.textContent = state.labels.save;
        }
      });
  }

  function handleCartEditLinkClick(event) {
    const editLink = event.target.closest('[data-city-cart-edit-link]');
    if (!editLink) return false;

    event.preventDefault();
    event.stopPropagation();

    let payload = null;
    try {
      payload = JSON.parse(editLink.dataset.cityCartEditPayload || '{}');
    } catch (error) {
      console.warn('Cart edit payload could not be parsed.', error);
      showInlineCartEditError('This item could not be edited in the cart. Please refresh and try again.');
      return true;
    }

    if (payload.isContact) {
      clearCartEditState();
      if (openInlinePrescriptionEditor(payload, editLink)) return true;
      showInlineCartEditError('Prescription editing could not be opened in the cart. Please refresh and try again.');
      return true;
    }

    if (payload.isSunglasses) {
      clearCartEditState();
      if (openInlineVariantEditor(payload, editLink)) return true;
    }

    if (payload.isLensReplacement) {
      clearCartEditState();
      if (openLensReplacementDrawerEditor(payload, editLink)) return true;
      storeLensReplacementCartEditPayload(payload);
      const drawer = document.querySelector('cart-drawer');
      if (drawer && typeof drawer.close === 'function') drawer.close();
      if (
        document.querySelector('#city-lens-rebuild') &&
        window.CityLensReplacementConfigurator &&
        typeof window.CityLensReplacementConfigurator.editFromCart === 'function'
      ) {
        window.CityLensReplacementConfigurator.editFromCart(payload);
        return true;
      }
      window.location.href = editLink.href;
      return true;
    }

    storeCartEditPayload(payload);
    window.location.href = editLink.href;
    return true;
  }

  function initDelegatedCartActions() {
    document.addEventListener('click', (event) => {
      handleCartEditLinkClick(event);
    }, true);

    document.addEventListener('click', (event) => {
      handleTransitProtectionRemoveClick(event);
    }, true);

    document.addEventListener('click', (event) => {
      const upsellButton = event.target.closest('[data-city-upsell-button]');
      if (!upsellButton) return;
      const upsellSource = upsellButton.closest('[data-city-upsell-form]') || upsellButton;

      event.preventDefault();
      event.stopPropagation();
      if (typeof event.stopImmediatePropagation === 'function') event.stopImmediatePropagation();
      submitUpsellForm(upsellSource);
    }, true);

    document.addEventListener('submit', (event) => {
      // Claim dynamically rendered estimator submissions before app/form
      // handlers can stop bubbling or fall through to a native navigation.
      const shippingForm = event.target.closest('[data-city-shipping-form]');
      if (shippingForm) {
        event.preventDefault();
        event.stopImmediatePropagation();
        estimateShipping(shippingForm, shippingForm.querySelector('[data-city-panel-message]'));
        return;
      }

      const upsellForm = event.target.closest('[data-city-upsell-form]');
      if (upsellForm) {
        event.preventDefault();
        event.stopPropagation();
        if (typeof event.stopImmediatePropagation === 'function') event.stopImmediatePropagation();
        submitUpsellForm(upsellForm);
        return;
      }

      const inlineEditorForm = event.target.closest('[data-city-inline-editor-form]');
      if (inlineEditorForm) {
        event.preventDefault();
        event.stopImmediatePropagation();
        submitInlinePrescriptionEditor(inlineEditorForm);
        return;
      }

      const inlineVariantForm = event.target.closest('[data-city-inline-variant-form]');
      if (inlineVariantForm) {
        event.preventDefault();
        event.stopImmediatePropagation();
        submitInlineVariantEditor(inlineVariantForm);
      }
    }, true);

    document.addEventListener('click', (event) => {
      const fullCartSubscription = document.querySelector('#main-cart-items .city-cart-selling-plan');
      const checkoutButton = event.target.closest(fullCartSubscription ? '#CartDrawer-Checkout, #checkout[form="cart"]' : '#CartDrawer-Checkout');
      if (checkoutButton) {
        event.preventDefault();
        goToCheckout(checkoutButton);
        return;
      }

      const cartTrigger = event.target.closest('#cart-icon-bubble');
      if (cartTrigger) {
        initCartEnhancements();
      }

      const upsellButton = event.target.closest('[data-city-upsell-button]');
      if (upsellButton) {
        event.preventDefault();
        event.stopPropagation();
        submitUpsellForm(upsellButton.closest('[data-city-upsell-form]') || upsellButton);
        return;
      }

      if (event.target.closest('#CartDrawer .quantity__button')) {
        scheduleTransitProtectionSync(1100, { openAfterRefresh: false });
      }

      const contactLensEyeQuantityButton = event.target.closest('[data-city-contact-lens-eye-qty-change]');
      if (contactLensEyeQuantityButton) {
        event.preventDefault();
        const key = contactLensEyeQuantityButton.dataset.cityContactLensKey;
        const item = (window.CityContactLensCartGroups || []).flat().find((groupItem) => groupItem.key === key);
        if (!item) return;
        const current = Math.max(Number(item.quantity || 0), 0);
        const nextQuantity = Math.max(current + Number(contactLensEyeQuantityButton.dataset.cityContactLensEyeQtyChange || 0), 0);
        updateContactLensItemQuantity(contactLensEyeQuantityButton, item, nextQuantity).catch(() => null);
        return;
      }

      const contactLensQuantityButton = event.target.closest('[data-city-contact-lens-qty-change]');
      if (contactLensQuantityButton) {
        event.preventDefault();
        const group = (window.CityContactLensCartGroups || [])[Number(contactLensQuantityButton.dataset.cityContactLensGroup || -1)];
        if (!group || !group.length) return;
        const current = parseInt(contactLensQuantityButton.parentElement.querySelector('span').textContent || '1', 10) || 1;
        const nextQuantity = Math.max(current + Number(contactLensQuantityButton.dataset.cityContactLensQtyChange || 0), 1);
        contactLensQuantityButton.closest('.city-contact-lens-card').classList.add('is-updating');
        updateContactLensGroupQuantities(group, nextQuantity).catch(() => {
          contactLensQuantityButton.closest('.city-contact-lens-card').classList.remove('is-updating');
        });
        return;
      }

      const contactLensEdit = event.target.closest('[data-city-contact-lens-edit]');
      if (contactLensEdit) {
        event.preventDefault();
        const line = Number(contactLensEdit.dataset.cityContactLensEdit || 0);
        const group = (window.CityContactLensCartGroups || []).find((items) => items.some((item) => Number(item.line || 0) === line));
        const card = contactLensEdit.closest('.city-contact-lens-card');
        const editorHost = card ? card.querySelector('[data-city-contact-lens-editor]') : null;
        if (group && group.length > 1) {
          const payloads = group
            .map((item) => getCartEditPayloadForLine(item.line))
            .filter(Boolean);
          if (payloads.length) {
            clearCartEditState();
            if (openInlinePrescriptionEditor(payloads[0], contactLensEdit, payloads, editorHost)) return;
          }
        }
        const editLink = document.querySelector(`#CartDrawer-Item-${line} [data-city-cart-edit-link]`);
        if (editLink && editorHost) {
          let payload = null;
          try {
            payload = JSON.parse(editLink.dataset.cityCartEditPayload || '{}');
          } catch (error) {
            payload = null;
          }
          if (payload && openInlinePrescriptionEditor(payload, contactLensEdit, [payload], editorHost)) return;
        }
        if (editLink) editLink.click();
        return;
      }

      const contactLensRemoveChoice = event.target.closest('[data-city-contact-lens-remove-choice]');
      if (contactLensRemoveChoice) {
        event.preventDefault();
        const index = contactLensRemoveChoice.dataset.cityContactLensRemoveChoice;
        const choice = document.querySelector(`[data-city-contact-lens-choice="${index}"]`);
        if (!choice) return;
        choice.hidden = !choice.hidden;
        contactLensRemoveChoice.setAttribute('aria-expanded', String(!choice.hidden));
        return;
      }

      const contactLensCancelChoice = event.target.closest('[data-city-contact-lens-cancel-choice]');
      if (contactLensCancelChoice) {
        event.preventDefault();
        const index = contactLensCancelChoice.dataset.cityContactLensCancelChoice;
        const choice = document.querySelector(`[data-city-contact-lens-choice="${index}"]`);
        const removeButton = document.querySelector(`[data-city-contact-lens-remove-choice="${index}"]`);
        if (choice) choice.hidden = true;
        if (removeButton) removeButton.setAttribute('aria-expanded', 'false');
        return;
      }

      const contactLensRemoveKey = event.target.closest('[data-city-contact-lens-remove-key]');
      if (contactLensRemoveKey) {
        event.preventDefault();
        const key = contactLensRemoveKey.dataset.cityContactLensRemoveKey;
        const item = (window.CityContactLensCartGroups || []).flat().find((groupItem) => groupItem.key === key);
        removeContactLensGroupWithLoading(contactLensRemoveKey, item ? [item] : [{ key }]);
        return;
      }

      const contactLensRemoveKeys = event.target.closest('[data-city-contact-lens-remove-keys]');
      if (contactLensRemoveKeys) {
        event.preventDefault();
        const items = String(contactLensRemoveKeys.dataset.cityContactLensRemoveKeys || '')
          .split('|')
          .filter(Boolean)
          .map((key) => ({ key }));
        if (items.length) removeContactLensGroupWithLoading(contactLensRemoveKeys, items);
        return;
      }

      const contactLensRemoveGroup = event.target.closest('[data-city-contact-lens-remove-group]');
      if (contactLensRemoveGroup) {
        event.preventDefault();
        const group = (window.CityContactLensCartGroups || [])[Number(contactLensRemoveGroup.dataset.cityContactLensRemoveGroup || -1)];
        if (group && group.length) removeContactLensGroupWithLoading(contactLensRemoveGroup, group);
        return;
      }

      const panelButton = event.target.closest('[data-city-cart-panel-trigger]');
      if (panelButton) {
        const panel = document.querySelector(`[data-city-cart-panel="${panelButton.dataset.cityCartPanelTrigger}"]`);
        if (!panel) return;
        document.querySelectorAll('[data-city-cart-panel]').forEach((item) => {
          if (item !== panel) item.classList.remove('is-active');
        });
        panel.classList.toggle('is-active');
        return;
      }

      const panelCloseButton = event.target.closest('[data-city-cart-panel-close]');
      if (panelCloseButton) {
        const panel = panelCloseButton.closest('[data-city-cart-panel]');
        if (panel) panel.classList.remove('is-active');
        return;
      }

      const editLink = event.target.closest('[data-city-cart-edit-link]');
      if (editLink) {
        handleCartEditLinkClick(event);
        return;
      }

      const addLensFrame = event.target.closest('[data-city-lens-add-frame]');
      if (addLensFrame) {
        event.preventDefault();
        let payload = null;
        try {
          payload = JSON.parse(addLensFrame.dataset.cityLensSourcePayload || '{}');
        } catch (error) {
          payload = null;
        }
        if (payload && openLensReplacementDrawerAdd(payload, addLensFrame)) return;
        window.location.href = '/pages/lens-replacement?add_frame=1#review-step';
        return;
      }

      const inlineEditorClose = event.target.closest('[data-city-inline-editor-close]');
      if (inlineEditorClose) {
        closeInlinePrescriptionEditor(inlineEditorClose);
        return;
      }

      const editCancelButton = event.target.closest('[data-city-cart-edit-cancel]');
      if (editCancelButton) {
        clearCartEditState();
        const editNotice = document.querySelector('[data-city-cart-edit-notice]');
        if (editNotice) editNotice.remove();
        document.querySelectorAll('button[name="add"]').forEach((button) => {
          const label = button.querySelector('span');
          if (label && window.variantStrings && window.variantStrings.addToCart) {
            label.textContent = window.variantStrings.addToCart;
          }
        });
        return;
      }

      const overlay = event.target.closest('#CartDrawer-Overlay');
      if (overlay) {
        const drawer = document.querySelector('cart-drawer');
        if (drawer && typeof drawer.close === 'function') drawer.close();
      }
    });

    document.addEventListener('submit', (event) => {
      if (event.target && event.target.id === 'CartDrawer-Form' && event.submitter && event.submitter.name === 'checkout') {
        event.preventDefault();
        goToCheckout(event.submitter);
        return;
      }

      const discountForm = event.target.closest('[data-city-discount-form]');
      if (discountForm) {
        event.preventDefault();
        applyDiscount(discountForm.querySelector('[name="discount"]').value, discountForm.querySelector('[data-city-panel-message]'));
        return;
      }

      const upsellForm = event.target.closest('[data-city-upsell-form]');
      if (!upsellForm) return;

      event.preventDefault();
      event.stopPropagation();
      submitUpsellForm(upsellForm);
    });

    document.addEventListener('change', (event) => {
      if (!event.target.closest('#CartDrawer .quantity__input')) return;
      scheduleTransitProtectionSync(1100, { openAfterRefresh: false });
    });
  }

  function removeReactiveAttributes(element) {
    Array.from(element.attributes || []).forEach((attribute) => {
      if (attribute.name.startsWith('x-') || attribute.name.startsWith(':') || attribute.name.startsWith('@')) {
        element.removeAttribute(attribute.name);
      }
    });

    element.querySelectorAll('*').forEach((child) => removeReactiveAttributes(child));
  }

  function getPrescriptionField(propsEl, name) {
    return Array.from(propsEl.querySelectorAll('select[name^="properties["]')).find((field) => field.name === name);
  }

  function getUploadSlot(propsEl) {
    return (propsEl && propsEl.querySelector('[data-city-rx-app-upload-slot].is-open')) || null;
  }

  function getUploadFileItem(propsEl) {
    const uploadSlot = getUploadSlot(propsEl);
    return (uploadSlot && uploadSlot.querySelector('.filepond--item')) || null;
  }

  function isUploadFileComplete(propsEl) {
    const item = getUploadFileItem(propsEl);
    return Boolean(item && item.getAttribute('data-filepond-item-state') === 'processing-complete');
  }

  function clearStaleUploadLiftPropertyValues(propsEl) {
    if (getUploadFileItem(propsEl)) return;
    document.querySelectorAll('input[name^="properties["], textarea[name^="properties["]').forEach((field) => {
      const value = field.value || '';
      if (!field.name.includes('Prescription Upload') || !value.includes('cloudlift.app')) return;
      field.value = '';
      dispatchFieldUpdate(field);
    });
  }

  function getUploadLiftPropertyValue(propsEl) {
    if (!isUploadFileComplete(propsEl)) {
      clearStaleUploadLiftPropertyValues(propsEl);
      return '';
    }

    const fields = document.querySelectorAll(
      'input[name^="properties["], textarea[name^="properties["], select[name^="properties["]'
    );
    const uploadField = Array.from(fields).find((field) => {
      const value = field.value || '';
      return field.name.includes('Prescription Upload') && value.includes('cloudlift.app');
    });

    return uploadField ? uploadField.value : '';
  }

  function hasActiveUploadFile(propsEl) {
    return Boolean(getUploadFileItem(propsEl));
  }

  function dispatchFieldUpdate(field) {
    field.dispatchEvent(new Event('input', { bubbles: true }));
    field.dispatchEvent(new Event('change', { bubbles: true }));
  }

  function dispatchStickyVariantUpdate(field, variantPicker) {
    if (variantPicker) variantPicker.dataset.cityStickySuppressMediaScroll = 'true';
    dispatchFieldUpdate(field);
    if (variantPicker) {
      window.setTimeout(() => {
        delete variantPicker.dataset.cityStickySuppressMediaScroll;
      }, 120);
    }
  }

  function getVariantPicker(mainButton) {
    const section = mainButton.closest('section');
    const form = mainButton.closest('form');
    const formId = form && form.getAttribute('id');
    return (
      (formId && document.querySelector(`variant-selects select[form="${formId}"]`) && document.querySelector(`variant-selects select[form="${formId}"]`).closest('variant-selects')) ||
      (section && section.querySelector('variant-selects')) ||
      document.querySelector('variant-selects')
    );
  }

  function getVariantOptionGroups(variantPicker) {
    if (!variantPicker) return [];
    return Array.from(variantPicker.querySelectorAll('.product-form__input')).filter((group) => {
      if (group.hidden || group.hasAttribute('hidden')) return false;
      if (group.matches('[data-city-sun-custom-tint]')) return false;

      const select = getVariantSourceSelect(group);
      const radios = getVariantSourceRadios(group);
      if (select) return !select.name || !select.name.startsWith('properties[');
      if (!radios.length) return false;

      return radios.some((radio) => radio.name && !radio.name.startsWith('properties['));
    });
  }

  function getVariantSourceSelect(group) {
    return group.querySelector('select[name^="options["], select[form]');
  }

  function getVariantSourceRadios(group) {
    return Array.from(group.querySelectorAll('input[type="radio"]')).filter((radio) =>
      radio.name && !radio.name.startsWith('properties[')
    );
  }

  function getVariantGroupValue(group) {
    const select = getVariantSourceSelect(group);
    if (select) return select.value;
    const checkedRadio = getVariantSourceRadios(group).find((radio) => radio.checked);
    return (checkedRadio && checkedRadio.value) || '';
  }

  function getVariantGroupTitle(group, index) {
    const label = group.querySelector('.form__label');
    const labelText = label ? label.textContent.trim() : `Option ${index + 1}`;
    return labelText.split(':')[0].replace(/\s+/g, ' ').trim();
  }

  function isStickyMobileColourOnly() {
    return true;
  }

  function isColourOptionTitle(title) {
    const normalized = String(title || '').toLowerCase();
    return normalized === 'color' || normalized === 'colour' || normalized === 'frame color' || normalized === 'frame colour';
  }

  function isStandardLensValue(value) {
    return /standard/i.test(String(value || ''));
  }

  function normalizeStickyLensValue(value) {
    if (/custom.*polar/i.test(value || '')) return 'custom-polarised';
    if (/polar/i.test(value || '')) return 'original-polarised';
    return 'standard';
  }

  function isGradientLensValue(value) {
    return /gradient/i.test(String(value || ''));
  }

  function getStickyCustomPolarisedEligibility(variantPicker) {
    if (!variantPicker) return {};
    if (variantPicker._cityStickyCustomPolarisedEligibility) return variantPicker._cityStickyCustomPolarisedEligibility;

    const script = variantPicker.querySelector('[data-city-sun-custom-polarised-eligible-map]');
    if (!script) {
      variantPicker._cityStickyCustomPolarisedEligibility = {};
      return variantPicker._cityStickyCustomPolarisedEligibility;
    }

    try {
      variantPicker._cityStickyCustomPolarisedEligibility = JSON.parse(script.textContent || '{}') || {};
    } catch (error) {
      variantPicker._cityStickyCustomPolarisedEligibility = {};
    }

    return variantPicker._cityStickyCustomPolarisedEligibility;
  }

  function variantOptionValuesFromPicker(variantPicker) {
    return getVariantOptionGroups(variantPicker).map((group) => getVariantGroupValue(group));
  }

  function findStickyColourIndex(variantPicker) {
    return getVariantOptionGroups(variantPicker).findIndex((group, index) =>
      isColourOptionTitle(getVariantGroupTitle(group, index))
    );
  }

  function findStickyLensIndex(variantPicker) {
    return getVariantOptionGroups(variantPicker).findIndex((group, index) =>
      String(getVariantGroupTitle(group, index) || '').toLowerCase().includes('lens')
    );
  }

  function getVariantData(variantPicker, sticky) {
    if (variantPicker) {
      try {
        return (
          (typeof variantPicker.getVariantData === 'function'
            ? variantPicker.getVariantData()
            : JSON.parse((variantPicker.querySelector('[type="application/json"]') && variantPicker.querySelector('[type="application/json"]').textContent) || '[]')) || []
        );
      } catch (error) {
        console.warn('Variant data could not be parsed from picker.', error);
      }
    }

    try {
      const stickyVariants = sticky && sticky.querySelector('[data-city-sticky-variants]');
      return JSON.parse((stickyVariants && stickyVariants.textContent) || '[]');
    } catch (error) {
      console.warn('Sticky variant data could not be parsed.', error);
      return [];
    }
  }

  function getStickyVariantOptions(sticky) {
    return Array.from(sticky.querySelectorAll('[data-city-sticky-option-index]'))
      .sort((a, b) => Number(a.dataset.cityStickyOptionIndex) - Number(b.dataset.cityStickyOptionIndex))
      .map((field) => field.value);
  }

  function findVariantByOptions(variantData, selectedOptions) {
    return variantData.find((variant) =>
      variant.options.every((option, index) => selectedOptions[index] === option)
    );
  }

  function findAvailableVariantByOptions(variantData, selectedOptions) {
    return variantData.find((variant) =>
      variant.available && variant.options.every((option, index) => !selectedOptions[index] || selectedOptions[index] === option)
    );
  }

  function findAvailableStandardVariantForColour(variantData, variantPicker, colourValue) {
    const colourIndex = findStickyColourIndex(variantPicker);
    const lensIndex = findStickyLensIndex(variantPicker);
    if (colourIndex < 0) return null;

    return variantData.find((variant) => {
      if (!variant.available || variant.options[colourIndex] !== colourValue) return false;
      if (lensIndex < 0) return true;
      return isStandardLensValue(variant.options[lensIndex]);
    }) || null;
  }

  function colourHasAvailableStickyVariant(variantData, variantPicker, colourValue) {
    const colourIndex = findStickyColourIndex(variantPicker);
    if (colourIndex < 0) return false;

    return variantData.some((variant) => variant.available && variant.options[colourIndex] === colourValue);
  }

  function findAvailableOriginalPolarisedVariantForColour(variantData, variantPicker, colourValue) {
    const colourIndex = findStickyColourIndex(variantPicker);
    const lensIndex = findStickyLensIndex(variantPicker);
    if (colourIndex < 0 || lensIndex < 0) return null;

    const originalVariants = variantData.filter((variant) =>
      variant.available &&
      variant.options[colourIndex] === colourValue &&
      normalizeStickyLensValue(variant.options[lensIndex]) === 'original-polarised'
    );

    return originalVariants.find((variant) => !isGradientLensValue(variant.options[lensIndex])) || originalVariants[0] || null;
  }

  function findCustomPolarisedBaseVariantForColour(variantData, variantPicker, colourValue) {
    const standardVariant = findAvailableStandardVariantForColour(variantData, variantPicker, colourValue);
    if (!standardVariant) return null;

    const eligibility = getStickyCustomPolarisedEligibility(variantPicker);
    return eligibility[String(standardVariant.id)] ? standardVariant : null;
  }

  function findMobileStickyTargetVariant(variantData, variantPicker, colourValue, currentLensValue) {
    const lensPreference = normalizeStickyLensValue(currentLensValue);

    if (lensPreference === 'custom-polarised') {
      return findCustomPolarisedBaseVariantForColour(variantData, variantPicker, colourValue) ||
        findAvailableOriginalPolarisedVariantForColour(variantData, variantPicker, colourValue) ||
        findAvailableStandardVariantForColour(variantData, variantPicker, colourValue);
    }

    if (lensPreference === 'original-polarised') {
      return findAvailableOriginalPolarisedVariantForColour(variantData, variantPicker, colourValue) ||
        findCustomPolarisedBaseVariantForColour(variantData, variantPicker, colourValue) ||
        findAvailableStandardVariantForColour(variantData, variantPicker, colourValue);
    }

    return findAvailableStandardVariantForColour(variantData, variantPicker, colourValue) ||
      findAvailableOriginalPolarisedVariantForColour(variantData, variantPicker, colourValue);
  }

  function getCurrentVariant(variantPicker, sticky) {
    const stickyOptions = sticky ? getStickyVariantOptions(sticky) : [];
    const variantData = getVariantData(variantPicker, sticky);

    if (stickyOptions.length) {
      const stickyVariant = findVariantByOptions(variantData, stickyOptions);
      if (stickyVariant) return stickyVariant;
    }

    if (!variantPicker) return null;
    const selectedOptions = variantOptionValuesFromPicker(variantPicker);
    return findVariantByOptions(variantData, selectedOptions);
  }

  function setProductVariantId(variant) {
    if (!variant || !variant.id) return;
    document.querySelectorAll('form[data-type="add-to-cart-form"] input[name="id"], product-form form input[name="id"]').forEach((input) => {
      if (String(input.value) === String(variant.id)) return;
      input.value = variant.id;
      dispatchFieldUpdate(input);
    });
  }

  function updateStickyVariantMeta(sticky, variantPicker) {
    const meta = sticky.querySelector('.city-sticky-cart__meta');
    const variant = getCurrentVariant(variantPicker, sticky);
    if (!variant) return;

    updateStickyMobileConfig(sticky, variantPicker, variant);
    if (!meta) return;

    meta.textContent = '';
    if (variant.title && variant.title !== 'Default Title') {
      const internalOption = variantPicker?.querySelector('[data-city-lens-type-option]');
      const displayTitle = internalOption && Array.isArray(variant.options)
        ? variant.options.filter((value, index) => index !== Number(internalOption.dataset.optionIndex)).join(' / ')
        : variant.title;
      const variantLabel = document.createElement('span');
      variantLabel.className = 'city-sticky-cart__variant';
      variantLabel.textContent = displayTitle;
      meta.appendChild(variantLabel);
    }
    const price = document.createElement('div');
    price.className = 'price city-rrp-price city-rrp-price--sticky';
    price.dataset.cityRrpMoneyFormat = sticky.dataset.cityRrpMoneyFormat;
    price.dataset.cityRrpBadgeScheme = sticky.dataset.cityRrpBadgeScheme;
    price.innerHTML = '<div class="price__container"><div class="price__regular city-rrp-price__row"></div></div>';
    updateCityRrpPrice(price, { price: variant.price, compareAtPrice: variant.compare_at_price, available: variant.available });
    meta.appendChild(price);
  }

  function stickyMobileLensLabel(value) {
    const text = String(value || '').trim();
    if (!text || /^default title$/i.test(text)) return '';
    if (/custom\s+polari[sz]ed/i.test(text)) return 'Custom Polarised';
    if (/original.*polari[sz]ed/i.test(text)) return 'Original Polarised';
    if (/^standard$/i.test(text)) return 'Standard';
    return text.replace(/polarized/gi, 'Polarised').replace(/\s+/g, ' ');
  }

  function stickyColourFallback(value) {
    const colour = String(value || '').toLowerCase();
    if (colour.includes('tortoise') || colour.includes('havana')) return 'linear-gradient(135deg,#2f1b12,#9b613a 52%,#25140e)';
    if (colour.includes('clear') || colour.includes('transparent')) return 'rgba(223,232,238,.65)';
    if (colour.includes('white')) return '#f7f7f4';
    if (colour.includes('blue') || colour.includes('navy')) return '#274b78';
    if (colour.includes('green')) return '#45614b';
    if (colour.includes('red') || colour.includes('burgundy')) return '#7e2733';
    if (colour.includes('brown') || colour.includes('sand')) return '#8a684f';
    if (colour.includes('gold')) return '#b89043';
    if (colour.includes('silver') || colour.includes('grey') || colour.includes('gray')) return '#7e8791';
    return '#111827';
  }

  function stickyConfigOptionEverAvailable(descriptor, value, variantData, variantPicker) {
    if (descriptor.type === 'purpose') {
      const source = descriptor.sources.find((item) => item.value === value);
      return Boolean(source && !source.control.disabled);
    }

    if (descriptor.type === 'colour') {
      return colourHasAvailableStickyVariant(variantData, variantPicker, value);
    }

    if (descriptor.type === 'lens') {
      if (normalizeStickyLensValue(value) === 'custom-polarised') {
        const source = descriptor.sources.find((item) => item.value === value);
        const eligibility = getStickyCustomPolarisedEligibility(variantPicker);
        return Boolean(source && !source.control.disabled) || Object.values(eligibility).some(Boolean);
      }
      return variantData.some((item) => item.available && item.options[descriptor.index] === value);
    }

    return false;
  }

  function stickyConfigLensOptionLabel(value) {
    const text = String(value || '').trim();
    if (/custom.*polar/i.test(text)) return 'Custom Polarised Upgrade';
    if (/^standard$/i.test(text)) return 'Standard';
    return text.replace(/polarized/gi, 'Polarised').replace(/\s+/g, ' ');
  }

  function getStickyConfigDescriptors(sticky, variantPicker) {
    const variantData = getVariantData(variantPicker, sticky);
    const descriptors = [];

    getVariantOptionGroups(variantPicker).forEach((group, index) => {
      const title = getVariantGroupTitle(group, index);
      const isColour = isColourOptionTitle(title);
      const isLens = String(title || '').toLowerCase().includes('lens');
      if (!isColour && !isLens) return;

      const select = getVariantSourceSelect(group);
      const radios = getVariantSourceRadios(group);
      const sources = select
        ? Array.from(select.options).map((option) => ({ value: option.value, label: option.textContent.trim(), control: select, option: option }))
        : radios.map((radio) => {
            const sourceLabel = (radio.labels && radio.labels[0] && radio.labels[0].innerText) || '';
            const explicitPrice = sourceLabel.match(/[+−-]\s*\$\s*\d+(?:\.\d{1,2})?/);
            return {
              value: radio.value,
              label: isLens ? stickyConfigLensOptionLabel(radio.value) : radio.value,
              priceDifference: explicitPrice ? explicitPrice[0].replace(/\s+/g, '') : '',
              control: radio,
              option: null,
            };
          });
      const uniqueSources = sources.filter((source, sourceIndex, all) =>
        source.value && all.findIndex((candidate) => candidate.value === source.value) === sourceIndex
      );
      const descriptor = {
        type: isColour ? 'colour' : 'lens',
        title: isColour ? 'Colour' : 'Lens Option',
        index: index,
        group: group,
        sources: uniqueSources,
        value: getVariantGroupValue(group),
      };
      descriptor.sources = uniqueSources.filter((source) =>
        stickyConfigOptionEverAvailable(descriptor, source.value, variantData, variantPicker)
      );
      if (descriptor.sources.length) descriptors.push(descriptor);
    });

    if (sticky.classList.contains('city-sticky-cart--optical')) {
      const purposeRadios = Array.from(document.querySelectorAll('[data-optical-purpose]'));
      if (purposeRadios.length) {
        const purposeSources = purposeRadios.map((radio) => {
          const purpose = radio.dataset.opticalPurpose || radio.value || 'standard';
          const shell = radio.closest('optical-lens-shell');
          const finishGroup = purpose === 'standard' ? null : shell?.querySelector(`[data-optical-finish-group="${purpose}"]`);
          const defaultFinish = finishGroup?.querySelector('[data-optical-upgrade-cents]:checked, [data-optical-upgrade-cents]');
          const upgrade = Number(defaultFinish?.dataset.opticalUpgradeCents || 0);
          return {
            value: purpose,
            label: purpose === 'blue-light' ? 'Blue-light' : purpose === 'sunglasses' ? 'Sunglasses' : 'As shown',
            priceDifference: upgrade > 0 ? `+${money(upgrade)}` : '',
            control: radio,
            option: null,
          };
        });
        const checked = purposeSources.find((source) => source.control.checked) || purposeSources[0];
        descriptors.push({
          type: 'purpose',
          title: 'Lens Option',
          index: -1,
          group: null,
          sources: purposeSources.filter((source) => !source.control.disabled),
          value: checked ? checked.value : '',
        });
      }
    }

    return descriptors;
  }

  function stickyConfigOptionAvailable(descriptor, value, sticky, variantPicker) {
    const variantData = getVariantData(variantPicker, sticky);
    if (descriptor.type === 'purpose') {
      const source = descriptor.sources.find((item) => item.value === value);
      return Boolean(source && !source.control.disabled);
    }
    if (descriptor.type === 'colour') return Boolean(findMobileStickyTargetVariant(
      variantData,
      variantPicker,
      value,
      getVariantOptionGroups(variantPicker)[findStickyLensIndex(variantPicker)]
        ? getVariantGroupValue(getVariantOptionGroups(variantPicker)[findStickyLensIndex(variantPicker)])
        : ''
    ));

    const source = descriptor.sources.find((item) => item.value === value);
    if (!source || source.control.disabled || (source.option && source.option.disabled)) return false;
    if (normalizeStickyLensValue(value) === 'custom-polarised') {
      const colourIndex = findStickyColourIndex(variantPicker);
      const colourValue = colourIndex >= 0 ? variantOptionValuesFromPicker(variantPicker)[colourIndex] : '';
      return Boolean(findCustomPolarisedBaseVariantForColour(variantData, variantPicker, colourValue));
    }
    const selected = variantOptionValuesFromPicker(variantPicker);
    selected[descriptor.index] = value;
    return Boolean(findAvailableVariantByOptions(variantData, selected));
  }

  function stickyConfigTargetVariant(descriptor, value, sticky, variantPicker) {
    const variantData = getVariantData(variantPicker, sticky);
    if (descriptor.type === 'purpose') return getCurrentVariant(variantPicker, sticky);
    if (descriptor.type === 'colour') {
      const lensIndex = findStickyLensIndex(variantPicker);
      const options = variantOptionValuesFromPicker(variantPicker);
      return findMobileStickyTargetVariant(variantData, variantPicker, value, lensIndex >= 0 ? options[lensIndex] : '');
    }
    if (normalizeStickyLensValue(value) === 'custom-polarised') {
      const colourIndex = findStickyColourIndex(variantPicker);
      const options = variantOptionValuesFromPicker(variantPicker);
      return findCustomPolarisedBaseVariantForColour(variantData, variantPicker, colourIndex >= 0 ? options[colourIndex] : '');
    }
    const options = variantOptionValuesFromPicker(variantPicker);
    options[descriptor.index] = value;
    return findAvailableVariantByOptions(variantData, options);
  }

  function stickyConfigPriceDifference(descriptor, value, sticky, variantPicker) {
    const source = descriptor.sources.find((item) => item.value === value);
    if (source && source.priceDifference) return source.priceDifference;
    const current = getCurrentVariant(variantPicker, sticky);
    const target = stickyConfigTargetVariant(descriptor, value, sticky, variantPicker);
    if (!current || !target || target.price === current.price) return '';
    const difference = target.price - current.price;
    return `${difference > 0 ? '+' : '−'}${money(Math.abs(difference))}`;
  }

  function updateStickyMobileConfig(sticky, variantPicker, variant) {
    const row = sticky.querySelector('[data-city-sticky-mobile-config]');
    const text = sticky.querySelector('[data-city-sticky-mobile-config-text]');
    const swatch = sticky.querySelector('[data-city-sticky-mobile-swatch]');
    if (!row || !text) return;

    const groups = getVariantOptionGroups(variantPicker);
    const descriptors = getStickyConfigDescriptors(sticky, variantPicker);
    const variableDescriptors = descriptors.filter((descriptor) => descriptor.sources.length > 1);
    const colourDescriptor = descriptors.find((descriptor) => descriptor.type === 'colour');
    const lensDescriptor = descriptors.find((descriptor) => descriptor.type === 'lens');
    const purposeDescriptor = descriptors.find((descriptor) => descriptor.type === 'purpose');
    const checkedColour = document.querySelector('[data-city-sunglass-selects] [data-city-sun-option-role="color"] input[type="radio"]:checked');
    const checkedLens = document.querySelector('[data-city-sunglass-selects] [data-city-sun-option-role="lens"] input[type="radio"]:checked');
    let colour = checkedColour?.value || colourDescriptor?.value || '';
    const lensParts = [];
    if (checkedLens || lensDescriptor) lensParts.push(stickyMobileLensLabel(checkedLens?.value || lensDescriptor?.value));
    if (purposeDescriptor) {
      const checkedPurpose = purposeDescriptor.sources.find((item) => item.control.checked);
      const source = checkedPurpose || purposeDescriptor.sources.find((item) => item.value === purposeDescriptor.value);
      if (source) lensParts.push(source.label);
    }

    const selectedLens = lensParts.join(' ');
    if (/custom\s+polari[sz]ed/i.test(selectedLens)) {
      const tint = document.querySelector('[data-city-sun-custom-tint-input]:checked');
      if (tint) lensParts.push(String(tint.value || '').replace(/\s+solid\s+tint$/i, '').trim());
    }

    if (sticky.classList.contains('city-sticky-cart--optical')) {
      const selectedPurpose = document.querySelector('[data-optical-purpose]:checked')?.dataset.opticalPurpose || 'standard';
      if (selectedPurpose !== 'standard') {
        const finish = document.querySelector(`[data-optical-finish-group="${selectedPurpose}"]:not([hidden]) input:checked`);
        if (finish?.value) lensParts.push(finish.value);
        const tint = document.querySelector('[data-optical-tint-group]:not([hidden]) [data-optical-tint]:checked');
        if (tint?.value) lensParts.push(tint.value);
      }
    }

    const summaryParts = [colour, ...lensParts].filter((part, index, all) => part && all.indexOf(part) === index);
    text.textContent = summaryParts.join(' · ');
    row.hidden = variableDescriptors.length === 0;
    row.setAttribute('aria-label', `Edit ${text.textContent}`);
    sticky._cityStickyConfigDescriptors = variableDescriptors;

    if (swatch) {
      swatch.hidden = row.hidden || (!colourDescriptor && !checkedColour);
      swatch.style.backgroundImage = '';
      swatch.style.backgroundColor = '';
      swatch.style.setProperty('--city-sticky-swatch', stickyColourFallback(colour));
      const colourGroup = groups.find((group, index) => isColourOptionTitle(getVariantGroupTitle(group, index)));
      const checked = colourGroup && (getVariantSourceRadios(colourGroup).find((radio) => radio.checked) || null);
      const sourceSwatch = checked && document.querySelector(`label[for="${CSS.escape(checked.id)}"] .swatch`);
      if (sourceSwatch) {
        const styles = window.getComputedStyle(sourceSwatch);
        if (styles.backgroundImage && styles.backgroundImage !== 'none') swatch.style.backgroundImage = styles.backgroundImage;
        if (styles.backgroundColor && styles.backgroundColor !== 'rgba(0, 0, 0, 0)') swatch.style.backgroundColor = styles.backgroundColor;
      }
    }
  }

  function syncStickyControlsFromVariantPicker(sticky, variantPicker) {
    const groups = getVariantOptionGroups(variantPicker);
    if (!groups.length) return;

    groups.forEach((group, index) => {
      const stickySelect = sticky.querySelector(`[data-city-sticky-option-index="${index}"]`);
      if (!stickySelect) return;
      stickySelect.value = getVariantGroupValue(group);
    });

    updateStickyVariantMeta(sticky, variantPicker);
  }

  function stickyOptionIsAvailable(variantData, optionIndex, value, selectedOptions) {
    const options = selectedOptions.slice();
    options[optionIndex] = value;
    return Boolean(findAvailableVariantByOptions(variantData, options));
  }

  function syncStickyMobileColourOnly(sticky, variantPicker) {
    const variantData = getVariantData(variantPicker, sticky);
    const colourIndex = findStickyColourIndex(variantPicker);
    const lensIndex = findStickyLensIndex(variantPicker);
    if (colourIndex < 0) return false;

    const colourSelect = sticky.querySelector(`[data-city-sticky-option-index="${colourIndex}"]`);
    if (!colourSelect) return false;

    const currentOptions = variantOptionValuesFromPicker(variantPicker);
    const nextColour = colourSelect.value;
    if (!nextColour || currentOptions[colourIndex] === nextColour) {
      updateStickyVariantMeta(sticky, variantPicker);
      return true;
    }

    const currentLensValue = lensIndex >= 0 ? currentOptions[lensIndex] : '';
    const lensPreference = normalizeStickyLensValue(currentLensValue);
    const originalPolarisedTarget = findAvailableOriginalPolarisedVariantForColour(variantData, variantPicker, nextColour);
    const customPolarisedTarget = findCustomPolarisedBaseVariantForColour(variantData, variantPicker, nextColour);
    const targetVariant = findMobileStickyTargetVariant(variantData, variantPicker, nextColour, currentLensValue);
    if (!targetVariant) return true;
    const shouldKeepCustomPolarised =
      Boolean(customPolarisedTarget) &&
      String(targetVariant.id) === String(customPolarisedTarget.id) &&
      (
        lensPreference === 'custom-polarised' ||
        (lensPreference === 'original-polarised' && !originalPolarisedTarget)
      );

    sticky.dataset.cityStickyInternalSync = 'true';

    getVariantOptionGroups(variantPicker)
      .map((group, index) => ({ group: group, index: index }))
      .sort((a, b) => {
        if (a.index === lensIndex) return -1;
        if (b.index === lensIndex) return 1;
        return a.index - b.index;
      })
      .forEach((entry) => {
      const group = entry.group;
      const index = entry.index;
      var value = targetVariant.options[index];
      if (index === lensIndex && shouldKeepCustomPolarised) value = 'Custom Polarised Upgrade';
      if (!value) return;

      const sourceSelect = getVariantSourceSelect(group);
      if (sourceSelect) {
        if (sourceSelect.value !== value) {
          sourceSelect.value = value;
          dispatchStickyVariantUpdate(sourceSelect, variantPicker);
        }
        return;
      }

      const sourceRadio = getVariantSourceRadios(group).find((radio) => radio.value === value);
      if (sourceRadio && !sourceRadio.checked) {
        sourceRadio.checked = true;
        dispatchStickyVariantUpdate(sourceRadio, variantPicker);
      }
    });

    window.setTimeout(() => {
      delete sticky.dataset.cityStickyInternalSync;
    }, 180);

    setProductVariantId(targetVariant);
    updateStickyVariantMeta(sticky, variantPicker);
    window.setTimeout(() => {
      setProductVariantId(targetVariant);
      updateStickyVariantMeta(sticky, variantPicker);
    }, 120);
    return true;
  }

  function measureStickySelectWidth(field, prefix, select, displayTitle) {
    if (!field || !prefix || !select) return;
    var selected = select.options[select.selectedIndex];
    var text = (selected ? selected.textContent : select.value) || '';
    var measurer = document.createElement('span');
    var selectStyles = window.getComputedStyle(select);
    measurer.style.position = 'absolute';
    measurer.style.visibility = 'hidden';
    measurer.style.whiteSpace = 'nowrap';
    measurer.style.fontFamily = selectStyles.fontFamily;
    measurer.style.fontSize = selectStyles.fontSize;
    measurer.style.fontWeight = selectStyles.fontWeight;
    measurer.textContent = text;
    document.body.appendChild(measurer);

    var prefixWidth = Math.ceil(prefix.getBoundingClientRect().width);
    var textWidth = Math.ceil(measurer.getBoundingClientRect().width);
    document.body.removeChild(measurer);

    var isLens = displayTitle === 'Lens Option';
    var minWidth = isLens ? 170 : 150;
    var maxWidth = isLens ? 310 : 230;
    var chromeSpace = isLens ? 50 : 44;
    var width = Math.max(minWidth, Math.min(maxWidth, prefixWidth + textWidth + chromeSpace));
    field.style.setProperty('--city-sticky-field-width', width + 'px');
  }

  function syncStickyVariantValues(sticky, variantPicker, changedIndex = -1) {
    if (!sticky) return;
    if (isStickyMobileColourOnly() && syncStickyMobileColourOnly(sticky, variantPicker)) return;

    const groups = getVariantOptionGroups(variantPicker);
    const variantData = getVariantData(variantPicker, sticky);
    const stickyOptions = getStickyVariantOptions(sticky);
    const exactVariant = findVariantByOptions(variantData, stickyOptions);

    if (!exactVariant || !exactVariant.available) {
      var relaxedOptions = stickyOptions.map(function (option, index) {
        return index === changedIndex ? option : '';
      });
      var availableVariant = findAvailableVariantByOptions(variantData, relaxedOptions);
      if (!availableVariant) {
        availableVariant = variantData.find(function (variant) { return variant.available; });
      }
      if (availableVariant) {
        sticky.querySelectorAll('[data-city-sticky-option-index]').forEach((field) => {
          const index = Number(field.dataset.cityStickyOptionIndex);
          if (availableVariant.options[index] && field.value !== availableVariant.options[index]) {
            field.value = availableVariant.options[index];
          }
        });
      }
    }

    sticky.querySelectorAll('[data-city-sticky-option-index]').forEach((field) => {
      const group = groups[Number(field.dataset.cityStickyOptionIndex)];
      if (!group) return;

      const sourceSelect = getVariantSourceSelect(group);
      if (sourceSelect) {
        if (sourceSelect.value !== field.value) {
          sourceSelect.value = field.value;
          dispatchStickyVariantUpdate(sourceSelect, variantPicker);
        }
        return;
      }

      const sourceRadio = getVariantSourceRadios(group).find((radio) => radio.value === field.value);
      if (sourceRadio && !sourceRadio.checked) {
        sourceRadio.checked = true;
        dispatchStickyVariantUpdate(sourceRadio, variantPicker);
      }
    });

    setProductVariantId(getCurrentVariant(variantPicker, sticky));
    updateStickyVariantMeta(sticky, variantPicker);
  }

  function buildStickyVariantControls(wrapper, sticky, variantPicker, scheduleSync) {
    const activeIndex = document.activeElement && document.activeElement.dataset.cityStickyOptionIndex;
    wrapper.innerHTML = '';

    function getStickyOptionLabel(title) {
      const normalized = String(title || '').toLowerCase();
      if (isColourOptionTitle(normalized)) return 'Colour';
      if (normalized.includes('lens')) return 'Lens Option';
      return title;
    }

    const mobileColourOnly = isStickyMobileColourOnly();
    const allGroups = getVariantOptionGroups(variantPicker);

    allGroups.forEach((group, index) => {
      const variantData = getVariantData(variantPicker, sticky);
      const sourceSelect = getVariantSourceSelect(group);
      const sourceRadios = getVariantSourceRadios(group);
      const currentValue = getVariantGroupValue(group);
      const groupTitle = getVariantGroupTitle(group, index);
      const displayTitle = getStickyOptionLabel(groupTitle);
      if (mobileColourOnly && displayTitle !== 'Colour') return;

      const field = document.createElement('label');
      field.className = 'city-sticky-cart__variant-field';
      if (displayTitle === 'Colour') field.classList.add('city-sticky-cart__variant-field--colour');
      if (displayTitle === 'Lens Option') field.classList.add('city-sticky-cart__variant-field--lens');

      const label = document.createElement('span');
      label.className = 'visually-hidden';
      label.textContent = groupTitle;

      const prefix = document.createElement('span');
      prefix.className = 'city-sticky-cart__variant-prefix';
      prefix.setAttribute('aria-hidden', 'true');
      prefix.textContent = `${displayTitle}:\u00A0`;

      const select = document.createElement('select');
      select.className = 'city-sticky-cart__variant-select';
      select.dataset.cityStickyOptionIndex = String(index);

      const selectedOptionsForAvailability = allGroups.map((optionGroup) => getVariantGroupValue(optionGroup));

      if (sourceSelect) {
        Array.from(sourceSelect.options).forEach((sourceOption) => {
          if (mobileColourOnly) {
            if (!colourHasAvailableStickyVariant(variantData, variantPicker, sourceOption.value)) return;
          } else if (!stickyOptionIsAvailable(variantData, index, sourceOption.value, selectedOptionsForAvailability)) return;
          const option = document.createElement('option');
          option.value = sourceOption.value;
          option.textContent = sourceOption.textContent;
          option.selected = sourceOption.value === currentValue;
          select.appendChild(option);
        });
      } else {
        sourceRadios.forEach((sourceRadio) => {
          if (mobileColourOnly) {
            if (!colourHasAvailableStickyVariant(variantData, variantPicker, sourceRadio.value)) return;
          } else if (!stickyOptionIsAvailable(variantData, index, sourceRadio.value, selectedOptionsForAvailability)) return;
          const option = document.createElement('option');
          option.value = sourceRadio.value;
          option.textContent = sourceRadio.value;
          option.selected = sourceRadio.value === currentValue;
          select.appendChild(option);
        });
      }

      if (!select.options.length) return;

      select.addEventListener('change', () => {
        syncStickyVariantValues(sticky, variantPicker, index);
        [60, 180, 420].forEach((delay) => setTimeout(scheduleSync, delay));
      });

      field.append(label, prefix, select);
      wrapper.appendChild(field);
      measureStickySelectWidth(field, prefix, select, displayTitle);
    });

    updateStickyVariantMeta(sticky, variantPicker);

    if (activeIndex) {
      const activeField = wrapper.querySelector(`[data-city-sticky-option-index="${activeIndex}"]`);
      if (activeField) activeField.focus({ preventScroll: true });
    }
  }

  function initStickyVariantControls(sticky, mainButton) {
    if (sticky.dataset.cityStickyVariantReady === 'true') return;
    const variantPicker = getVariantPicker(mainButton);
    const groups = getVariantOptionGroups(variantPicker);
    const actions = sticky.querySelector('.city-sticky-cart__actions');
    const submitButton = sticky.querySelector('[data-city-sticky-submit]');
    let wrapper = sticky.querySelector('[data-city-sticky-variant-controls]');
    if (!actions || !submitButton || (!wrapper && !groups.length)) return;

    sticky.dataset.cityStickyVariantReady = 'true';

    if (!wrapper) {
      wrapper = document.createElement('div');
      wrapper.className = 'city-sticky-cart__variant-controls';
      wrapper.dataset.cityStickyVariantControls = 'true';
      actions.insertBefore(wrapper, submitButton);
    }

    let syncTimer = null;
    const scheduleSync = () => {
      clearTimeout(syncTimer);
      syncTimer = setTimeout(() => {
        if (sticky.dataset.cityStickyInternalSync === 'true') {
          syncTimer = setTimeout(scheduleSync, 220);
          return;
        }

        if (groups.length) {
          if (isStickyMobileColourOnly() && wrapper.children.length) {
            syncStickyControlsFromVariantPicker(sticky, variantPicker);
          } else {
            buildStickyVariantControls(wrapper, sticky, variantPicker, scheduleSync);
          }
        } else if (wrapper.dataset.cityStickyLiquidControls === 'true') {
          syncStickyControlsFromVariantPicker(sticky, variantPicker);
        }
        setProductVariantId(getCurrentVariant(variantPicker, sticky));
        updateStickyVariantMeta(sticky, variantPicker);
      }, 30);
    };

    wrapper.dataset.cityStickyLiquidControls = wrapper.children.length ? 'true' : 'false';
    wrapper.addEventListener('change', (event) => {
      const target = event.target.closest('[data-city-sticky-option-index]');
      if (!target) return;
      syncStickyVariantValues(sticky, variantPicker, Number(target.dataset.cityStickyOptionIndex));
      [60, 180, 420].forEach((delay) => setTimeout(scheduleSync, delay));
    });

    if (variantPicker) variantPicker.addEventListener('change', scheduleSync);
    document.addEventListener('variantChange', scheduleSync);
    [0, 120, 450].forEach((delay) => setTimeout(scheduleSync, delay));
  }

  function getStickyPrescriptionState(propsEl) {
    const uploadValue = getUploadLiftPropertyValue(propsEl);
    if (uploadValue) return { state: 'uploaded' };
    if (hasActiveUploadFile(propsEl)) return { state: 'uploading' };
    if (getUploadSlot(propsEl)) return { state: 'upload-empty' };

    const requiredSelects = Array.from(
      propsEl.querySelectorAll('select[name^="properties["][required]:not(:disabled)')
    ).filter((select) => !select.name.includes('Quantity '));
    const blankSelect = requiredSelects.find((select) => !select.value);
    const hasEnteredValue = requiredSelects.some((select) => select.value);

    if (!blankSelect && requiredSelects.length) return { state: 'complete' };
    return { state: hasEnteredValue ? 'incomplete' : 'empty', target: blankSelect };
  }

  function scrollToPrescriptionArea(propsEl, targetField) {
    if (!propsEl) return;
    propsEl.classList.remove('city-sticky-cart__rx-highlight');

    const header = document.querySelector('sticky-header, .section-header, header');
    const headerOffset = header ? Math.ceil(header.getBoundingClientRect().height) : 0;
    const top = propsEl.getBoundingClientRect().top + window.scrollY - headerOffset - 24;
    window.scrollTo({ top: Math.max(top, 0), behavior: 'smooth' });

    window.setTimeout(() => {
      propsEl.classList.add('city-sticky-cart__rx-highlight');
      const focusTarget = targetField || propsEl.querySelector('select[name^="properties["][required]:not(:disabled)');
      if (focusTarget) focusTarget.focus({ preventScroll: true });
    }, 420);
    window.setTimeout(() => propsEl.classList.remove('city-sticky-cart__rx-highlight'), 2200);
  }

  function initStickyPrescriptionControls(sticky, mainForm, mainButton) {
    const propsEl = mainForm && mainForm.querySelector('.js-custom-props');
    if (!propsEl || sticky.dataset.cityStickyPrescriptionReady === 'true') return;

    const actions = sticky.querySelector('.city-sticky-cart__actions');
    const submitButton = sticky.querySelector('[data-city-sticky-submit]');
    if (!actions || !submitButton) return;

    sticky.dataset.cityStickyPrescriptionReady = 'true';
    sticky.classList.add('city-sticky-cart--contact-lens');
    if (!propsEl.id) propsEl.id = 'city-contact-lens-prescription';

    const status = document.createElement('span');
    status.className = 'city-sticky-cart__prescription-status';
    status.hidden = true;

    submitButton.setAttribute('aria-controls', propsEl.id || '');

    let syncTimer = null;
    const scheduleSync = () => {
      clearTimeout(syncTimer);
      syncTimer = setTimeout(() => {
        const rxState = getStickyPrescriptionState(propsEl);
        const isUploaded = rxState.state === 'uploaded';
        const isUploading = rxState.state === 'uploading';
        const isComplete = rxState.state === 'complete' || isUploaded;

        status.hidden = true;
        status.style.display = 'none';
        status.textContent = '';

        if (submitButton) {
          submitButton.hidden = false;
          submitButton.style.display = '';
          submitButton.classList.toggle('is-secondary', !isComplete);
          submitButton.textContent = isUploading ? 'Uploading...' : isComplete ? 'Add to Cart' : 'Complete prescription';
          submitButton.dataset.cityStickyRxMode = isUploading ? 'uploading' : isComplete ? 'complete' : 'incomplete';

          if (isUploading) {
            submitButton.disabled = true;
            submitButton.setAttribute('aria-disabled', 'true');
          } else {
            submitButton.disabled = false;
            submitButton.removeAttribute('aria-disabled');
          }
        }
      }, 20);
    };

    document.addEventListener(
      'change',
      (event) => {
        if (propsEl.contains(event.target)) scheduleSync();
      },
      true
    );
    document.addEventListener(
      'input',
      (event) => {
        if (propsEl.contains(event.target)) scheduleSync();
      },
      true
    );
    propsEl.addEventListener('change', scheduleSync);
    propsEl.addEventListener('input', scheduleSync);

    new MutationObserver(scheduleSync).observe(propsEl, {
      attributes: true,
      attributeFilter: ['disabled', 'required', 'name', 'data-filepond-item-state', 'class', 'data-props', 'data-quantity'],
      childList: true,
      subtree: true,
    });

    const uploadSlot = propsEl.querySelector('[data-city-rx-app-upload-slot]');
    if (uploadSlot) {
      new MutationObserver(scheduleSync).observe(uploadSlot, {
        attributes: true,
        childList: true,
        subtree: true,
      });
    }

    if (submitButton) {
      submitButton.addEventListener(
        'click',
        (event) => {
          const rxState = getStickyPrescriptionState(propsEl);
          if (rxState.state === 'uploading') {
            event.preventDefault();
            event.stopImmediatePropagation();
            return;
          }

          if (rxState.state === 'empty' || rxState.state === 'incomplete' || rxState.state === 'upload-empty') {
            event.preventDefault();
            event.stopImmediatePropagation();
            scrollToPrescriptionArea(propsEl, rxState.target);
          }
        },
        true
      );
    }

    actions.insertBefore(status, submitButton);
    window.setInterval(scheduleSync, 700);
    [0, 150, 500].forEach((delay) => setTimeout(scheduleSync, delay));
  }

  function closeStickyPanels(sticky) {
    sticky.querySelectorAll('.city-sticky-cart__prescription-panel').forEach((panel) => {
      panel.hidden = true;
    });
    sticky.querySelectorAll('.city-sticky-cart__prescription-toggle').forEach((toggle) => {
      toggle.setAttribute('aria-expanded', 'false');
    });
    sticky.classList.remove('has-prescription-open');
  }

  function expandStickyEditTarget(target) {
    if (!target) return;
    let parent = target.parentElement;
    while (parent) {
      if (parent.tagName === 'DETAILS') parent.open = true;
      parent = parent.parentElement;
    }
  }

  function stickyVisibleHeaderBottom() {
    return Array.from(document.querySelectorAll('sticky-header, .section-header, #shopify-section-header, .header-wrapper'))
      .reduce((bottom, header) => {
        const styles = window.getComputedStyle(header);
        const rect = header.getBoundingClientRect();
        if (styles.display === 'none' || styles.visibility === 'hidden' || rect.height < 1 || rect.bottom <= 0) return bottom;
        return Math.max(bottom, Math.min(rect.bottom, window.innerHeight));
      }, 0);
  }

  function scrollToStickyEditTarget(target, sticky) {
    if (!target) return false;
    expandStickyEditTarget(target);
    target.classList.remove('city-sticky-edit-target', 'is-highlighted');
    target.classList.add('city-sticky-edit-target');

    const headerBottom = stickyVisibleHeaderBottom();
    const targetTop = target.getBoundingClientRect().top + window.scrollY;
    const top = Math.max(0, targetTop - headerBottom - 16);
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    window.scrollTo({ top, behavior: reducedMotion ? 'auto' : 'smooth' });

    const arrivalDelay = reducedMotion ? 0 : 420;
    window.setTimeout(() => target.classList.add('is-highlighted'), arrivalDelay);
    window.setTimeout(() => {
      target.classList.remove('is-highlighted');
      window.setTimeout(() => target.classList.remove('city-sticky-edit-target'), 220);
    }, arrivalDelay + 1800);
    return true;
  }

  function stickyMissingConfigurationTarget(sticky) {
    const customTint = document.querySelector('[data-city-sun-custom-tint]:not([hidden])');
    if (customTint && !customTint.querySelector('[data-city-sun-custom-tint-input]:checked')) return customTint;

    if (sticky.classList.contains('city-sticky-cart--optical')) {
      const purpose = document.querySelector('[data-optical-purpose]:checked')?.dataset.opticalPurpose || 'standard';
      if (purpose !== 'standard') {
        const finishGroup = document.querySelector(`[data-optical-finish-group="${purpose}"]:not([hidden])`);
        if (finishGroup && !finishGroup.querySelector('input:checked')) return finishGroup;
        const tintGroup = document.querySelector('[data-optical-tint-group]:not([hidden])');
        if (tintGroup && !tintGroup.querySelector('[data-optical-tint]:checked')) return tintGroup;
      }
    }
    return null;
  }

  function stickyContextualEditTarget(sticky, variantPicker) {
    const variable = getStickyConfigDescriptors(sticky, variantPicker).filter((descriptor) => descriptor.sources.length > 1);
    const colour = variable.find((descriptor) => descriptor.type === 'colour');
    const lens = variable.find((descriptor) => descriptor.type === 'lens');
    const purpose = variable.find((descriptor) => descriptor.type === 'purpose');
    const missing = stickyMissingConfigurationTarget(sticky);
    if (missing) return missing;

    const checkedLens = document.querySelector('[data-city-sunglass-selects] [data-city-sun-option-role="lens"] input[type="radio"]:checked');
    if (lens && normalizeStickyLensValue(checkedLens?.value || lens.value) === 'custom-polarised') {
      return document.querySelector('[data-city-sun-custom-tint]:not([hidden])') || lens.group;
    }

    if (sticky.classList.contains('city-sticky-cart--optical')) {
      if (colour && purpose) return colour.group || document.querySelector('optical-lens-shell');
      if (purpose) return purpose.sources[0]?.control.closest('fieldset') || document.querySelector('optical-lens-shell');
      if (colour) return colour.group;
    }

    if (colour && lens) return document.querySelector('[data-city-sunglass-selects]') || colour.group;
    if (lens) return lens.group;
    if (colour) return colour.group;
    return sticky.classList.contains('city-sticky-cart--optical')
      ? document.querySelector('optical-lens-shell')
      : document.querySelector('[data-city-sunglass-selects]');
  }

  function initStickyMobileConfigScroll(sticky, mainButton) {
    const trigger = sticky.querySelector('[data-city-sticky-mobile-config]');
    if (!trigger) return;
    const scheduleCanonicalRefresh = () => {
      [0, 80, 220, 600, 1200, 2400, 4200].forEach((delay) => window.setTimeout(() => {
        updateStickyVariantMeta(sticky, getVariantPicker(mainButton));
      }, delay));
    };
    trigger.addEventListener('click', () => {
      const target = stickyContextualEditTarget(sticky, getVariantPicker(mainButton));
      scrollToStickyEditTarget(target, sticky);
    });

    const picker = getVariantPicker(mainButton);
    const refreshCanonicalNow = () => {
      updateStickyVariantMeta(sticky, getVariantPicker(mainButton));
      window.requestAnimationFrame(() => updateStickyVariantMeta(sticky, getVariantPicker(mainButton)));
    };
    picker?.addEventListener('click', scheduleCanonicalRefresh, true);
    picker?.addEventListener('change', refreshCanonicalNow, true);
    const opticalShell = document.querySelector('optical-lens-shell');
    opticalShell?.addEventListener('click', scheduleCanonicalRefresh, true);
    opticalShell?.addEventListener('change', scheduleCanonicalRefresh, true);

    const mainForm = mainButton.closest('form');
    if (mainForm) {
      new MutationObserver(refreshCanonicalNow).observe(mainForm, {
        attributes: true,
        attributeFilter: [
          'data-city-custom-polarised-selected',
          'data-city-custom-polarised-active',
          'data-city-custom-polarised-colour'
        ]
      });
    }

  }

  function initStickyCart() {
    const sticky = document.querySelector('[data-city-sticky-cart]');
    const mainButton = document.querySelector('.product-form__submit[name="add"]');
    if (!sticky || !mainButton) return;

    if (
      document.querySelector('.product--contact-lens') ||
      document.querySelector('.contact-lens-product-fit') ||
      document.querySelector('.contact-lens-prescription-guide')
    ) {
      sticky.classList.add('city-sticky-cart--contact-lens');
    }

    if (sticky.parentElement !== document.body) {
      document.body.appendChild(sticky);
    }

    const stickyButton = sticky.querySelector('[data-city-sticky-submit]');
    const collapseButton = sticky.querySelector('[data-city-sticky-collapse]');
    const mobileConfigButton = sticky.querySelector('[data-city-sticky-mobile-config]');
    const stickyHiddenStorageKey = `cityStickyHidden:${window.location.pathname}`;
    const getStoredHiddenState = () => {
      try {
        return window.sessionStorage.getItem(stickyHiddenStorageKey) === 'true';
      } catch (error) {
        return false;
      }
    };
    const storeHiddenState = (nextValue) => {
      try {
        if (nextValue) {
          window.sessionStorage.setItem(stickyHiddenStorageKey, 'true');
        } else {
          window.sessionStorage.removeItem(stickyHiddenStorageKey);
        }
      } catch (error) {
        return;
      }
    };
    if (stickyButton) {
      stickyButton.addEventListener('click', () => {
        if (stickyButton.disabled) return;
        const missingTarget = stickyMissingConfigurationTarget(sticky);
        if (missingTarget) {
          scrollToStickyEditTarget(missingTarget, sticky);
          return;
        }
        const mainForm = mainButton.closest('form');
        const variantPicker = getVariantPicker(mainButton);
        syncStickyVariantValues(sticky, variantPicker);
        if (sticky.classList.contains('city-sticky-cart--optical')) {
          const selectedPurpose = document.querySelector('[data-optical-purpose]:checked')?.dataset.opticalPurpose || 'standard';
          const detail = {
            source: 'sticky',
            pathway: selectedPurpose,
            variant_id: Number(mainForm?.querySelector('input[name="id"]')?.value || 0)
          };
          document.dispatchEvent(new CustomEvent('city:optical-purchase-action', {
            detail: { action: 'optical_non_prescription_purchase_clicked', ...detail }
          }));
          const privacy = window.Shopify?.customerPrivacy;
          let analyticsAllowed = false;
          try {
            analyticsAllowed = typeof privacy?.analyticsProcessingAllowed === 'function' && privacy.analyticsProcessingAllowed() === true;
          } catch (error) {
            analyticsAllowed = false;
          }
          if (analyticsAllowed && Array.isArray(window.dataLayer)) {
            window.dataLayer.push({ event: 'optical_non_prescription_purchase_clicked', ...detail });
          }
        }
        mainButton.click();
      });
    }

    initStickyVariantControls(sticky, mainButton);
    initStickyMobileConfigScroll(sticky, mainButton);
    initStickyPrescriptionControls(sticky, mainButton.closest('form'), mainButton);

    document.addEventListener('change', (event) => {
      if (!event.target.closest('[data-optical-purpose], [data-optical-finish-group], [data-city-sunglass-selects]')) return;
      window.setTimeout(() => updateStickyVariantMeta(sticky, getVariantPicker(mainButton)), 0);
    }, true);

    let visibilityFrame = null;
    let isStickyVisible = false;
    let isHiddenByUser = getStoredHiddenState();
    let initialStickyGuardTimer = null;
    let initialStickyGuardReleased = false;
    const mobileFloatingOffsetAttr = 'data-city-sticky-mobile-offset';
    const mobileFloatingBottomAttr = 'data-city-sticky-mobile-bottom';
    const mobileFloatingInsetAttr = 'data-city-sticky-mobile-inset';

    const resetMobileFloatingWidgets = () => {
      document.querySelectorAll(`[${mobileFloatingOffsetAttr}]`).forEach((element) => {
        const previousBottom = element.getAttribute(mobileFloatingBottomAttr);
        const previousInset = element.getAttribute(mobileFloatingInsetAttr);
        element.style.removeProperty('bottom');
        element.style.removeProperty('inset-block-end');
        if (previousBottom && previousBottom !== '__empty__') element.style.setProperty('bottom', previousBottom);
        if (previousInset && previousInset !== '__empty__') element.style.setProperty('inset-block-end', previousInset);
        element.removeAttribute(mobileFloatingOffsetAttr);
        element.removeAttribute(mobileFloatingBottomAttr);
        element.removeAttribute(mobileFloatingInsetAttr);
      });
    };

    const syncMobileFloatingWidgets = () => {
      resetMobileFloatingWidgets();
      if (!window.matchMedia || !window.matchMedia('(max-width: 749px)').matches) return;
      if (!sticky.classList.contains('city-sticky-cart--contact-lens')
        && !sticky.classList.contains('city-sticky-cart--eyewear')) return;
      if (!isStickyVisible || isHiddenByUser) return;
      if (sticky.classList.contains('is-purchase-modal-open')) return;

      const panel = sticky.querySelector('[data-city-sticky-panel]');
      const panelRect = panel && panel.getBoundingClientRect();
      if (!panelRect || panelRect.height < 1) return;

      const offset = Math.max(96, Math.ceil(window.innerHeight - panelRect.top + 18));
      const selectors = [
        '#ShopifyChat',
        '#shopify-chat',
        '#shopify-chat-button',
        '.shopify-chat',
        '.shopify-chat-button',
        '[id*="shopify-chat" i]',
        '[id*="store-assistant" i]',
        '[class*="shopify-chat" i]',
        '[class*="store-assistant" i]',
        '[aria-label*="chat" i]',
        '[aria-label*="assistant" i]',
        'iframe[id*="chat" i]',
        'iframe[src*="chat" i]',
        'iframe[src*="inbox" i]',
        'iframe[title*="chat" i]',
        'iframe[title*="assistant" i]',
      ];

      document.querySelectorAll(selectors.join(',')).forEach((element) => {
        if (!element || sticky.contains(element)) return;
        if (element.closest('.city-cart-drawer, .drawer, cart-drawer')) return;

        const rect = element.getBoundingClientRect();
        if (rect.width < 28 || rect.height < 28) return;
        if (rect.right < window.innerWidth * 0.55) return;
        if (rect.bottom < panelRect.top - 20) return;

        const computed = window.getComputedStyle(element);
        if (computed.display === 'none' || computed.visibility === 'hidden') return;

        element.setAttribute(mobileFloatingOffsetAttr, 'true');
        element.setAttribute(mobileFloatingBottomAttr, element.style.bottom || '__empty__');
        element.setAttribute(mobileFloatingInsetAttr, element.style.insetBlockEnd || '__empty__');
        element.style.setProperty('bottom', `${offset}px`, 'important');
        element.style.setProperty('inset-block-end', `${offset}px`, 'important');
      });
    };

    const syncStickyState = () => {
      const purchaseModalOpen = document.documentElement.classList.contains('optical-rx-open')
        || document.body.classList.contains('rx-dialog-open');
      sticky.classList.toggle('is-visible', isStickyVisible);
      sticky.classList.toggle('is-hidden-by-user', isHiddenByUser);
      sticky.classList.toggle('is-purchase-modal-open', purchaseModalOpen);

      if (collapseButton) {
        const canToggle = isStickyVisible && !purchaseModalOpen;
        const toggleLabel = isHiddenByUser ? 'Show sticky purchase bar' : 'Hide sticky purchase bar';
        collapseButton.tabIndex = canToggle ? 0 : -1;
        collapseButton.setAttribute('aria-expanded', isHiddenByUser ? 'false' : 'true');
        collapseButton.setAttribute('aria-label', toggleLabel);
        collapseButton.setAttribute('title', toggleLabel);
        const hiddenLabel = collapseButton.querySelector('.visually-hidden');
        if (hiddenLabel) hiddenLabel.textContent = toggleLabel;
      }

      if (!isStickyVisible || isHiddenByUser || purchaseModalOpen) closeStickyPanels(sticky);
      syncMobileFloatingWidgets();
    };

    const purchaseModalObserver = new MutationObserver(syncStickyState);
    purchaseModalObserver.observe(document.documentElement, { attributes: true, attributeFilter: ['class'] });
    purchaseModalObserver.observe(document.body, { attributes: true, attributeFilter: ['class'] });

    const setHiddenByUser = (nextValue) => {
      isHiddenByUser = nextValue;
      storeHiddenState(nextValue);
      syncStickyState();
    };

    if (collapseButton) {
      collapseButton.addEventListener('click', () => {
        setHiddenByUser(!isHiddenByUser);
      });
    }

    const updateStickyVisibility = () => {
      updateStickyVariantMeta(sticky, getVariantPicker(mainButton));
      const rect = mainButton.getBoundingClientRect();
      isStickyVisible = rect.bottom < 0;
      syncStickyState();
    };

    const scheduleStickyVisibility = () => {
      if (visibilityFrame) return;
      visibilityFrame = window.requestAnimationFrame(() => {
        visibilityFrame = null;
        updateStickyVisibility();
      });
    };

    const releaseInitialStickyGuard = () => {
      if (initialStickyGuardReleased) return;
      initialStickyGuardReleased = true;
      if (initialStickyGuardTimer) window.clearTimeout(initialStickyGuardTimer);
      updateStickyVisibility();
      sticky.classList.remove('is-initializing');
      syncStickyState();
      sticky.style.removeProperty('opacity');
      sticky.style.removeProperty('visibility');
    };

    const scheduleInitialStickyGuardRelease = () => {
      if (!sticky.classList.contains('is-initializing')) return;
      initialStickyGuardTimer = window.setTimeout(releaseInitialStickyGuard, 650);
      if (document.readyState === 'complete') {
        window.setTimeout(releaseInitialStickyGuard, 160);
      } else {
        window.addEventListener('load', () => window.setTimeout(releaseInitialStickyGuard, 160), { once: true });
      }
    };

    window.addEventListener('scroll', scheduleStickyVisibility, { passive: true });
    window.addEventListener('resize', scheduleStickyVisibility);
    syncStickyState();
    scheduleStickyVisibility();
    scheduleInitialStickyGuardRelease();
    [300, 900, 1800, 3000].forEach((delay) => window.setTimeout(scheduleStickyVisibility, delay));
  }

  let cityCartDrawerInitialized = false;

  function initCityCartDrawer() {
    if (cityCartDrawerInitialized) return;
    cityCartDrawerInitialized = true;

    const debugMarker = document.querySelector('[data-city-cart-debug-marker]');
    if (debugMarker) debugMarker.textContent = 'drawer v4 js';

    initCartUpdateSync();
    initSharedCartDisplaySync();
    initCartEnhancements(null, { deferCartState: true });
    initDelegatedCartActions();
    initProductCartEdit();
    initStickyCart();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCityCartDrawer, { once: true });
  } else {
    initCityCartDrawer();
  }

  window.addEventListener('pageshow', (event) => {
    const navigationEntries = window.performance && typeof window.performance.getEntriesByType === 'function'
      ? window.performance.getEntriesByType('navigation')
      : [];
    const navigationEntry = navigationEntries && navigationEntries[0];
    const restoredFromHistory = event.persisted || (navigationEntry && navigationEntry.type === 'back_forward');
    if (!restoredFromHistory) return;

    fetchCartState()
      .then((cartState) => refreshCartDrawer(false, getVisibleCartItemCount(cartState)))
      .catch(() => refreshCartDrawer(false, 0));
  });

  document.addEventListener('cart:updated', () => {
    resetExpiryTimer();
    refreshCartDrawer(true, 1);
  });

  window.CityCartEdit = {
    getKey: getCartEditKey,
    getPayload: getCartEditPayload,
    getToken: getCartEditToken,
    removeEditedCartLine,
    clear: clearCartEditState,
    initEnhancements: initCartEnhancements,
    syncTransitProtection: () => fetchCartState().then((cartState) => syncTransitProtectionQuantity(cartState, { openAfterRefresh: false })),
    syncTransitProtectionBeforeCartRender,
    syncCartState: syncCartEmptyState,
    refreshCartDrawer,
  };
})();
